import React, { Component } from 'react';
import { connect } from 'react-redux';
import { errorValidataion } from '../../State/actions/sessions';
import Box from 'grommet/components/Box';
import Heading from 'grommet/components/Heading';
import Paragraph from 'grommet/components/Paragraph';
import FormField from 'grommet/components/FormField';
import TextInput from 'grommet/components/TextInput';
import Select from 'grommet/components/Select';
import Label from 'grommet/components/Label';
import TableRow from 'grommet/components/TableRow';
import TrashIcon from 'grommet/components/icons/base/Trash';
import CircleInformation from 'grommet/components/icons/base/CircleInformation';
import Layer from 'grommet/components/Layer';
import CloseIcon from 'grommet/components/icons/base/FormClose';
import 'core-js/es7/array';
import 'core-js/es7/object';
import Spinning from 'grommet/components/icons/Spinning';
import ReactTooltip from 'react-tooltip';
import { fetchServerList, fetchNodeQty, getARCValue, getosdisklist, recallAnalyticsandDatabasenodeQty } from '../Redux/actions/epaActions';
import { toggleSizeButton } from '../../State/actions/sessions';
import EPAvNextInputs from '../../Datafiles/EPAvNextInput.json';
import {updateGrowthItem, serverChangeCompatibilityCheck} from '../commonLogic';
import DataDrive from './DataDrive.js';
import * as Constants from '../Redux/action_types/EPAConstants.js';
//import dataDriveOptions from '../../Datafiles/DataDrive.js';
let diskcapacityvalue = "", capacitytypevalue = "", ensurecodngdata = "", ensurecodngparity = "", overhead = "", compression = "", strgwrkload = "";
let replicationvalue = "";

//HardWare Selection variables
let procQuantity;
let serverValue, processorValue, memoryValue, pocQtyValue, noOfDiskValue, noOfOSDiskValue, datadisktypValue, osdisktypValue, nodesQtyValue;
let processorTypeValue;
let nodeValue;
let procValue;
//Sizer recommendation variables
let SizerRecmdtnProcsr, SizerRecmdtnServer, SizerRecmdtnDisktype, SizerRecmdtnMemory;

//Scality
let GreenLakevalue, GreenLakeoptions, Sitesvalue, Secondsitevalue, Secondsiteoptions, ARCvalue, Scalitydiskcapacityvalue, NetworkSwitchvalue, NetworkSwitchoptions, Quantityvalue, Quantityoptions;

let MessagesPerSec, Sitesvalueoptions;

let GPUQty, ImagesPerSec;
let EventsPerSec;
let AIConfigtypevalue = "";
let GPUvalue = "";
let GPUsOptions = [];
let Analyticsvalue, Ansdiskcapacityvalue, ContainersQty, CoresPerContainer, MemoryPerContainer, NodelocalStorageValue, StorageNodesQty, Storagevalue, StorageOptions;
let Storagevalue1, Storagevalue1disabled, Storagevalue2, Storagevalue2disabled;
let StoragePerc;
let QueryData, ResponseTime, ConcurrentQueries;
//let DatabaseUsablecapacity;
var Servers = [];
var Drives = [];
var MemoryList = [];
var OSDiskList = [];
var ProcList = [];
var ProcFamilyList = [];
let StroageNodeQtyCall = false;
let AnalyticsandDatabaseNodeQtyCall = false;
let forRawdisabled = false;
let defaultNodevalue = '';
let defaultNodevalueChange = true;
let DriveClassChanged = false;
let IDatadiskqtynotchange = false;
let IOSDatadiskqtynotchange = true;
let maxlayer = false;
let maxlayerSecondServices = false;
let maxlayerthirdServices = false;
let maxlayerFourthServices = false;
let MaxDriveQty = '';
let maxDrivesSupported = '';
let EducationCustomeroptions, Addserversoptions, SKUInformationList;
let DIMMCapacity, DATADriveCapacity, DATADrivePerServer, SpareServers, NumServers;
let DatabaseDatadiskChange = false;
let DataDiskQtyChange = false;
let ProcorDiskValue = null;
let FirstServer = true;
let recommDrive = true;
var recommOSDisk = true;
var recommProc = true;
// let ProcessorChanged=false;
// let DataDiskChanged=false;
//Weka
let Addservers, SKUInformationValue, OSEnvironment, SupportYearCount, EducationCustomer, NetworkType, capacityrequired, ServerType, DriveClassValue;
let Peakreadiops, Peakwriteiops, Totalusablestorage, Peakreadbandwdth, Peakwritebandwdth, NetworkTypeoptions, SupportYearCountoptions, OSEnvironmentoptions;
let DATADrivePerServeroptions, SpareServersoptions, DIMMCapacityoptions;
let DATADriveCapacityoptions = [];
let DriveClassList = [];
let SparkSynergyServerChanged = false;
let KafkaSynergyServerChanged = false;
let FlinkSynergyServerChanged = false;
let StormSynergyServerChanged = false;
let YarnSynergyServerChanged = false;
let HiveSynergyServerChanged = false;
let CassandraSynergyServerChanged = false;
let ImpalaSynergyServerChanged = false;
let HBaseSynergyServerChanged = false;
let SynergyServerChanged = false;
let SparkAnalyticsSynergyServerChanged = false;
let ShowHiveLayer = false;
var HDFS_Change = ""
var Scality_Change = ""
var Weka_Change = ""
var Hive_Change = ""
var Cassandra_change = ""
var Impala_Change = ""
var HBase_Change = ""
var SparkStreaming_Change = ""
var Kafka_Change = ""
var Flink_Change = ""
var Storm_Change = ""
var Yarn_Change = ""
var Spark_Change = ""
var TensorFlow_Change = ""
var Py_Torch_Change = ""
var MiNifi_Change = ""
var noteTextOnChangeOfConfiguration = ""
let noteTextOnChangeOfConfigurationScality = " "
let noteTextOnChangeOfConfigurationPyTorch = ""
let noteTextOnChangeOfConfigurationWeka = ""
let noteTextOnChangeOfConfigurationHive = ""
let noteTextOnChangeOfConfigurationCassandra = ""
let noteTextOnChangeOfConfigurationImpala = ""
let noteTextOnChangeOfConfigurationHBase = ""
let noteTextOnChangeOfConfigurationSparkStreaming = ""
let noteTextOnChangeOfConfigurationKafka = ""
let noteTextOnChangeOfConfigurationFlink = ""
let noteTextOnChangeOfConfigurationStorm = ""
let noteTextOnChangeOfConfigurationYarn = ""
let noteTextOnChangeOfConfigurationSpark = ""
let noteTextOnChangeOfConfigurationTensorflow = ""
let noteTextOnChangeOfConfigurationMiNifi = ""
let OPSminvalue = ''
let editExisting = false;
let isMixedStorageConfiguration = ""
let serverChangeConfirmationlayer = ""
let validCombination = true
let proLiantDL360Gen10 = "ProLiant DL360 Gen10";
let training = "Training";
const INFERENCE = "Inference";
const CASCADELAKE = "Cascade Lake";
const AI = "AI";
const NA_ = "NA";
let onChangeTriggered = false;

class Serverconfig extends Component {
  constructor() {
    super();

    this.state = {
      Node: "",
      NodeQtyvisible: true,
      HiveServerList: [],
      capacitytypevalueoptions: ['Raw', 'Usable capacity '],
      Serverchange: false,
      dataDriveType : "",
      dataDriveConsolidatedOptions : [],
      enableADDButton : true,
      valueChanged : false,
      changeDriveTypeOptions : false
    }
    this.onServerChange = this.onServerChange.bind(this);
    this.onOSDiskChange = this.onOSDiskChange.bind(this);
    this.onProcessorChange = this.onProcessorChange.bind(this);
    this.onDataDiskChange = this.onDataDiskChange.bind(this);
    this.onProcQtyChange = this.onProcQtyChange.bind(this);
    this.onMemoryChange = this.onMemoryChange.bind(this);
    this.onNoOfDisksChange = this.onNoOfDisksChange.bind(this);
    this.onNodevalueChange = this.onNodevalueChange.bind(this);
    this.onContainersQtyChange = this.onContainersQtyChange.bind(this)
    this.onCoresPerContainerChange = this.onCoresPerContainerChange.bind(this)
    this.onMemoryPerContainerChange = this.onMemoryPerContainerChange.bind(this)
    this.onNodelocalStorageValueChange = this.onNodelocalStorageValueChange.bind(this)
    this.onAnsdiskcapacityvalue = this.onAnsdiskcapacityvalue.bind(this)
    this.onStorageNodesQtyChange = this.onStorageNodesQtyChange.bind(this)
    this.onStorageOptionsChange = this.onStorageOptionsChange.bind(this)
    this.onStoragevalueCahnge = this.onStoragevalueCahnge.bind(this)
    this.oncapacitytypevalueChange = this.oncapacitytypevalueChange.bind(this)
    this.textOnConfigurationChange = this.textOnConfigurationChange.bind(this);
    this.ChangedValue = this.ChangedValue.bind(this);
    this.onEnsuredataBlur = this.onEnsuredataBlur.bind(this)
    this.onEnsureParityBlur = this.onEnsureParityBlur.bind(this)
    this.onReplicationBlur = this.onReplicationBlur.bind(this)
    this.resetChangesToEmpty = this.resetChangesToEmpty.bind(this)
    this.onWorkloadUpdate = this.onWorkloadUpdate.bind(this);
    this.layerclose = this.layerclose.bind(this);
    this.noteTextOnChangeOfConfiguration = this.noteTextOnChangeOfConfiguration.bind(this);
    this.noteContent = this.noteContent.bind(this);
    this.NodeQtycahnge = this.NodeQtycahnge.bind(this);
    this.onDiskCapacityChange = this.onDiskCapacityChange.bind(this);
    this.onReplicationCahnge = this.onReplicationCahnge.bind(this);
    this.onEnsuredataCahnge = this.onEnsuredataCahnge.bind(this);
    this.onEnsureParityCahnge = this.onEnsureParityCahnge.bind(this);
    this.ContainerdisplayChange = this.ContainerdisplayChange.bind(this);
    this.maxDriveCountValidation = this.maxDriveCountValidation.bind(this);

  }

  onDatadriveTypeChange = (e) => {
    this.resetChangesToEmpty()
    if( Array.isArray(this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service)) {
      this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.filter(x=>x["@Type"] === this.props.title)[0].Hardware["@dataDriveType"] = e.option
    } else {
      this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.Hardware["@dataDriveType"] = e.option;
    }
    this.state.dataDriveType = e.option;
    this.populateDataDriveoptions()
    if (Drives.indexOf(datadisktypValue) === -1) {
      datadisktypValue = Drives[0];
      if( Array.isArray(this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service)) {
        this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.filter(x=>x["@Type"] === this.props.title)[0].Hardware["@DataDisk"] = datadisktypValue;
      } else {
        this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.Hardware["@DataDisk"] = datadisktypValue;
      }
    }
    StroageNodeQtyCall = true;
    this.updateDriveQuantity();
    this.onWorkloadUpdate(this.props.type, this.props.title, "noOfDiskValue");
    this.setState({});
  }
  updateDriveQuantity = () => {
    noOfDiskValue = this.noOfDrivesleft("").toString()
      if( Array.isArray(this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service)) {
        this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.filter(x=>x["@Type"] === this.props.title)[0].Hardware["@DiskQty"] = noOfDiskValue;
      } else {
        this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.Hardware["@DiskQty"] = noOfDiskValue;
      }
  }

  componentWillMount() {
    if( this.props.workload !== undefined) {
      if (Array.isArray(this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service)) {
        if(!(Array.isArray(this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.filter(x=>x["@Type"] === this.props.title)[0].DataDisks))) {
          this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.filter(x=>x["@Type"] === this.props.title)[0]["@mixedStorage"] = "False"
        }
      } else {
        if(!(Array.isArray(this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.DataDisks))) {
          this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service["@mixedStorage"] = "False"
        }
      }
    }
  }
  componentWillUnmount() {
    let Hardware = "";
    let diskNumber = "";
    let MixedStorageConfiguration = "";
    if( Array.isArray(this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service)) {
      Hardware = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.filter(x=>x["@Type"] === this.props.title)[0].Hardware
      diskNumber = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.filter(x=>x["@Type"] === this.props.title)[0].DataDisks.length
      MixedStorageConfiguration = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.filter(x=>x["@Type"] === this.props.title)[0]["@mixedStorage"]
    } else {
      Hardware = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.Hardware
      diskNumber = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.DataDisks.length
      MixedStorageConfiguration = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service["@mixedStorage"]
    }
    if( MixedStorageConfiguration==="False") {
      let newDrive = { Item : {
        "@disk" : Hardware["@DataDisk"],
        "@qty": Hardware["@DiskQty"],
        "@volumeName": "Data_0"
      } }
      if( Array.isArray(this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service)) {
        this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.filter(x=>x["@Type"] === this.props.title)[0].DataDisks = []
        this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.filter(x=>x["@Type"] === this.props.title)[0].DataDisks.push(newDrive);
      } else {
        this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.DataDisks = []
        this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.DataDisks.push(newDrive);
      }
    }
  }

  renderTable = () => {
    let tableData = [];
    let tableDataArray = ""
    if( Array.isArray(this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service)) {
      tableDataArray = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.filter(x=>x["@Type"] === this.props.title)[0].DataDisks
    } else {
      tableDataArray = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.DataDisks
    }
    if(Array.isArray(tableDataArray)) {
    tableDataArray.map(((dataDrive, id)=>{
      tableData.push(
          <TableRow>
            <td>{dataDrive.Item["@disk"]}</td>
            <td><TextInput value={dataDrive.Item["@qty"]} onDOMChange={(e)=>this.onNoOfDisksChange(e, this.props.type, this.props.title, "Change", true, id)} onBlur={(e)=>this.onNoOfDisksChange(e, this.props.type, this.props.title, "Blur", true, id)}/></td>
            <td><TrashIcon  primary={true} onClick={()=>this.deleteDrive(id)}/></td>
          </TableRow>
      )
    })) }
    return tableData; 
  }

  onAddingDataDisk = () => {
    if (noOfDiskValue != "0" && datadisktypValue !== undefined ) {
      let existingDrivesArray = []
      validCombination = true;
      if (serverValue === Constants.HPE_APOLLO_4200_GEN10 && (datadisktypValue.toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[0]) !== -1 || datadisktypValue.toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[1]) > -1)) {
        if( Array.isArray(this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service)) {
          isMixedStorageConfiguration = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.filter(x=>x["@Type"] === this.props.title)[0]["@mixedStorage"]
          existingDrivesArray = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.filter(x=>x["@Type"] === this.props.title)[0].DataDisks
        } else {
          isMixedStorageConfiguration = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service["@mixedStorage"]
          existingDrivesArray = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.DataDisks
        }
        if(isMixedStorageConfiguration === "True") {
          let nonNVMeDrives = 0
          let NVMeDrives = 0
          let SFFDrives = 0
          existingDrivesArray.map(x=>{
            if(x.Item["@disk"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[1]) === -1 && x.Item["@disk"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[0]) === -1) {
              nonNVMeDrives += parseInt(x.Item["@qty"], 10)
            } else if(x.Item["@disk"].indexOf('NVMe') !== -1) {
              NVMeDrives += parseInt(x.Item["@qty"], 10);
            } else {
              SFFDrives += parseInt(x.Item["@qty"], 10);
            }
          })
          if( datadisktypValue.indexOf("NVMe") !== -1 && SFFDrives > 0) {
            validCombination = false
          } else if(datadisktypValue.indexOf("NVMe") === -1 && NVMeDrives > 0){
            validCombination = false
          }
          if (osdisktypValue.indexOf("M.2") !== -1) {
            if (nonNVMeDrives > 24) {
              validCombination = false
            }
          } else {
            if (nonNVMeDrives > 22) {
              validCombination = false
            }
          }
          if (!validCombination) {
            let text = "Drive cannot be added as the maximum drives exceeded." 
            this.serverChangeConfirmationlayerRoutine(text);
          }
        }
      }

      if (validCombination) {
        let Hardware = "";
        let diskNumber = "";
        this.maxDriveCountValidation()
        if (!maxlayer && !maxlayerSecondServices && !maxlayerthirdServices && !maxlayerFourthServices) {
        if( Array.isArray(this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service)) {
          Hardware = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.filter(x=>x["@Type"] === this.props.title)[0].Hardware;
          isMixedStorageConfiguration = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.filter(x=>x["@Type"] === this.props.title)[0]["@mixedStorage"];
          if( isMixedStorageConfiguration !== "True") {
            this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.filter(x=>x["@Type"] === this.props.title)[0].DataDisks = [];
            diskNumber = 0;
          }
          isMixedStorageConfiguration = "True";
          this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.filter(x=>x["@Type"] === this.props.title)[0]["@mixedStorage"] = "True";
          existingDrivesArray = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.filter(x=>x["@Type"] === this.props.title)[0].DataDisks;
          diskNumber = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.filter(x=>x["@Type"] === this.props.title)[0].DataDisks.length;
        } else {
          Hardware = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.Hardware;
          isMixedStorageConfiguration = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service["@mixedStorage"];
          if (isMixedStorageConfiguration !== "True") {
            this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.DataDisks = [];
            diskNumber = 0;
          }
          isMixedStorageConfiguration = "True";
          this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service["@mixedStorage"] = "True";
          existingDrivesArray = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.DataDisks;
          diskNumber = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.DataDisks.length;
        }

          let pushDrive = true;
          if (diskNumber > 0 ) {
            existingDrivesArray.map(x => {
              if (x.Item["@disk"] === datadisktypValue) {
                x.Item["@qty"] = (parseInt(x.Item["@qty"], 10) + parseInt(noOfDiskValue, 10)).toString();
                pushDrive = false
              }
            })
          } 
          if (pushDrive) {
            let newDrive = {
              Item: {
                "@disk": Hardware["@DataDisk"],
                "@qty": Hardware["@DiskQty"],
                "@volumeName": "Data_" + diskNumber
              }
            }
            if (Array.isArray(this.props.workload.UserInputs.Environments.Functions.Function.filter(x => x["@Type"] === this.props.type)[0].Service)) {
              this.props.workload.UserInputs.Environments.Functions.Function.filter(x => x["@Type"] === this.props.type)[0].Service.filter(x => x["@Type"] === this.props.title)[0].DataDisks.push(newDrive);
            } else {
              this.props.workload.UserInputs.Environments.Functions.Function.filter(x => x["@Type"] === this.props.type)[0].Service.DataDisks.push(newDrive);
            }
          }
          this.state.changeDriveTypeOptions = true
          this.populateDataDriveoptions();
          StroageNodeQtyCall = true;
          this.onWorkloadUpdate(this.props.type, this.props.title, "noOfDiskValue");
        }
        this.updateDriveQuantity();
      }
      this.setState({})
    }
  }

  populateDataDriveoptions = () => {
      let drivesArray = []
      let temp = []
      let existingDriveTypes = []
      if( Array.isArray(this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service)) {
        this.state.dataDriveType = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.filter(x=>x["@Type"] === this.props.title)[0].Hardware["@dataDriveType"] 
        serverValue = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.filter(x=>x["@Type"] === this.props.title)[0].Hardware["@Server"]
        isMixedStorageConfiguration = this.props.workload.UserInputs.Environments.Functions.Function.filter(x => x["@Type"] === this.props.type)[0].Service.filter(x => x["@Type"] === this.props.title)[0]["@mixedStorage"]
      } else {
        this.state.dataDriveType = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.Hardware["@dataDriveType"]
        if(this.props.type === "IoT") {
          serverValue = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.Hardware["@ServerName"]  
        } else {
          serverValue = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.Hardware["@Server"] 
        }
        isMixedStorageConfiguration = this.props.workload.UserInputs.Environments.Functions.Function.filter(x => x["@Type"] === this.props.type)[0].Service["@mixedStorage"]
      }
      if(isMixedStorageConfiguration === "True")
      {
        this.props.defaultSizerWorkload.serversList.filter(x => x['serviceName'] === this.props.title)[0].totalList[serverValue].DataDiskList.map(x => {
          drivesArray.push(x)
        })
        let existingDrives = []
        if (Array.isArray(this.props.workload.UserInputs.Environments.Functions.Function.filter(x => x["@Type"] === this.props.type)[0].Service)) {
          this.props.workload.UserInputs.Environments.Functions.Function.filter(x => x["@Type"] === this.props.type)[0].Service.filter(x => x["@Type"] === this.props.title)[0].DataDisks.map(x=>{
            existingDrives.push(x.Item["@disk"])
          })
        } else {
          this.props.workload.UserInputs.Environments.Functions.Function.filter(x => x["@Type"] === this.props.type)[0].Service.DataDisks.map(x=>{
            existingDrives.push(x.Item["@disk"])
          })
        }
        this.props.defaultSizerWorkload.serversList.filter(x => x['serviceName'] === this.props.title)[0].totalList[serverValue].DataDiskList.filter(x =>{
           if(existingDrives.indexOf(x.StrDrive) !== -1 ) {
            x.Types.map(y=>{
              if(existingDriveTypes.indexOf(y) === -1) {
                existingDriveTypes.push(y)
              }
            })
           }
        })
        if(serverValue !== "HPE Apollo 4200 Gen10 Server") {
          if (existingDriveTypes.indexOf('LFF HDD') !== -1 || existingDriveTypes.indexOf('LFF SSD') !== -1) {
            drivesArray.map(x => {
              if (x.Types.indexOf('SFF HDD') === -1 && x.Types.indexOf('SFF SSD') === -1 ) {
                temp.push(x)
              }
            })
          } else if (existingDriveTypes.indexOf('SFF HDD') !== -1 || existingDriveTypes.indexOf('SFF SSD') !== -1) {
            drivesArray.map(x => {
              if (x.Types.indexOf('LFF HDD') === -1 && x.Types.indexOf('LFF HDD') === -1) {
                temp.push(x)
              }
            })
          }
          else {
            drivesArray.map(x => {
                temp.push(x)
            })
          }
          drivesArray = [];
          drivesArray = temp;
          temp = [];
        }
        if (existingDriveTypes.indexOf('SFF SAS SSD') !== -1 || existingDriveTypes.indexOf('SFF SAS HDD') !== -1 || existingDriveTypes.indexOf('LFF SAS SSD') !== -1 || existingDriveTypes.indexOf('LFF SAS HDD') !== -1 || existingDriveTypes.indexOf('NVMe') !== -1 ) {
          drivesArray.map(x => {
            if (x.Types.indexOf('LFF SATA HDD') === -1 && x.Types.indexOf('SFF SATA HDD') === -1) {
              temp.push(x);
            }
            else if(existingDriveTypes.indexOf('SFF SAS SSD') === -1 && existingDriveTypes.indexOf('SFF SAS HDD') === -1 && existingDriveTypes.indexOf('LFF SAS SSD') === -1 && existingDriveTypes.indexOf('LFF SAS HDD') === -1 && existingDriveTypes.indexOf('NVMe') !== -1 && serverValue === "HPE Apollo 4200 Gen10 Server") {
              temp.push(x);
            } 
          })
        }
        else {
          drivesArray.map(x => {
            temp.push(x)
        })
        }

        drivesArray = [];
        drivesArray = temp;
        temp = [];

        if (existingDriveTypes.indexOf('SFF SATA HDD') !== -1 || existingDriveTypes.indexOf('LFF SATA HDD') !== -1 ) {
          drivesArray.map(x => {
            if (x.Types.indexOf('SFF SAS SSD') === -1 && x.Types.indexOf('SFF SAS HDD') === -1 && x.Types.indexOf('LFF SAS SSD') === -1 && x.Types.indexOf('LFF SAS HDD') === -1 && x.Types.indexOf('NVMe') === -1) {
              temp.push(x);
            }
            else if (x.Types.indexOf('SFF SAS SSD') === -1 && x.Types.indexOf('SFF SAS HDD') === -1 && x.Types.indexOf('LFF SAS SSD') === -1 && x.Types.indexOf('LFF SAS HDD') === -1 && x.Types.indexOf('NVMe') !== -1 && serverValue === "HPE Apollo 4200 Gen10 Server") {
              temp.push(x);
            }
          })
        } else {
          drivesArray.map(x => {
            temp.push(x)
        })
        }

        drivesArray = [];
        drivesArray = temp;
        temp = [];
      }else{
        Drives=[];
        drivesArray = [];
        this.props.defaultSizerWorkload.serversList.filter(x => x['serviceName'] === this.props.title)[0].totalList[serverValue].DataDiskList.map(x => {        
        drivesArray.push(x)        
        })
      }
      if(this.state.dataDriveConsolidatedOptions.length === 0 || this.state.changeDriveTypeOptions) {
      this.state.changeDriveTypeOptions = false;
      this.state.dataDriveConsolidatedOptions = []; 
      drivesArray.map(x => {
        x.Types.map(y => {
          if (this.state.dataDriveConsolidatedOptions.indexOf(y) === -1) {
            this.state.dataDriveConsolidatedOptions.push(y)
          }
        })
      })
      }
    
        if(this.state.dataDriveType === "") {
          this.state.dataDriveType = this.state.dataDriveConsolidatedOptions[0]
          if( Array.isArray(this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service)) {
            this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.filter(x=>x["@Type"] === this.props.title)[0].Hardware["@dataDriveType"]  = this.state.dataDriveType
          } else {
            this.props.workload.UserInputs.Environments.Functions.Function.filter(x => x["@Type"] === this.props.type)[0].Service.Hardware["@dataDriveType"] = this.state.dataDriveType
          }
        }
  
      Drives = [];
      drivesArray.map(x => {
        if(x.Types.indexOf(this.state.dataDriveType)!==-1)
        Drives.push(x.StrDrive)
      });    
  }

  deleteDrive = (id) => {
    if( Array.isArray(this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service)) {
      this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.filter(x=>x["@Type"] === this.props.title)[0].DataDisks.splice(id,1);
      if (this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.filter(x=>x["@Type"] === this.props.title)[0].DataDisks.length == 0 ) {
        this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.filter(x=>x["@Type"] === this.props.title)[0]["@mixedStorage"] = "False";
        isMixedStorageConfiguration = "False"
      }
    } else {
      this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.DataDisks.splice(id,1);
      if(this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.DataDisks.length == 0) {
        this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service["@mixedStorage"] = "False"
        isMixedStorageConfiguration = "False"
      }
    }
    this.state.changeDriveTypeOptions = true;
    this.populateDataDriveoptions();
    this.updateDriveQuantity();
    this.setState({})
  }

  populateGPUOptions = () =>{
    if (serverValue === "ProLiant XL190r Gen10") {
      GPUsOptions = ["V100-PCIE-32GB"];
      if(processorTypeValue === CASCADELAKE && AIConfigtypevalue === INFERENCE) {
        GPUsOptions.push("T4-PCIE-16GB");
      }
    } else if (serverValue === 'ProLiant XL270d Gen10') {
      GPUsOptions = ["V100-PCIE-32GB", "V100-SXM2-32GB", "V100-SXM2-16GB"]
      if(processorTypeValue === CASCADELAKE && AIConfigtypevalue === INFERENCE) {
        GPUsOptions.push("T4-PCIE-16GB");
      }
    }
    else if (this.props.type === 'AI' && serverValue === Constants.PROLIANT_DL360_GEN10_PLUS) {
      GPUsOptions = ["T4-PCIE-16GB"];
    }
    else if (this.props.type === 'AI' && serverValue === Constants.PROLIANT_DL380_GEN10_PLUS) {
      GPUsOptions = ['V100-PCIE-32GB'];
      if (AIConfigtypevalue === INFERENCE) {
        GPUsOptions = ["T4-PCIE-16GB"];
      }
    }
    else if (this.props.type === "AI" && (serverValue === Constants.PROLIANT_DL380_GEN10 || serverValue === Constants.PROLIANT_DL385_GEN10_PLUS)) {//DL380 Gen10 Supported for AI, GPUs
      GPUsOptions = ["V100-PCIE-32GB"]
    }
    else if (this.props.type === "AI" && (serverValue === proLiantDL360Gen10 || serverValue === Constants.PROLIANT_DL325_GEN10_PLUS)) {
      GPUsOptions = ["T4-PCIE-16GB"]
    }else if (this.props.type === "AI" && serverValue === 'ProLiant DL385 Gen10') {//DL385 Gen10 Supported for AI, GPUs
      GPUsOptions = ["V100-PCIE-32GB"]
    }
  }

  noOfDrivesleft = (driveID) => {
    let dryqty = 0
    let maxDrives = 0
    let noOfExistingDrives = 0
    let noOfExistingNVMeDrives = 0
    let arrayorObjectCommonMethod = (service, ServiceName) => {
      if (service['@Type'] === this.props.title) {
        if (service['@Selected'] === "true") {
          osdisktypValue = service.Hardware['@OSDisk'];
          if(this.props.title === "MiNifi") {
            serverValue = service.Hardware["@ServerName"]
          } else {
            serverValue = service.Hardware['@Server'];
          }
          if (ServiceName.serviceName === this.props.title) {
            for (let key in ServiceName.totalList) {
              if (key === serverValue) {
                let currentDrive = service.Hardware["@DataDisk"];
                if (editExisting && driveID !== "") {
                  currentDrive = service.DataDisks[driveID].Item["@disk"];
                }
                if ((currentDrive.toUpperCase().indexOf(Constants.NVME_) !== -1) || (serverValue === Constants.HPE_APOLLO_4200_GEN10 && (currentDrive.toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[1]) !== -1 || currentDrive.toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[0]) > -1))) {
                  maxDrives = ServiceName.totalList[key].iMaxNVMeDrives
                  let nonNVMeDrives = 0
                  if (service.DataDisks.length > 0 && service["@mixedStorage"] === Constants.TRUE_) {
                    service.DataDisks.map((x, id)=>{
                      if(x.Item["@disk"].toUpperCase().indexOf(Constants.NVME_) !== -1) {
                        if (!(editExisting && id === driveID)) {
                          noOfExistingNVMeDrives += parseInt(x.Item["@qty"], 10);
                        }
                      } else if(serverValue === Constants.HPE_APOLLO_4200_GEN10 && (x.Item["@disk"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[1]) !== -1 || x.Item["@disk"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[0]) > -1)){
                        if (!(editExisting && id === driveID)) {
                          nonNVMeDrives += parseInt(x.Item["@qty"], 10);
                        }
                      }
                      if (serverValue === Constants.HPE_APOLLO_4200_GEN10) {
                        maxDrives = 6
                      }

                    })
                  }
                  dryqty = maxDrives - noOfExistingNVMeDrives - nonNVMeDrives;
                } else {
                  maxDrives = ServiceName.totalList[key].iDataDiskQty
                  if (service.DataDisks.length > 0 && service["@mixedStorage"] === Constants.TRUE_) {
                    service.DataDisks.map((x, id)=>{
                      if (serverValue !== Constants.HPE_APOLLO_4200_GEN10) {
                        if (!(editExisting && id === driveID)) {
                          noOfExistingDrives += parseInt(x.Item["@qty"], 10)
                        }
                      }
                      else {
                        if(x.Item["@disk"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[1]) === -1 && x.Item["@disk"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[0]) === -1) {
                          if (!(editExisting && id === driveID)) {
                            noOfExistingDrives += parseInt(x.Item["@qty"], 10);
                          }
                        } else {
                          maxDrives = 22
                        }
                      }
                    })
                  } 
                  dryqty = maxDrives - noOfExistingDrives
                  if (serverValue === Constants.HPE_APOLLO_4200_GEN10 && osdisktypValue.indexOf(Constants.M_2) !== -1) {
                    dryqty = dryqty + 2;
                  }
                }
              }
            }
          }
        }
      }
    }
    this.props.defaultSizerWorkload.serversList.map((ServiceName) => {
      this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
        if (val['@Type'] === this.props.type) {
          if (Array.isArray(val.Service)) {
            val.Service.filter((service) => {
              arrayorObjectCommonMethod(service, ServiceName)
            })
          }
          else {
            arrayorObjectCommonMethod(val.Service, ServiceName)
          }  
          
        }
      })
    })
    return dryqty
  }
  closeLayer = () => {
    serverChangeConfirmationlayer = "" ;
    validCombination = true;
    this.setState({})
  }
  ChangedValue(valueChanged, PreviousValue) {
    switch (valueChanged) {
      case "ProcessorFamily":
        return "Processor Family(" + PreviousValue + ")";
      case "Processor":
        return "Processor(" + PreviousValue + ")";
      case "Processor Qty":
        return "Processor Quantity";
      case "Memory":
        return "Memory(" + PreviousValue + ")";
      case "DataDisk":
        return "Data Disk(" + PreviousValue + ")";
      case "OSDisk":
        return "OS Disk(" + PreviousValue + ")";
      case "DataDiskQty":
        return "Data Disk Quantity(" + PreviousValue + ")";
      case "OSDiskQty":
        return "OS Disk Quantity(" + PreviousValue + ")";
      case "NodeQty":
        return "Node Quantity(" + PreviousValue + ")";
    }
  }

  noteContent(Final_Note, Service) {
    var final_note = `${Final_Note.slice(0,Final_Note.indexOf('#'))})`;
    var final_text = " "
    final_note = final_note.substr(1)
    if (final_note === "")
      return "";
    var text1 = final_note.split(",");
    if (text1.length === 1) {
      final_text = text1[0] + " is changed";
    }
    else if (text1.length > 1) {
      for (let i = 0; i < text1.length; i++) {
        if (i == text1.length - 2) {
          final_text = final_text + text1[i] + " and ";
        }
        else if (i == text1.length - 1) {
          final_text = final_text + text1[i] + " are changed";
        }
        else {
          final_text = final_text + text1[i] + ", ";
        }
      }
    }

    switch (Service) {
      case Constants.DATA_LAKE:
        noteTextOnChangeOfConfiguration =
          <Box direction="row">
            <Label style={{ color: 'rgb(255, 141, 109)', fontWeight: '600' }}><b>Note :</b></Label>
            <Paragraph style={{ marginLeft: '1%', marginTop: '27px', color: 'rgb(255, 141, 109)', fontWeight: '600', maxWidth: "85%" }}>{final_text}</Paragraph>
          </Box>
        break;
      case "Scality":
        noteTextOnChangeOfConfigurationScality =
          <Box direction="row">
            <Label style={{ color: 'rgb(255, 141, 109)', fontWeight: '600' }}><b>Note :</b></Label>
            <Paragraph style={{ marginLeft: '1%', marginTop: '27px', color: 'rgb(255, 141, 109)', fontWeight: '600', maxWidth: "85%" }}>{final_text}</Paragraph>
          </Box>
        break;
      case "PyTorch":
        noteTextOnChangeOfConfigurationPyTorch =
          <Box direction="row">
            <Label style={{ color: 'rgb(255, 141, 109)', fontWeight: '600' }}><b>Note :</b></Label>
            <Paragraph style={{ marginLeft: '1%', marginTop: '27px', color: 'rgb(255, 141, 109)', fontWeight: '600', maxWidth: "85%" }}>{final_text}</Paragraph>
          </Box>
        break;
      case "Weka":
        noteTextOnChangeOfConfigurationWeka =
          <Box direction="row">
            <Label style={{ color: 'rgb(255, 141, 109)', fontWeight: '600' }}><b>Note :</b></Label>
            <Paragraph style={{ marginLeft: '1%', marginTop: '27px', color: 'rgb(255, 141, 109)', fontWeight: '600', maxWidth: "85%" }}>{final_text}</Paragraph>
          </Box>
        break;
      case "Hive":
        noteTextOnChangeOfConfigurationHive =
          <Box direction="row">
            <Label style={{ color: 'rgb(255, 141, 109)', fontWeight: '600' }}><b>Note :</b></Label>
            <Paragraph style={{ marginLeft: '1%', marginTop: '27px', color: 'rgb(255, 141, 109)', fontWeight: '600', maxWidth: "85%" }}>{final_text}</Paragraph>
          </Box>
        break;
      case "Cassandra":
        noteTextOnChangeOfConfigurationCassandra =
          <Box direction="row">
            <Label style={{ color: 'rgb(255, 141, 109)', fontWeight: '600' }}><b>Note :</b></Label>
            <Paragraph style={{ marginLeft: '1%', marginTop: '27px', color: 'rgb(255, 141, 109)', fontWeight: '600', maxWidth: "85%" }}>{final_text}</Paragraph>
          </Box>
        break;
      case "Impala":
        noteTextOnChangeOfConfigurationImpala =
          <Box direction="row">
            <Label style={{ color: 'rgb(255, 141, 109)', fontWeight: '600' }}><b>Note :</b></Label>
            <Paragraph style={{ marginLeft: '1%', marginTop: '27px', color: 'rgb(255, 141, 109)', fontWeight: '600', maxWidth: "85%" }}>{final_text}</Paragraph>
          </Box>
        break;
      case "HBase":
        noteTextOnChangeOfConfigurationHBase =
          <Box direction="row">
            <Label style={{ color: 'rgb(255, 141, 109)', fontWeight: '600' }}><b>Note :</b></Label>
            <Paragraph style={{ marginLeft: '1%', marginTop: '27px', color: 'rgb(255, 141, 109)', fontWeight: '600', maxWidth: "85%" }}>{final_text}</Paragraph>
          </Box>
        break;
      case "Spark Streaming":
        noteTextOnChangeOfConfigurationSparkStreaming =
          <Box direction="row">
            <Label style={{ color: 'rgb(255, 141, 109)', fontWeight: '600' }}><b>Note :</b></Label>
            <Paragraph style={{ marginLeft: '1%', marginTop: '27px', color: 'rgb(255, 141, 109)', fontWeight: '600', maxWidth: "85%" }}>{final_text}</Paragraph>
          </Box>
        break;
      case "Kafka":
        noteTextOnChangeOfConfigurationKafka =
          <Box direction="row">
            <Label style={{ color: 'rgb(255, 141, 109)', fontWeight: '600' }}><b>Note :</b></Label>
            <Paragraph style={{ marginLeft: '1%', marginTop: '27px', color: 'rgb(255, 141, 109)', fontWeight: '600', maxWidth: "85%" }}>{final_text}</Paragraph>
          </Box>
        break;
      case "Flink":
        noteTextOnChangeOfConfigurationFlink =
          <Box direction="row">
            <Label style={{ color: 'rgb(255, 141, 109)', fontWeight: '600' }}><b>Note :</b></Label>
            <Paragraph style={{ marginLeft: '1%', marginTop: '27px', color: 'rgb(255, 141, 109)', fontWeight: '600', maxWidth: "85%" }}>{final_text}</Paragraph>
          </Box>
        break;
      case "Storm":
        noteTextOnChangeOfConfigurationStorm =
          <Box direction="row">
            <Label style={{ color: 'rgb(255, 141, 109)', fontWeight: '600' }}><b>Note :</b></Label>
            <Paragraph style={{ marginLeft: '1%', marginTop: '27px', color: 'rgb(255, 141, 109)', fontWeight: '600', maxWidth: "85%" }}>{final_text}</Paragraph>
          </Box>
        break;
      case "Yarn":
        noteTextOnChangeOfConfigurationYarn =
          <Box direction="row">
            <Label style={{ color: 'rgb(255, 141, 109)', fontWeight: '600' }}><b>Note :</b></Label>
            <Paragraph style={{ marginLeft: '1%', marginTop: '27px', color: 'rgb(255, 141, 109)', fontWeight: '600', maxWidth: "85%" }}>{final_text}</Paragraph>
          </Box>
        break;
      case "Spark":
        noteTextOnChangeOfConfigurationSpark =
          <Box direction="row">
            <Label style={{ color: 'rgb(255, 141, 109)', fontWeight: '600' }}><b>Note :</b></Label>
            <Paragraph style={{ marginLeft: '1%', marginTop: '27px', color: 'rgb(255, 141, 109)', fontWeight: '600', maxWidth: "85%" }}>{final_text}</Paragraph>
          </Box>
        break;
      case "Tensorflow":
        noteTextOnChangeOfConfigurationTensorflow =
          <Box direction="row">
            <Label style={{ color: 'rgb(255, 141, 109)', fontWeight: '600' }}><b>Note :</b></Label>
            <Paragraph style={{ marginLeft: '1%', marginTop: '27px', color: 'rgb(255, 141, 109)', fontWeight: '600', maxWidth: "85%" }}>{final_text}</Paragraph>
          </Box>
        break;
      case "MiNifi":
        noteTextOnChangeOfConfigurationMiNifi =
          <Box direction="row">
            <Label style={{ color: 'rgb(255, 141, 109)', fontWeight: '600' }}><b>Note :</b></Label>
            <Paragraph style={{ marginLeft: '1%', marginTop: '27px', color: 'rgb(255, 141, 109)', fontWeight: '600', maxWidth: "85%" }}>{final_text}</Paragraph>
          </Box>
        break;
    }
  }

  noteTextOnChangeOfConfiguration(Service) {
    var final_Changes= HDFS_Change+Scality_Change+Weka_Change+Hive_Change+Cassandra_change+Impala_Change+HBase_Change+SparkStreaming_Change+Kafka_Change+Flink_Change+Storm_Change+Yarn_Change+Spark_Change+TensorFlow_Change+Py_Torch_Change+MiNifi_Change;
    final_Changes = final_Changes.substr(1);
    if (final_Changes === "") {
      noteTextOnChangeOfConfiguration = ""
      noteTextOnChangeOfConfigurationScality = ""
      noteTextOnChangeOfConfigurationPyTorch = ""
      noteTextOnChangeOfConfigurationWeka = ""
      noteTextOnChangeOfConfigurationHive = ""
      noteTextOnChangeOfConfigurationCassandra = ""
      noteTextOnChangeOfConfigurationImpala = ""
      noteTextOnChangeOfConfigurationHBase = ""
      noteTextOnChangeOfConfigurationSparkStreaming = ""
      noteTextOnChangeOfConfigurationKafka = ""
      noteTextOnChangeOfConfigurationFlink = ""
      noteTextOnChangeOfConfigurationStorm = ""
      noteTextOnChangeOfConfigurationYarn = ""
      noteTextOnChangeOfConfigurationSpark = ""
      noteTextOnChangeOfConfigurationTensorflow = ""
      noteTextOnChangeOfConfigurationMiNifi = ""

    }
    else {
      switch (Service) {
        case Constants.DATA_LAKE:
          this.noteContent(HDFS_Change, Service);
          break;
        case "Scality":
          this.noteContent(Scality_Change, Service);
          break;
        case "PyTorch":
          this.noteContent(Py_Torch_Change, Service);
          break;
        case "Weka":
          this.noteContent(Weka_Change, Service);
          break;
        case "Hive":
          this.noteContent(Hive_Change, Service);
          break;
        case "Cassandra":
          this.noteContent(Cassandra_change, Service);
          break;
        case "Impala":
          this.noteContent(Impala_Change, Service);
          break;
        case "HBase":
          this.noteContent(HBase_Change, Service);
          break;
        case "Spark Streaming":
          this.noteContent(SparkStreaming_Change, Service);
          break;
        case "Kafka":
          this.noteContent(Kafka_Change, Service);
          break;
        case "Flink":
          this.noteContent(Flink_Change, Service);
          break;
        case "Storm":
          this.noteContent(Storm_Change, Service);
          break;
        case "Yarn":
          this.noteContent(Yarn_Change, Service);
          break;
        case "Spark":
          this.noteContent(Spark_Change, Service);
          break;
        case "Tensorflow":
          this.noteContent(TensorFlow_Change, Service);
          break;
        case "MiNifi":
          this.noteContent(MiNifi_Change, Service);
          break;
      }
      return noteTextOnChangeOfConfiguration;
    }
  }

  textOnConfigurationChange(Service, valueChanged, PreviousValue) {
    var result = "," + this.ChangedValue(valueChanged, PreviousValue)
    switch (Service) {
      case Constants.DATA_LAKE:
        HDFS_Change = HDFS_Change + result
        break;
      case "Scality":
        Scality_Change = Scality_Change + result;
        break;
      case "Weka":
        Weka_Change = Weka_Change + result;
        break;
      case "Hive":
        Hive_Change = Hive_Change + result;
        break;
      case "Cassandra":
        Cassandra_change = Cassandra_change + result;;
        break;
      case "Impala":
        Impala_Change = Impala_Change + result;;
        break;
      case "HBase":
        HBase_Change = HBase_Change + result;
        break;
      case "Spark Streaming":
        SparkStreaming_Change = SparkStreaming_Change + result;
        break;
      case "Kafka":
        Kafka_Change = Kafka_Change + result;
        break;
      case "Flink":
        Flink_Change = Flink_Change + result;
        break;
      case "Storm":
        Storm_Change = Storm_Change + result;
        break;
      case "Yarn":
        Yarn_Change = Yarn_Change + result;
        break;
      case "Spark":
        Spark_Change = Spark_Change + result;
        break;
      case "Tensorflow":
        TensorFlow_Change = TensorFlow_Change + result;
        break;
      case "PyTorch":
        Py_Torch_Change = Py_Torch_Change + result;
        break;
      case "MiNifi":
        MiNifi_Change = MiNifi_Change + result;
        break;
    }
    console.log(HDFS_Change)
    console.log(Scality_Change)
    console.log(Weka_Change)
    console.log(Hive_Change)
    console.log(Cassandra_change)
    console.log(Impala_Change)
    console.log(HBase_Change)
    console.log(SparkStreaming_Change)
    console.log(Kafka_Change)
    console.log(Flink_Change)
    console.log(Storm_Change)
    console.log(Yarn_Change)
    console.log(Spark_Change)
    console.log(TensorFlow_Change)
    console.log(Py_Torch_Change)
    console.log(MiNifi_Change)
  }
  layerclose(e) {
    maxlayer = false;
    maxlayerSecondServices = false
    maxlayerthirdServices = false
    maxlayerFourthServices = false
    this.props.defaultSizerWorkload.serversList.map((ServiceName) => {
      if (ServiceName.serviceName === this.props.title && ServiceName.Servers !== '') {
        this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
          if (val['@Type'] === this.props.type) {
            if (Array.isArray(val.Service)) {
              val.Service.filter((service) => {
                if (service['@Type'] === this.props.title) {
                  if (service['@Selected'] === "true") {
                    for (let key in ServiceName.totalList) {
                      if (key === serverValue) {
                        //noOfDiskValue = ServiceName.totalList[key].iDataDiskQty.toString();
                        //  service.Hardware['@DiskQty'] = noOfDiskValue
                        noOfOSDiskValue = ServiceName.totalList[key].iOSDiskQty.toString();
                        service.Hardware['@OSDiskQty'] = noOfOSDiskValue
                      }
                    }
                  }
                }
              })
            }
            else {
              if (val.Service['@Type'] === this.props.title) {
                if (val.Service['@Selected'] === "true") {
                  for (let key in ServiceName.totalList) {
                    if (key === serverValue) {
                      // noOfDiskValue = ServiceName.totalList[key].iDataDiskQty.toString();
                      // val.Service.Hardware['@DiskQty'] = noOfDiskValue
                      noOfOSDiskValue = ServiceName.totalList[key].iOSDiskQty.toString();
                      val.Service.Hardware['@OSDiskQty'] = noOfOSDiskValue
                    }
                  }
                }
              }
            }
          }
        })
      }
    })
    StroageNodeQtyCall = true;
    this.onWorkloadUpdate(this.props.type, this.props.title, "noOfDiskValue");
    this.setState({})
  }

  serverChangeConfirmationlayerRoutine = (text) => {
    serverChangeConfirmationlayer = <Layer style={{ zIndex: '500 !important' }}>
        <Box direction="row" margin="none" separator="bottom" style={{ padding: "none", backgroundColor: "#425563" }} >
          <Box direction="row" margin="none" pad="none" align='start' style={{ width: '96%', padding: "10px", color: "#fff" }}>
            <Heading tag="h4" strong={true} style={{ marginBottom: '0px' }}>Warning</Heading>
          </Box>
          <Box direction="row" style={{ marginTop: "10px", padding: "5px" }} margin="none" pad="none" align='start' alignContent="start" onClick={() => this.closeLayer()} >
            <CloseIcon size='small' colorIndex="light-2" style={{ stroke: 'white' }} />
          </Box>
        </Box>
        <Box style={{ padding: "10px" }}>
        <Paragraph>{text}</Paragraph>
        </Box>
      </Layer>
      this.setState({})
  }
  onAIConfigtypevalueChangeBlur(e) {

  }
  onGPUvalueChangeBlur(e) {

  }
  onScalitydiskcapacityvalue(e, type, title) {
    var number = /^[0-9]+$/
    if (e.target.value.length <= 4) {
      let value = parseInt(e.target.value, 10);
      if (isNaN(value)) {
        Scalitydiskcapacityvalue = "";
      }
      else if ((number.test(value)) && (value <= 9999) && (value >= 1) || isNaN(value)) {
        Scalitydiskcapacityvalue = value.toString();
      }
      else {
      }
    }
    this.onWorkloadUpdate(type, title, "Scalitydiskcapacityvalue");
  }
  onScalitydiskcapacityvalueBlur(e, type, title) {
    var number = /^[0-9]+$/
    if (e.target.value.length < 4) {
      let value = parseInt(e.target.value, 10);
      if (isNaN(value)) {
        Scalitydiskcapacityvalue = "200";
      }
      else if ((number.test(value)) && (value <= 999) && (value >= 200) || isNaN(value)) {
        Scalitydiskcapacityvalue = value.toString();

      }
      else {
        Scalitydiskcapacityvalue = "200";
      }
    }
    StroageNodeQtyCall = true
    defaultNodevalueChange = true
    this.onWorkloadUpdate(type, title, "Scalitydiskcapacityvalue");
  }
  onGreenLakeChange(e, type, title) {
    GreenLakevalue = e.value;
    StroageNodeQtyCall = true
    defaultNodevalueChange = true
    this.onWorkloadUpdate(type, title, "GreenLakevalue")
  }
  onSitesvalueChange(e, type, title) {
    Sitesvalue = e.value;
    StroageNodeQtyCall = true
    defaultNodevalueChange = true
    let inputs = {
      "siteName": Sitesvalue
    }
    this.props.OnGetARCValue(inputs);
    this.onWorkloadUpdate(type, title, "Sitesvalue")
  }
  onSecondsitevalueChange(e, type, title) {
    Secondsitevalue = e.value;
    StroageNodeQtyCall = true
    defaultNodevalueChange = true
    this.onWorkloadUpdate(type, title, "Secondsitevalue")
  }
  onStoragePercChange(e, type, title, netwrkcl) {
    var number = /^[0-9]+$/
    if (e.target.value === "") {
      StoragePerc = "1"
      e.target.value = StoragePerc;
    }
    if (e.target.value.length < 4) {
      let value = parseInt(e.target.value, 10);
      if (isNaN(value)) {
        StoragePerc = "0";
      }
      else if ((number.test(value)) && (value <= 100) && (value >= 1) || isNaN(value)) {
        StoragePerc = value.toString();
      }
      else {
      }
    }
    if (netwrkcl === "Blur") {
      StroageNodeQtyCall = true
      defaultNodevalueChange = true
    }
    this.onWorkloadUpdate(type, title, "StoragePerc")
  }
  onAIConfigtypevalueChange(e, type, title) {
    if( Array.isArray(this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service)) {
      serverValue = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.filter(x=>x["@Type"] === this.props.title)[0].Hardware["@Server"];
    } else {
      serverValue = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.Hardware["@ServerName"];
    }
    if((serverValue === proLiantDL360Gen10 || serverValue === Constants.PROLIANT_DL325_GEN10_PLUS) && e.value === training) {
      let text = "The selected configuration type does not support "+serverValue+" server. Please change the server to change the configuration type."
      this.serverChangeConfirmationlayerRoutine(text);
    } else {
    AIConfigtypevalue = e.value;
    StroageNodeQtyCall = true;
    defaultNodevalueChange = true
    this.onWorkloadUpdate(type, title, "AIConfigtypevalue");
    }
  }
  onGPUvalueChange(e, type, title) {
    GPUvalue = e.value;
    StroageNodeQtyCall = true;
    this.onWorkloadUpdate(type, title, "GPUvalue");
  }
  oncapacitytypevalueChange(e, type, title) {
    capacitytypevalue = e.value;
    StroageNodeQtyCall = true;
    defaultNodevalueChange = true
    this.onWorkloadUpdate(type, title, "capacitytypevalue");
  }
  onResponseTimeChange(e, type, title, nwtwkcl) {
    ProcorDiskValue = 'Node Storage Change'
    var number = /^[0-9]+$/
    if (e.target.value.length < 4) {
      let value = parseInt(e.target.value, 10);
      if (isNaN(value)) {
        ResponseTime = "";
        if (nwtwkcl === "Blur") {
          ResponseTime = "1";
        }
      }
      else if ((number.test(value)) && (value <= 999) && (value >= 1) || isNaN(value)) {
        ResponseTime = value.toString();

      }
      else {

      }
    }

    if (nwtwkcl === "Blur") {
      StroageNodeQtyCall = true
    }
    this.onWorkloadUpdate(type, title, "ResponseTime");
  }

  onQueryDataChange(e, type, title, nwtwkcl) {
    ProcorDiskValue = null
    var number = /^[0-9]+$/
    if (e.target.value === "") {
      QueryData = "1"
      e.target.value = QueryData;
    }
    if (e.target.value.length < 4) {
      let value = parseInt(e.target.value, 10);
      if (isNaN(value)) {
        QueryData = "";
      }
      else if ((number.test(value)) && (value <= 999) && (value >= 1) || isNaN(value)) {
        QueryData = value.toString();
      }
      else {
      }
    }
    if (nwtwkcl === "Blur") {
      StroageNodeQtyCall = true
      defaultNodevalueChange = true
    }
    this.onWorkloadUpdate(type, title, "QueryData");
  }
  
  onConcurrentQueriesChange(e, type, title, nwtwkcl) {
    ProcorDiskValue = null
    var number = /^[0-9]+$/
    if (e.target.value === "") {
      ConcurrentQueries = "1"
      e.target.value = ConcurrentQueries;
    }
    if (e.target.value.length < 7) {
      let value = parseInt(e.target.value, 10);
      if (isNaN(value)) {
        ConcurrentQueries = "";
      }
      else if ((number.test(value)) && (value <= 999999) && (value >= parseInt(e.target.min, 10)) || isNaN(value)) {
        ConcurrentQueries = value.toString();
      }
      else {
      }
    }
    if (nwtwkcl === "Blur") {
      StroageNodeQtyCall = true
      defaultNodevalueChange = true
    }
    this.onWorkloadUpdate(type, title, "ConcurrentQueries");
  }

  pushToServersList = (key) => {
    if (Servers.indexOf(key) === -1) {
      if(this.props.type === "AI" && AIConfigtypevalue === training ) { 
        if(key !== proLiantDL360Gen10 && key !== Constants.PROLIANT_DL325_GEN10_PLUS) {
          Servers.push(key);
        }
      } else {
        Servers.push(key);
      }
    }
  }

  onServerChange(e, type, title) {
    let MixedStorageConfiguration = ""
    
    if( Array.isArray(this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service)) {
      MixedStorageConfiguration = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.filter(x=>x["@Type"] === this.props.title)[0]["@mixedStorage"]
    } else {
      MixedStorageConfiguration = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service["@mixedStorage"]
    }
    let validateServerChangeResponse = [true, ''];
    if (MixedStorageConfiguration === "True") {
      validateServerChangeResponse= serverChangeCompatibilityCheck(this.props.workload, e.value, this.props.defaultSizerWorkload.serversList, this.props.type, this.props.title);
    }
    if (!validateServerChangeResponse[0]) {
      this.serverChangeConfirmationlayerRoutine(validateServerChangeResponse[1]);
    }
    else {
    this.resetChangesToEmpty()
    serverValue = e.value;
    ProcorDiskValue = null
    this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
      if (val['@Type'] === this.props.type) {
        if (Array.isArray(val.Service)) {
          val.Service.filter((service) => {
            if (service['@Type'] === this.props.title) {
              if (MixedStorageConfiguration !== Constants.TRUE_) {
                service["@mixedStorage"] = "False"
                service.DataDisks = [];
                service.Hardware["@dataDriveType"] = ""
              }
              service.Hardware["@Server"] = serverValue
              if (serverValue === Constants.PROLIANT_DL325_GEN10_PLUS) {
                service.Hardware['@ProcQty'] = "1";
              } else {
                service.Hardware['@ProcQty'] = "2";
              }
              if (service['@Selected'] === "true" && service.Hardware['@Server'].indexOf("Synergy") !== -1) {
                if (serverValue.indexOf("Synergy") === -1) {
                  SynergyServerChanged = true
                }
              }
            }
          })
        }
        else {
          if(val.Service["@Type"]=== this.props.title) {
            if (MixedStorageConfiguration !== Constants.TRUE_) {
              val.Service["@mixedStorage"] = "False"
              val.Service.DataDisks = [];
              val.Service.Hardware["@dataDriveType"] = ""
            }
            if (val.Service["@Type"] === "MiNifi") {
              val.Service.Hardware["@ServerName"] = serverValue
            }
          }
        }
      }
    })
    FirstServer = false
    if (this.props.title === "Spark Streaming") {
      SparkSynergyServerChanged = true
    } else if (this.props.title === "Kafka") {
      KafkaSynergyServerChanged = true
    } else if (this.props.title === "Flink") {
      FlinkSynergyServerChanged = true
    } else if (this.props.title === "Storm") {
      StormSynergyServerChanged = true
    }
    if (this.props.title === "Yarn") {
      YarnSynergyServerChanged = true
    } else if (this.props.title === "Spark") {
      SparkAnalyticsSynergyServerChanged = true
    } else if (this.props.title === "Hive") {
      HiveSynergyServerChanged = true
    } else if (this.props.title === "Cassandra") {
      CassandraSynergyServerChanged = true
    } else if (this.props.title === "Impala") {
      ImpalaSynergyServerChanged = true
    } else if (this.props.title === "HBase") {
      HBaseSynergyServerChanged = true
    }

    //For retaining previous memory value----Rohith 
    this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
      if (val['@Type'] === this.props.type) {
        if (Array.isArray(val.Service)) {
          val.Service.filter((service) => {
            if (service['@Type'] === this.props.title) {
              if (service['@Selected'] === "true") {
                memoryValue = service.Hardware['@Memory'];
                processorValue = service.Hardware['@Proc'];
                processorTypeValue = service.Hardware['@ProcFamily'];
              }
            }
          })
        } else {
          if (val.Service['@Type'] === this.props.title) {
            if (val.Service['@Selected'] === "true") {
              memoryValue = val.Service.Hardware['@Memory'];
              processorValue = val.Service.Hardware['@Proc'];
              processorTypeValue = val.Service.Hardware['@ProcFamily'];
            }
          }
        }
      }
    })
    this.state.Serverchange = true;
    ProcFamilyList = []
    ProcList = []
    if (this.props.defaultSizerWorkload.serversList !== "" && this.props.defaultSizerWorkload.serversList !== undefined && this.props.defaultSizerWorkload.serversList !== null) {
      this.props.defaultSizerWorkload.serversList.map((ServiceName) => {
        if (ServiceName.serviceName === this.props.title && ServiceName.Servers !== '') {
          for (let key in ServiceName.totalList) {
            if (key === serverValue) {
              this.state.changeDriveTypeOptions = true;
              this.populateDataDriveoptions();
              if (this.props.type !== "Func") {//before wrote for IOT
                for (let proctype in ServiceName.totalList[key].ProcessorList) {
                  if (ProcFamilyList.indexOf(proctype) === -1) {
                    ProcFamilyList.push(proctype);
                  }
                }
                 for (let proctype in ServiceName.totalList[key].ProcessorList) {
                   if(ProcFamilyList.indexOf(processorTypeValue)===-1){
                     processorTypeValue = ProcFamilyList[0]
                   }
                  if (proctype === processorTypeValue) {
                    for (let proc in ServiceName.totalList[key].ProcessorList[proctype]) {
                      if (ProcList.indexOf(proc) === -1) {
                        ProcList.push(proc);
                      }
                    }
                    if (ProcList.indexOf(processorValue) === -1) {
                      this.textOnConfigurationChange(this.props.title, "Processor", processorValue)
                      processorValue = ProcList[0];
                    }
                    for (let proc in ServiceName.totalList[key].ProcessorList[proctype]) {
                      if (proc === processorValue) {
                        MemoryList = ServiceName.totalList[key].ProcessorList[proctype][proc]
                      }
                    }
                  }
                }
              }
              else {
                for (let proc in ServiceName.totalList[key].ProcessorList[processorTypeValue]) {
                  if (ProcList.indexOf(proc) === -1) {
                    ProcList.push(proc);
                    }
                }
                if (ProcList.indexOf(processorValue) === -1) {
                  this.textOnConfigurationChange(this.props.title, "Processor", processorValue)
                  processorValue = ProcList[0];
                }
                for (let proc in ServiceName.totalList[key].ProcessorList[processorTypeValue]) {
                  if (proc === processorValue) {
                    MemoryList = ServiceName.totalList[key].ProcessorList[processorTypeValue][proc]
                  }
                }
              }
            }
           this.pushToServersList(key);
          }
          if (this.state.Serverchange) {
            if (Drives.indexOf(datadisktypValue) === -1) {
              this.textOnConfigurationChange(this.props.title, "DataDisk", datadisktypValue)
              datadisktypValue = Drives[0];
            }
            if (MemoryList.indexOf(memoryValue) === -1) {
              this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
                if (val['@Type'] === this.props.type) {
                  if (Array.isArray(val.Service)) {
                    val.Service.filter((service) => {
                      if (service['@Type'] === this.props.title) {
                        if (service['@Selected'] === "true") {
                          this.textOnConfigurationChange(this.props.title, "Memory", memoryValue)
                          memoryValue = service.Recommendation['@Memory']
                        }
                      }
                    })
                  } else {
                    if (val.Service['@Type'] === this.props.title) {
                      if (val.Service['@Selected'] === "true") {
                        this.textOnConfigurationChange(this.props.title, "Memory", memoryValue)
                        memoryValue = val.Service.Recommendation['@Memory']
                      }
                    }
                  }
                }
              })
            }
            if (ProcList.indexOf(processorValue) === -1) {
              this.textOnConfigurationChange(this.props.title, "Processor", processorValue)
              processorValue = ProcList[0];
            }
            this.state.Serverchange = false
          }
        }
      })
    }

    this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
      if (val['@Type'] === this.props.type) {
        if (Array.isArray(val.Service)) {
          val.Service.filter((service) => {
            if (service['@Type'] === this.props.title) {
              if (service['@Selected'] === "true") {
                service.Hardware['@Server'] = serverValue;
                service.Hardware['@Proc'] = processorValue;

                if(ProcFamilyList.indexOf(processorTypeValue)==-1)
                {
                  processorTypeValue = ProcFamilyList[0];
                }

                service.Hardware['@ProcFamily'] = processorTypeValue
                service.Hardware['@DataDisk'] = datadisktypValue;
                service.Hardware['@Memory'] = memoryValue;
              }
            }
          })
        } else {
          if (val.Service['@Type'] === this.props.title) {
            if (val.Service['@Selected'] === "true") {
              if (val.Service['@Type'] === "MiNifi") {
                val.Service.Hardware['@ServerName'] = serverValue;
              } else {
                val.Service.Hardware['@Server'] = serverValue;
              }
              val.Service.Hardware['@Proc'] = processorValue;
              val.Service.Hardware['@ProcFamily'] = processorTypeValue;
              val.Service.Hardware['@DataDisk'] = datadisktypValue;
              // val.Service.Hardware['@OSDisk'] = osdisktypValue;
              val.Service.Hardware['@Memory'] = memoryValue;
            }
          }
        }
      }
    })
    //Updating No.of Data Disks and OS Disks
    this.props.defaultSizerWorkload.serversList.map((ServiceName) => {
      if (ServiceName.serviceName === this.props.title && ServiceName.Servers !== '' && MixedStorageConfiguration !== Constants.TRUE_) {
        this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
          if (val['@Type'] === this.props.type) {
            if (Array.isArray(val.Service)) {
              val.Service.filter((service) => {
                if (service['@Type'] === this.props.title) {
                  if (service['@Selected'] === "true") {
                    for (let key in ServiceName.totalList) {
                      if (key === serverValue) {
                        noOfDiskValue = ServiceName.totalList[key].iDataDiskQty.toString();
                        if (noOfDiskValue !== service.Hardware['@DiskQty']) {
                          this.textOnConfigurationChange(this.props.title, 'DataDiskQty', service.Hardware['@DiskQty']);
                        }
                        service.DataDisks = []
                        service.DataDisks[0] = { Item : { '@disk' : datadisktypValue, '@qty' : noOfDiskValue, "@volumeName": "Data_0" } };
                        service.Hardware['@DiskQty'] = noOfDiskValue
                        noOfOSDiskValue = ServiceName.totalList[key].iOSDiskQty.toString();
                        if (noOfOSDiskValue !== service.Hardware['@OSDiskQty']) {
                          this.textOnConfigurationChange(this.props.title, 'OSDiskQty', service.Hardware['@OSDiskQty'])
                        }
                        service.Hardware['@OSDiskQty'] = noOfOSDiskValue
                      }

                    }
                  }
                }
              })
            }
            else {
              if (val.Service['@Type'] === this.props.title) {
                if (val.Service['@Selected'] === "true") {
                  for (let key in ServiceName.totalList) {
                    if (key === serverValue) {
                      noOfDiskValue = ServiceName.totalList[key].iDataDiskQty.toString();
                      val.Service.DataDisks = []
                      val.Service.DataDisks[0] = { Item : { '@disk' : datadisktypValue, '@qty' : noOfDiskValue, "@volumeName": "Data_0" } };
                      val.Service.Hardware['@DiskQty'] = noOfDiskValue
                      noOfOSDiskValue = ServiceName.totalList[key].iOSDiskQty.toString();
                      val.Service.Hardware['@OSDiskQty'] = noOfOSDiskValue

                    }

                  }
                }
              }
            }
          }
        })
      }
    })
    var OSInputs = {
      "strFunction": type,
      "strService": title,
      "strServer": serverValue,
      "strDataDisk": datadisktypValue,
    }
    this.props.OnGetOSDiskList(OSInputs);
    StroageNodeQtyCall = true;
    if(MixedStorageConfiguration === Constants.TRUE_) {
      this.updateDriveQuantity();
    }
    defaultNodevalueChange = true
    this.onWorkloadUpdate(type, title, "serverValue");
  }
  }
  resetChangesToEmpty() {
    HDFS_Change = ""
    Scality_Change = ""
    Weka_Change = ""
    Hive_Change = ""
    Cassandra_change = ""
    Impala_Change = ""
    HBase_Change = ""
    SparkStreaming_Change = ""
    Kafka_Change = ""
    Flink_Change = ""
    Storm_Change = ""
    Yarn_Change = ""
    Spark_Change = ""
    TensorFlow_Change = ""
    Py_Torch_Change = ""
    MiNifi_Change = ""
  }
  componentDidMount() {
     this.resetChangesToEmpty();
     console.log("HDFS_Changes"+HDFS_Change)
    
    console.log(EPAvNextInputs);
    var serviceselected = false;
    //this.props.SelectedService.value===this.props.title
    this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
      if (val['@Type'] === this.props.type) {
        if (Array.isArray(val.Service)) {
          val.Service.filter((service) => {
            if (service['@Type'] === this.props.title) {
              if (service['@Selected'] === "true") {
                serviceselected = true
              }
            }
          })
        } else {
          if (val.Service['@Type'] === this.props.title) {
            if (val.Service['@Selected'] === "true") {
              serviceselected = true
            }
          }
        }
      }
    })

    if (OSDiskList.length === 0 && serviceselected) {
      var OSInputs = {
        "strFunction": this.props.type,
        "strService": this.props.title,
        "strServer": serverValue,
        "strDataDisk": datadisktypValue,
      }
      this.props.OnGetOSDiskList(OSInputs);
    }
    this.setState({})
    // IDatadiskqtynotchange=true;
    //IOSDatadiskqtynotchange=true
    // this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
    //           if (val['@Type'] === this.props.type) {
    //              if (Array.isArray(val.Service)) {
    //                 val.Service.filter((service) => {
    //                     if (service['@Type'] === this.props.title) {
    //                       if (service['@Selected'] === "true") {
    //                                 noOfDiskValue=service.Hardware['@DiskQty']; 
    //                                  noOfOSDiskValue=service.Hardware['@OSDiskQty'];
    //                                 }
    //                               }
    //                 })
    //                       }
    //                     }
    //                 })


    // if(!this.props.activeSession.isSizeEnabled) 
    //  this.props.OnToggleSizeButton(true);
  }
  onOSDiskChange(e, type, title) {
    validCombination = true;
    let existingDrivesArray = [];
    if(serverValue === "HPE Apollo 4200 Gen10 Server") {
      if(osdisktypValue.indexOf('M.2') !== -1 && e.option.indexOf('M.2') === -1) {
        if( Array.isArray(this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service)) {
          isMixedStorageConfiguration = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.filter(x=>x["@Type"] === this.props.title)[0]["@mixedStorage"]
          existingDrivesArray = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.filter(x=>x["@Type"] === this.props.title)[0].DataDisks
        } else {
          isMixedStorageConfiguration = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service["@mixedStorage"]
          existingDrivesArray = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.DataDisks
        }
        if(isMixedStorageConfiguration === "True") {
          let nonNVMeDrives = 0
          let NVMeDrives = 0
          let SFFDrives = 0
          existingDrivesArray.map(x=>{
            if(x.Item["@disk"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[1]) === -1 && x.Item["@disk"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[0]) === -1) {
              nonNVMeDrives += parseInt(x.Item["@qty"], 10)
            } else if(x.Item["@disk"].indexOf('NVMe') !== -1) {
              NVMeDrives += parseInt(x.Item["@qty"], 10);
            } else {
              SFFDrives += parseInt(x.Item["@qty"], 10);
            }
          })
          if(nonNVMeDrives > 26) {
            validCombination = false
          }
          if ((NVMeDrives > 0 || SFFDrives > 0) && nonNVMeDrives > 22) {
            validCombination = false
          }
          if (!validCombination) {
            let text = "Drive cannot be changed as the maximum drives exceeded." 
            this.serverChangeConfirmationlayerRoutine(text);
          }
        }
      }
    }
    if (validCombination) {
    this.resetChangesToEmpty()
    osdisktypValue = e.value;
    let dryqty = 0;
    let serverValue;
    let DiskCount;
    this.props.defaultSizerWorkload.serversList.map((ServiceName) => {
      for (let key in ServiceName.totalList) {
        this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
          if (val['@Type'] === this.props.type) {
            if (Array.isArray(val.Service)) {
              val.Service.filter((service) => {
                if (service['@Type'] === this.props.title) {
                  if (service['@Selected'] === "true") {
                    //osdisktypValue= service.Hardware['@OSDisk'] ;
                    serverValue = service.Hardware['@Server'];
                    DiskCount = service.Hardware['@DiskQty'];
                  }
                }
              })
            }
          }
        })
        if (key === serverValue && ServiceName.serviceName ===this.props.title) {
          dryqty = ServiceName.totalList[key].iDataDiskQty
          if (serverValue === "HPE Apollo 4200 Gen10 Server" && osdisktypValue.indexOf("M.2") !== -1) {
            dryqty = dryqty + 2;
          }
        }
      }
    })
    if (parseInt(DiskCount, 10) > dryqty) {
      DiskCount = dryqty.toString()
      this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
        if (val['@Type'] === this.props.type) {
          if (Array.isArray(val.Service)) {
            val.Service.filter((service) => {
              if (service['@Type'] === this.props.title) {
                if (service['@Selected'] === "true") {
                  service.Hardware['@DiskQty'] = DiskCount;
                }
              }
            })
          }
        }
      })
    }
    this.onWorkloadUpdate(type, title, "osdisktypValue");
    this.updateDriveQuantity();
  }
  }
  onProcessorChange(e, type, title) {
    this.resetChangesToEmpty()
    processorValue = e.value;
    recommProc = false;
    if (serverValue === "Synergy 480 Gen10 Server") {
      MemoryList = []
      this.props.defaultSizerWorkload.serversList.map((ServiceName) => {
        if (ServiceName.serviceName === this.props.title && ServiceName.Servers !== '') {
          for (let key in ServiceName.totalList) {
            if (key === serverValue) {
              for (let proctype in ServiceName.totalList[key].ProcessorList) {
                if (proctype === processorTypeValue) {
                  for (let proc in ServiceName.totalList[key].ProcessorList[proctype]) {
                    if (proc === processorValue) {
                      MemoryList = ServiceName.totalList[key].ProcessorList[proctype][proc]
                      // memoryValue = MemoryList[0];
                    }
                  }

                }
              }

            }
          }
          if (processorValue.indexOf("M") !== 4 && processorValue.indexOf("L") !== 4 && MemoryList.indexOf("3072 GB") !== -1) {
            MemoryList.pop();
          }
          if (MemoryList.indexOf(memoryValue) === -1) {
            this.textOnConfigurationChange(this.props.title, "Memory", memoryValue)
            memoryValue = MemoryList[0];
          }
        }
      })

      this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
        if (val['@Type'] === this.props.type) {
          if (Array.isArray(val.Service)) {
            val.Service.filter((service) => {
              if (service['@Type'] === this.props.title) {
                if (service['@Selected'] === "true") {
                  service.Hardware['@Memory'] = memoryValue;
                }
              }
            })
          } else {
            if (val.Service['@Type'] === this.props.title) {
              if (val.Service['@Selected'] === "true") {
                val.Service.Hardware['@Memory'] = memoryValue;
              }
            }
          }
        }
      })
    }
    if(serverValue === Constants.PROLIANT_XL225N_GEN10_PLUS){
      if(processorValue.indexOf(Constants.DLC) > 0){
        pocQtyValue = Constants.NUMERIC_ONE;
      } else if(processorValue.indexOf(Constants.AC) > 0){
        pocQtyValue = Constants.NUMERIC_TWO;
      }
      this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
        if (val['@Type'] === type) {
          if (Array.isArray(val.Service)) {
            val.Service.filter((service) => {
              if (service['@Type'] === title) {
                if (service['@Selected'] === Constants.tRUE_) {
                  service.Hardware['@ProcQty'] = pocQtyValue;
                }
              }
            })
          }
          else {
            if (val.Service['@Type'] === this.props.title && val.Service['@Selected'] === Constants.tRUE_) {
                val.Service.Hardware['@ProcQty'] = pocQtyValue;
            }
          }
        }
      })
      this.props.defaultSizerWorkload.serversList.map((ServiceName) => {
        if (ServiceName.serviceName === this.props.title && ServiceName.Servers !== '') {
          for (let key in ServiceName.totalList) {
            if (key === serverValue) {
                for (let proctype in ServiceName.totalList[key].ProcessorList) {
                    for (let proc in ServiceName.totalList[key].ProcessorList[proctype]) {
                      if (proc === processorValue) {
                        MemoryList = ServiceName.totalList[key].ProcessorList[proctype][proc]
                      }
                    }
                }
            }
          }
        }
      })
    }

    if (this.props.type === "Analytics" || this.props.type === "Database") {
      StroageNodeQtyCall = true;
      ProcorDiskValue = "Proc Changed";
      DatabaseDatadiskChange = true;
    }
    this.onWorkloadUpdate(type, title, "processorValue");
  }
  onProcessorFamilyChange(e, type, title) {
    this.resetChangesToEmpty()
    processorTypeValue = e.value;
    ProcList = []
    this.props.defaultSizerWorkload.serversList.map((ServiceName) => {
      if (ServiceName.serviceName === this.props.title && ServiceName.Servers !== '') {
        for (let key in ServiceName.totalList) {
          if (key === serverValue) {
            if (this.props.type !== "Func") {//before wrote for IOT
              for (let proctype in ServiceName.totalList[key].ProcessorList) {
                if (proctype === processorTypeValue) {
                  for (let proc in ServiceName.totalList[key].ProcessorList[proctype]) {
                    if (ProcList.indexOf(proc) === -1) {
                      ProcList.push(proc);
                    }
                    if (ProcList.indexOf(processorValue) === -1) {
                      this.textOnConfigurationChange(this.props.title, "Processor", processorValue)
                      processorValue = ProcList[0];
                    }
                    if (proc === processorValue) {
                      MemoryList = ServiceName.totalList[key].ProcessorList[proctype][proc]
                      if (MemoryList.indexOf(memoryValue) === -1) {
                        this.textOnConfigurationChange(this.props.title, "Memory", memoryValue)
                        memoryValue = MemoryList[0];

                      }
                    }
                  }
                }
              }
            } else {
              for (let proc in ServiceName.totalList[key].ProcessorList[processorTypeValue]) {
                if (ProcList.indexOf(proc) === -1) {
                  ProcList.push(proc);
                }
                if (ProcList.indexOf(processorValue) === -1) {
                  this.textOnConfigurationChange(this.props.title, "Processor", processorValue)
                  processorValue = ProcList[0];
                }
                if (proc === processorValue) {
                  MemoryList = ServiceName.totalList[key].ProcessorList[processorTypeValue][proc]
                }
              }
            }

          }
        }

      }
    })
    if (this.props.type === "Analytics" || this.props.type === "Database") {
      StroageNodeQtyCall = true;
      ProcorDiskValue = "Proc Changed";
      DatabaseDatadiskChange = true;
    }
    this.onWorkloadUpdate(type, title, "processorTypeValue");
  }
  onDataDiskChange(e, type, title) {
    this.resetChangesToEmpty()
    datadisktypValue = e.value;
    StroageNodeQtyCall = true;
    if (this.props.type === "Analytics" || this.props.type === "Database") {
      ProcorDiskValue = "Disk Changed";
      DatabaseDatadiskChange = true;
    }
    defaultNodevalueChange = true

    var OSInputs = {
      "strFunction": type,
      "strService": title,
      "strServer": serverValue,
      "strDataDisk": datadisktypValue,
    }
    this.props.OnGetOSDiskList(OSInputs);
    this.onWorkloadUpdate(type, title, "datadisktypValue");
    this.updateDriveQuantity();
  }
  onProcQtyChange(e, type, title) {
    this.resetChangesToEmpty()
    pocQtyValue = e.value;


    this.onWorkloadUpdate(type, title, "pocQtyValue");
  }
  onMemoryChange(e, type, title) {
    this.resetChangesToEmpty()
    memoryValue = e.value;
    ProcorDiskValue = null
    if (this.props.type === "Analytics") {
      StroageNodeQtyCall = true;
      ProcorDiskValue = "Memory Changed";
    }
    if (this.props.type === "Analytics" || this.props.type === "Database") {
      DatabaseDatadiskChange = true;
      ProcorDiskValue = "Memory Changed";
    }
    this.onWorkloadUpdate(type, title, "memoryValue");
  }
  onNoOfDisksChange(e, type, title, nwtwkcl, editexisting, driveID) {
    if (editexisting === true) {
      editExisting = editexisting
    } else {
      editExisting = false
    }
    this.resetChangesToEmpty()
    // noOfDiskValue=e.target.value;
    let dryqty = ""
    var number = /^[0-9]+$/
    let globalValue = ""

    if (nwtwkcl === "Blur") {
      this.state.enableADDButton = true
      if (e.target.value === "") {
        //noOfDiskValue = noOfDiskValue;
        e.target.value = editExisting ? "1" : '0';
      }
      if (this.state.valueChanged) {
        StroageNodeQtyCall = true
        this.state.valueChanged = false
      }
      defaultNodevalueChange = true
      //IDatadiskqtynotchange=false
      dryqty = this.noOfDrivesleft(driveID);
      if (e.target.value.length < 3) {
        let value = parseInt(e.target.value, 10);
        if (isNaN(value)) {
          globalValue = "";
        }
        else if ((number.test(value)) && (value < dryqty) && (value >= 1) || isNaN(value)) {
          //noOfDiskValue = dryqty.toString();
          globalValue = value.toString();

        }
        else {
          // noOfDiskValue = value.toString();
          globalValue = dryqty.toString();
        }
        if (value > dryqty && !editExisting) {
          this.maxDriveCountValidation(title);
        }
        if (editExisting) {
          if (Array.isArray(this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service)) {
            this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.filter(x=>x["@Type"] === this.props.title)[0].DataDisks[driveID].Item["@qty"] = globalValue
          }
          else {
            this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.DataDisks[driveID].Item["@qty"] = globalValue
          }
        } else {
          noOfDiskValue = globalValue
        }
      }
      if(editExisting) {
        editExisting = false;
        noOfDiskValue = this.noOfDrivesleft(driveID).toString()
        if( Array.isArray(this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service)) {
          this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.filter(x=>x["@Type"] === this.props.title)[0].Hardware["@DiskQty"] = noOfDiskValue;
        } else {
          this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.Hardware["@DiskQty"] = noOfDiskValue;
        }
      }
      DataDiskQtyChange = true;
    }
    else {
      this.state.valueChanged = true
      this.state.enableADDButton = false
      if (e.target.value.length < 3) {
        let value = parseInt(e.target.value, 10);
        if (isNaN(value)) {
          globalValue = "";
        }
        else if ((number.test(value)) && (value <= 99) && (value >= 1) || isNaN(value)) {
          globalValue = value.toString();

        }
        else {
          //noOfDiskValue = dryqty.toString();
        } 
        if (editExisting) {
          if (Array.isArray(this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service)) {
            this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.filter(x=>x["@Type"] === this.props.title)[0].DataDisks[driveID].Item["@qty"] = globalValue
          }
          else {
            this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.DataDisks[driveID].Item["@qty"] = globalValue
          }
        } else {
          noOfDiskValue = globalValue
        }

      }

    }
    IDatadiskqtynotchange = false
    if (this.props.type === "Analytics" || this.props.type === "Database") {
      ProcorDiskValue = "Disk Qty Changed";
      DatabaseDatadiskChange = true;
    }
    //this.maxDriveCountValidation()
    if(maxlayer || maxlayerSecondServices || maxlayerthirdServices || maxlayerFourthServices) {
      StroageNodeQtyCall = false;
    }
      this.onWorkloadUpdate(type, title, "noOfDiskValue");
    editExisting = false;
  }
  // onNoOfDisksChangeBlur(e,type,title){
  //   if(e.target.value===" ")
  //   {
  //     noOfDiskValue="1";
  //   }
  //   StroageNodeQtyCall=true
  // defaultNodevalueChange=true
  //   this.onWorkloadUpdate(type,title,"noOfDiskValue");
  // }

  onNoOfOSDisksChange(e, type, title, nwtwkcl) {
    this.resetChangesToEmpty()

    let dryqty = ""
    var number = /^[0-9]+$/

    if (nwtwkcl === "Blur") {
      if (e.target.value === "") {
        noOfOSDiskValue = "2";
        e.target.value = noOfOSDiskValue;
      }
      //IOSDatadiskqtynotchange=false
      this.props.defaultSizerWorkload.serversList.map((ServiceName) => {
        for (let key in ServiceName.totalList) {
          if (key === serverValue) {
            dryqty = ServiceName.totalList[key].iOSDiskQty
          }
        }
      })
      if (e.target.value.length < 2) {
        let value = parseInt(e.target.value, 10);
        if (isNaN(value)) {
          noOfOSDiskValue = "";
        }
        else if ((number.test(value)) && (value <= dryqty) && (value > 1) || isNaN(value)) {
          //noOfOSDiskValue = dryqty.toString();
          noOfOSDiskValue = value.toString();

        }
        else {
          // noOfOSDiskValue = value.toString();
          noOfOSDiskValue = dryqty.toString();
        }
      }

    }
    else {
      if (e.target.value.length < 4) {
        let value = parseInt(e.target.value, 10);
        if (isNaN(value)) {
          noOfOSDiskValue = "";
        }
        else if ((number.test(value)) && (value <= dryqty) && (value >= 1) || isNaN(value)) {
          noOfOSDiskValue = value.toString();

        }
        else {

        }
      }
    }


    IOSDatadiskqtynotchange = false
    editExisting = true
    this.maxDriveCountValidation(title)
    editExisting = false
    this.onWorkloadUpdate(type, title, "noOfOSDiskValue");
  }
  onNodevalueChange(e, type, title) {
    //this.onNoOfDisksChange()
    //nodesQtyValue=e.target.value;
    var number = /^[0-9]+$/
    if (e.target.value.length < 6) {
      let value = parseInt(e.target.value, 10);
      if (isNaN(value)) {
        nodesQtyValue = ""
      }
      else if ((number.test(value)) && (value <= 99999) && (value >= 1) || isNaN(value)) {
        nodesQtyValue = value.toString();
      }
      else {

      }
    }

    this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
      if (val['@Type'] === this.props.type) {
        if (Array.isArray(val.Service)) {
          val.Service.filter((service) => {
            if (service['@Type'] === this.props.title) {
              if (service['@Selected'] === "true") {
                service.Hardware['@NodesCount'] = nodesQtyValue;
              }
            }
          })
        } else {
          if (val.Service['@Type'] === this.props.title) {
            if (val.Service['@Selected'] === "true") {
              val.Service.Hardware['@NodesCount'] = nodesQtyValue;
            }
          }
        }
      }
    })
    defaultNodevalueChange = false
    this.onWorkloadUpdate(type, title, "nodesQtyValue")
  }
  onNodevalueBlur(e, type, title) {
    if (parseInt(defaultNodevalue, 10) <= parseInt(e.target.value, 10) || e.target.value === " ") {
      nodesQtyValue = e.target.value;
    } else {
      nodesQtyValue = defaultNodevalue.toString();
    }
    this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
      if (val['@Type'] === this.props.type) {
        if (Array.isArray(val.Service)) {
          val.Service.filter((service) => {
            if (service['@Type'] === this.props.title) {
              if (service['@Selected'] === "true") {
                service.Hardware['@NodesCount'] = nodesQtyValue;
              }
            }
          })
        } else {
          if (val.Service['@Type'] === this.props.title) {
            if (val.Service['@Selected'] === "true") {
              val.Service.Hardware['@NodesCount'] = nodesQtyValue;
            }
          }
        }
      }
    })

    updateGrowthItem(this.props.title,nodesQtyValue,this.props.workload);

    defaultNodevalueChange = false
    this.onWorkloadUpdate(type, title, "nodesQtyValue")
  }

  onStoragevalueCahnge(e, val, type, title) {
    var number = /^[0-9]+$/
    if (e.target.value.length < 2) {
      let value = parseInt(e.target.value, 10);
      if (isNaN(value)) {
        if (val === "value1") {
          Storagevalue1 = '';
        } else {
          Storagevalue2 = ''
        }
      }
      else if ((number.test(value)) && (value <= 9) && (value >= 1) || isNaN(value)) {
        if (val === "value1") {
          Storagevalue1 = value.toString();
        } else {
          Storagevalue2 = value.toString();
        }
      }
      else {

      }
    }


    this.onWorkloadUpdate(type, title, val)
  }
  onStoragevalueCahngeBlur(e, val, type, title) {
    if (e.target.value === '') {
      if (val === "value1") {
        Storagevalue1 = "1"
      } else {
        Storagevalue2 = "1"
      }
    } else {
      if (val === "value1") {
        Storagevalue1 = e.target.value
      } else {
        Storagevalue2 = e.target.value
      }
    }
    // e.target.value=
    StroageNodeQtyCall = true
    defaultNodevalueChange = true
    this.onWorkloadUpdate(type, title, val)
  }
  onWorkloadUpdate(type, title, tag) {
    //this.props.SelectedService.value=title
    this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
      if (val['@Type'] === type) {
        if (Array.isArray(val.Service)) {
          val.Service.filter((service) => {
            if (service['@Type'] === title) {
              // service['@Selected']=this.props.isSelected;
              if (service['@Selected'] === "true") {
                //Hardware Selection
                if (tag === "serverValue") {
                  service.Hardware['@Server'] = serverValue;
                  service.Inputs['@GPU'] = GPUsOptions[0]
                } else if (tag === "processorValue") {
                  service.Hardware['@Proc'] = processorValue;
                } else if (tag === "processorTypeValue") {
                  service.Hardware['@ProcFamily'] = processorTypeValue
                  service.Hardware['@Proc'] = processorValue;
                  service.Hardware['@Memory'] = memoryValue;
                } else if (tag === "pocQtyValue") {
                  service.Hardware['@ProcQty'] = pocQtyValue;
                } else if (tag === "datadisktypValue") {
                  service.Hardware['@DataDisk'] = datadisktypValue;
                } else if (tag === "osdisktypValue") {
                  service.Hardware['@OSDisk'] = osdisktypValue;
                } else if (tag === "nodesQtyValue") {
                  service.Hardware['@NodesCount'] = nodesQtyValue;
                }
                if (tag === "memoryValue")
                  service.Hardware['@Memory'] = memoryValue;

                if (tag === "noOfDiskValue")
                  service.Hardware['@DiskQty'] = noOfDiskValue;

                if (tag === "noOfOSDiskValue")
                  service.Hardware['@OSDiskQty'] = noOfOSDiskValue;

                if (tag === "nodeValue") {
                  service.Hardware['@NodesQty'] = nodeValue;
                  if (nodeValue === "Sizer Recommendation") {
                    service.Hardware['@NodesCount'] = defaultNodevalue
                  }
                }
                if (type === AI) {
                  this.populateGPUOptions();
                  if (GPUsOptions.indexOf(GPUvalue) === -1) {
                    GPUvalue = GPUsOptions[0]
                    service.Inputs['@GPU'] = GPUvalue;
                    StroageNodeQtyCall = true;
                  }
                }
                //Storage Selection
                if (this.props.title === Constants.DATA_LAKE || this.props.title === "MapR and MapR-EC") {

                  if (tag === "diskcapacityvalue")
                    service.Inputs['@Capacity'] = diskcapacityvalue;

                  if (tag === "compression")
                    service.Inputs['@Compression'] = compression;

                  if (tag === "ensurecodngdata") {
                    service.Inputs['@ErasureData'] = ensurecodngdata;
                    service.Inputs['@ErasureParity'] = ensurecodngparity;
                  }

                  if (tag === "ensurecodngparity")
                    service.Inputs['@ErasureParity'] = ensurecodngparity;

                  if (tag === "overhead")
                    service.Inputs['@OverHead'] = overhead;

                  if (tag === "strgwrkload")
                    service.Inputs['@StorageWL'] = strgwrkload;

                  if (tag === "capacitytypevalue") {
                    service.Inputs['@Type'] = capacitytypevalue;
                    if (service.Inputs['@Type'] === "Raw") {
                      service.Inputs['@ErasureCoding'] = "false"
                    }
                  }


                  if (tag === "replicationvalue")
                    service.Inputs['@Replication'] = replicationvalue;
                }
                else if (this.props.title === "Scality") {

                  if (tag === "ARCvalue")
                    service.Inputs['@ARC'] = ARCvalue;

                  if (tag === "Scalitydiskcapacityvalue")
                    service.Inputs['@Capacity'] = Scalitydiskcapacityvalue;

                  if (tag === "GreenLakevalue")
                    service.Inputs['@GreenLake'] = GreenLakevalue;

                  if (tag === "Sitesvalue")
                    service.Inputs['@NoOfSites'] = Sitesvalue;

                  if (tag === "StoragePerc")
                    service.Inputs['@StoragePerc'] = StoragePerc;

                  if (tag === "NetworkSwitchvalue")
                    service.Inputs['@NwSwitch'] = NetworkSwitchvalue;

                  if (tag === "Quantityvalue")
                    service.Inputs['@NwSwitchQty'] = Quantityvalue;

                  if (tag === "Secondsitevalue")
                    service.Inputs['@Replication'] = Secondsitevalue;





                }
                else if (this.props.type === 'Streaming') {
                  if (tag === "MessagesPerSec")
                    service.Inputs['@MessagesPerSec'] = MessagesPerSec;
                }
                else if (this.props.type === "AI") {
                  if (tag === "GPUvalue")
                    service.Inputs['@GPU'] = GPUvalue;

                  if (tag === "GPUQty")
                    service.Inputs['@GPUQty'] = GPUQty;

                  if (tag === "ImagesPerSec")
                    service.Inputs['@ImagesPerSec'] = ImagesPerSec;

                  if (tag === "AIConfigtypevalue")
                    service.Inputs['@ConfigType'] = AIConfigtypevalue;
                }
                else if (this.props.type === "IoT") {
                  if (tag === "EventsPerSec")
                    service.Inputs['@EventsPerSec'] = EventsPerSec;
                }
                else if (this.props.type === "Analytics") {

                  if (tag === "Analyticsvalue") {
                    service.Inputs['@ConfigType'] = Analyticsvalue;
                  } else if (tag === "Ansdiskcapacityvalue") {
                    service.Inputs['@UsableCapacity'] = Ansdiskcapacityvalue
                  } else if (tag === "ContainersQty") {
                    service.Inputs['@ContainersQty'] = ContainersQty
                  } else if (tag === "CoresPerContainer") {
                    service.Inputs['@CoresPerContainer'] = CoresPerContainer
                  } else if (tag === "MemoryPerContainer") {
                    service.Inputs['@MemoryPerContainer'] = MemoryPerContainer
                  } else if (tag === "NodelocalStorageValue") {
                    service.Inputs['@NodeStorage'] = NodelocalStorageValue
                  } else if (tag === "StorageNodesQty") {
                    service.Inputs['@StorageNodesQty'] = StorageNodesQty
                  } else if (tag === "Storagevalue") {
                    service.Inputs['@SCRatio'] = Storagevalue
                    service.Inputs['@Storage'] = Storagevalue1;
                    service.Inputs['@Compute'] = Storagevalue2;
                  } else if (tag === "value1") {
                    service.Inputs['@Storage'] = Storagevalue1;
                  } else if (tag === "value2") {
                    service.Inputs['@Compute'] = Storagevalue2;
                  }

                }
                else if (this.props.type === "Database") {
                  if (tag === "QueryData")
                    service.Inputs['@Capacity'] = QueryData;

                  if (tag === "ResponseTime")
                    service.Inputs['@NodeStorage'] = ResponseTime;

                  if (tag === "ConcurrentQueries")
                    service.Inputs['@OpsPerSec'] = ConcurrentQueries;

                  // if (tag === "DatabaseUsablecapacity")
                  //   service.Inputs['@Capacity'] = DatabaseUsablecapacity;
                }

                else if (this.props.title === "Weka") {
                  if (tag === "DriveClassValue") {
                    if (DriveClassChanged) {
                      DriveClassChanged = false;
                      DATADriveCapacity = DATADriveCapacityoptions[0]
                      service.Inputs['@DATADriveCapacity'] = DATADriveCapacity;
                      if (SKUInformationValue === "Predefined Configuration")
                        service.Inputs['@RawCapacity'] = (parseFloat(service.Inputs['@DATADriveCapacity']) * parseFloat(service.Hardware['@NodesCount']) * parseFloat(service.Inputs['@DATADrivePerServer'])).toString()
                    }
                    service.Inputs['@DriveClass'] = DriveClassValue;
                  }
                  if (tag === "SKUInformationValue") {
                    service.Inputs['@SKUInfo'] = SKUInformationValue;

                    if (SKUInformationValue === "Predefined Configuration") {
                      service.Inputs['@RawCapacity'] = (parseFloat(service.Inputs['@DATADriveCapacity']) * parseFloat(service.Hardware['@NodesCount']) * parseFloat(service.Inputs['@DATADrivePerServer'])).toString()
                      // service.Hardware['@NodesCount'] = "1";
                      service.Hardware['@NodesCount'] = "6";
                    }
                  }


                  if (tag === "Addservers")
                    service.Inputs['@AddServers'] = Addservers;

                  if (tag === "OSEnvironment")
                    service.Inputs['@OS'] = OSEnvironment;

                  if (tag === "SupportYearCount")
                    service.Inputs['@SupportYears'] = SupportYearCount;

                  if (tag === "EducationCustomer")
                    service.Inputs['@IsEduCustomer'] = EducationCustomer;

                  if (tag === "NetworkType")
                    service.Inputs['@NetworkType'] = NetworkType;

                  if (tag === "Peakreadiops")
                    service.Inputs['@PeakReadIOPS'] = Peakreadiops;

                  if (tag === "Peakwriteiops")
                    service.Inputs['@PeakWriteIOPS'] = Peakwriteiops;

                  if (tag === "ServerType") {
                    service.Hardware['@Server'] = ServerType;
                    service.Inputs['@DATADrivePerServer'] = DATADrivePerServer;
                    if (SKUInformationValue === "Predefined Configuration")
                      service.Inputs['@RawCapacity'] = (parseFloat(service.Inputs['@DATADriveCapacity']) * parseFloat(service.Hardware['@NodesCount']) * parseFloat(service.Inputs['@DATADrivePerServer'])).toString()
                  }


                  if (tag === "capacityrequired")
                    service.Inputs['@TierCapacity'] = capacityrequired;

                  if (tag === "Peakreadbandwdth")
                    service.Inputs['@PeakReadBW'] = Peakreadbandwdth;

                  if (tag === "Peakwritebandwdth")
                    service.Inputs['@PeakWriteBW'] = Peakwritebandwdth;

                  if (tag === "Totalusablestorage")
                    service.Inputs['@Capacity'] = Totalusablestorage;

                  if (tag === "DIMMCapacity")
                    service.Inputs['@DIMMCapacity'] = DIMMCapacity;

                  if (tag === "DATADriveCapacity") {
                    service.Inputs['@DATADriveCapacity'] = DATADriveCapacity;
                    if (SKUInformationValue === "Predefined Configuration")
                      service.Inputs['@RawCapacity'] = (parseInt(service.Inputs['@DATADriveCapacity'], 10) * parseInt(service.Hardware['@NodesCount'], 10)).toString()
                  }



                  if (tag === "DATADrivePerServer")
                    service.Inputs['@DATADrivePerServer'] = DATADrivePerServer;

                  if (tag === "SpareServers")
                    service.Inputs['@SpareServers'] = SpareServers;

                  if (tag === "NumServers")
                    service.Hardware['@NodesCount'] = NumServers;







                }



              }

            }
          })
        }
        else {
          if (val.Service['@Type'] === this.props.title) {

            if (val.Service['@Selected'] === "true") {
              val.Service.Inputs['@EventsPerSec'] = EventsPerSec;

              if (tag === "serverValue")
                if (val.Service['@Type'] === "MiNifi") {
                  val.Service.Hardware['@ServerName'] = serverValue;
                } else {
                  val.Service.Hardware['@Server'] = serverValue;
                }
              // val.Service.Hardware['@Server'] = serverValue;

              if (tag === "processorValue")
                val.Service.Hardware['@Proc'] = processorValue;

              if (tag === "processorTypeValue") {
                val.Service.Hardware['@ProcFamily'] = processorTypeValue;
                val.Service.Hardware['@Proc'] = processorValue;
                val.Service.Hardware['@Memory'] = memoryValue;
              }

              if (tag === "pocQtyValue")
                val.Service.Hardware['@ProcQty'] = pocQtyValue;

              if (tag === "datadisktypValue")
                val.Service.Hardware['@DataDisk'] = datadisktypValue;

              if (tag === "osdisktypValue")
                val.Service.Hardware['@OSDisk'] = osdisktypValue;

              if (tag === "nodesQtyValue")
                val.Service.Hardware['@NodesCount'] = nodesQtyValue;

              if (tag === "memoryValue")
                val.Service.Hardware['@Memory'] = memoryValue;

              if (tag === "noOfDiskValue")
                val.Service.Hardware['@DiskQty'] = noOfDiskValue;

              if (tag === "noOfOSDiskValue")
                val.Service.Hardware['@OSDiskQty'] = noOfOSDiskValue;

              if (tag === "nodeValue") {
                val.Service.Hardware['@NodesQty'] = nodeValue;
                if (nodeValue === "Sizer Recommendation") {
                  val.Service.Hardware['@NodesCount'] = defaultNodevalue
                }
              }
              // val.Service.Hardware['@Server'] = serverValue;
              //val.Service.Hardware['@Proc'] = processorValue;
              //val.Service.Hardware['@ProcQty'] = pocQtyValue;
              // val.Service.Hardware['@DataDisk'] = datadisktypValue;
              //val.Service.Hardware['@OSDisk'] = osdisktypValue;
              // val.Service.Hardware['@NodesCount'] = nodesQtyValue;
              // val.Service.Hardware['@Memory'] = memoryValue;
              // val.Service.Hardware['@DiskQty'] = noOfDiskValue;
              //  val.Service.Hardware['@NodesQty']=nodeValue;
            }
            else {
              EventsPerSec = ''
            }
          }
        }
      }
    })
    if (AnalyticsandDatabaseNodeQtyCall) {
      AnalyticsandDatabaseNodeQtyCall = false;
      this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
        if (val['@Type'] === this.props.type) {
          if (Array.isArray(val.Service)) {
            val.Service.filter((service) => {
              if (service['@Type'] === this.props.title) {
                if (service['@Selected'] === "true") {
                  let NodeInputs = {};
                  switch (this.props.type) {
                    case "Analytics":
                      NodeInputs = {
                        "strFunc": this.props.type,
                        "strService": this.props.title,
                        "strServer": service.Hardware['@Server'],
                        "strDataDisk": service.Hardware['@DataDisk'],
                        "dNodeStorage": parseFloat(service.Inputs['@NodeStorage']),
                        "iDiskQty": parseInt(service.Hardware['@DiskQty'], 10),
                      }
                      break;
                    case "Database":
                      NodeInputs = {
                        "strFunc": this.props.type,
                        "strService": this.props.title,
                        "strServer": service.Hardware['@Server'],
                        "strDataDisk": service.Hardware['@DataDisk'],
                        "dNodeStorage": parseFloat(service.Inputs['@NodeStorage']),
                        "iDiskQty": parseInt(service.Hardware['@DiskQty'], 10),
                      }
                      break;
                  }
                  this.props.RecallAnalyticsandDatabaseNodeQty(NodeInputs)
                }
              }
            })
          }
        }
      })

    }

    if (StroageNodeQtyCall) {
      StroageNodeQtyCall = false
      // ProcorDiskValue=null
      this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
        let Arg0, Arg1, Arg2
        let earasure = false
        if (val['@Type'] === this.props.type) {
          if (Array.isArray(val.Service)) {
            val.Service.filter((service) => {
              if (service['@Type'] === this.props.title) {
                isMixedStorageConfiguration = service["@mixedStorage"]
                if (service['@Selected'] === "true") {
                  if (service.Inputs['@ConfigType'] === "Containers" || service.Inputs['@ConfigType'] === "Executors") {
                    Arg0 = parseFloat(service.Inputs['@ContainersQty'])
                    Arg1 = parseFloat(service.Inputs['@CoresPerContainer'])
                    Arg2 = parseFloat(service.Inputs['@MemoryPerContainer'])
                  } else {
                    Arg0 = parseFloat(service.Inputs['@StorageNodesQty'])
                    Arg1 = parseFloat(Storagevalue1)
                    Arg2 = parseFloat(Storagevalue2)
                  }
                  let Databasedrives = [];
                  let DatabaseandAnalyticsDiskQtyChange = ""
                  if (this.props.type === "Database" || this.props.type === "Analytics") {
                    if (DatabaseDatadiskChange) {
                      DatabaseDatadiskChange = false
                      Databasedrives.push(service.Hardware['@DataDisk']);
                    } else {
                      Databasedrives = Drives
                    }
                    if (DataDiskQtyChange) {
                      DataDiskQtyChange = false
                      DatabaseandAnalyticsDiskQtyChange = true
                    } else {
                      DatabaseandAnalyticsDiskQtyChange = false
                    }
                  }

                  if (service['@Type'] === Constants.DATA_LAKE) {
                    earasure = this.props.erasureHDFS
                  } else if (service['@Type'] === "MapR and MapR-EC") {
                    earasure = this.props.erasureMAPR
                  }
                  let disksQtyinpayload = []
                  if(isMixedStorageConfiguration === "True") {
                    disksQtyinpayload = service.DataDisks
                  }
                  let Inputs = {};
                  switch (this.props.type) {
                    case 'Storage':
                      if (this.props.title === "Weka") {
                        Inputs = {
                          "strFunc": this.props.type,
                          "strService": this.props.title,
                          "SKUInfo": service.Inputs['@SKUInfo'],
                          "strServer": service.Hardware['@Server'],
                          "strDriveClass": service.Inputs['@DriveClass'],
                          "PeakReadIO": parseFloat(service.Inputs['@PeakReadIOPS']),
                          "PeakWriteIO": parseFloat(service.Inputs['@PeakWriteIOPS']),
                          "PeakReadBW": parseFloat(service.Inputs['@PeakReadBW']),
                          "PeakWriteBW": parseFloat(service.Inputs['@PeakWriteBW']),
                          "dUsableCapacity": parseFloat(service.Inputs['@Capacity']),
                        }
                      } else if (this.props.title === "Scality") {
                        Inputs = {
                          "strFunc": this.props.type,
                          "strService": this.props.title,
                          "isGreenLake": service.Inputs['@GreenLake'],
                          "strServer": service.Hardware['@Server'],
                          "strDataDisk": service.Hardware['@DataDisk'],
                          "Drives": disksQtyinpayload,
                          "iDiskQty": parseFloat(service.Hardware['@DiskQty']),
                          "dUsableCapacity": parseFloat(service.Inputs['@Capacity']),
                          "dStoragePerc": parseFloat(service.Inputs['@StoragePerc']),
                          "strSite": service.Inputs['@NoOfSites'],
                          "strReplication": service.Inputs['@Replication']
                        }
                      }
                      else {
                        Inputs = {
                          "strFunc": this.props.type,
                          "strService": this.props.title,
                          "Server": service.Hardware['@Server'],
                          "dRawCapacity": parseFloat(service.Inputs['@Capacity']),
                          "strDataDisk": service.Hardware['@DataDisk'],
                          "Drives": disksQtyinpayload,
                          "strCapacityType": service.Inputs['@Type'],
                          "dReplication": parseFloat(service.Inputs['@Replication']),
                          "dCompression": parseFloat(service.Inputs['@Compression']),
                          "dOverhead": parseFloat(service.Inputs['@OverHead']),
                          "bErasureCode": earasure,
                          //"bErasureCode":this.props.defaultSizerWorkload.ErasureCodingChkd,
                          "dData": parseFloat(service.Inputs['@ErasureData']),
                          "dParity": parseFloat(service.Inputs['@ErasureParity']),
                          "iDiskQty": parseFloat(service.Hardware['@DiskQty'])
                        }
                      }
                      break;
                    case 'Streaming':
                      Inputs = {
                        "strFunc": this.props.type,
                        "strService": this.props.title,
                        "Server": service.Hardware['@Server'],
                        "dMessPerSec": parseFloat(service.Inputs['@MessagesPerSec'])
                      }
                      break;
                    case 'Database':
                      if (this.props.title === "Hive") {
                        ShowHiveLayer = true
                      }
                      Inputs = {
                        "strFunc": this.props.type,
                        "strService": this.props.title,
                        "Server": service.Hardware['@Server'],
                        "SelectedDisk": service.Hardware['@DataDisk'],
                        "Drives": disksQtyinpayload,
                        "DBSize": parseFloat(service.Inputs['@Capacity']),
                        "dNodeStorage": parseFloat(service.Inputs['@NodeStorage']),
                        "dQueriesPerMinute": parseFloat(service.Inputs['@OpsPerSec']),
                        "lstDataDrives": Databasedrives,
                        //"lstDataDrives":service.Hardware['@DataDisk'],
                        "iDataDiskQty": parseInt(service.Hardware['@DiskQty'], 10),
                        "bIsDiskChanged": DatabaseandAnalyticsDiskQtyChange,
                        "strProcessor": service.Hardware['@Proc'],
                        "strCompChanged": ProcorDiskValue
                        //"iDataDiskQtyChange":DatabaseandAnalyticsDiskQtyChange
                      }
                      break;
                    case 'AI':
                      Inputs = {
                        "strFunc": this.props.type,
                        "strService": this.props.title,
                        "strServer": service.Hardware['@Server'],
                        "strConfigType": AIConfigtypevalue,
                        "iGPUQty": "",
                        "dImagesPerSec": parseFloat(service.Inputs['@ImagesPerSec']),
                        "strGPUSelected": service.Inputs['@GPU']
                      }
                      break;
                    case 'Analytics':
                      Inputs = {
                        "strFunc": this.props.type,
                        "strService": this.props.title,
                        "strConfigType": service.Inputs['@ConfigType'],
                        "arg0": Arg0,
                        "arg1": Arg1,
                        "arg2": Arg2,
                        "strServer": service.Hardware['@Server'],
                        "strDataDisk": service.Hardware['@DataDisk'],
                        "Drives": disksQtyinpayload,
                        "dNodeStorage": parseFloat(service.Inputs['@NodeStorage']),
                        "lstDataDrives": Databasedrives,
                        //"lstDataDrives":service.Hardware['@DataDisk'],
                        "iDataDiskQty": parseInt(service.Hardware['@DiskQty'], 10),
                        "bIsDiskChanged": DatabaseandAnalyticsDiskQtyChange,
                        "strMemory": service.Hardware['@Memory'],
                        "strProcessor": service.Hardware['@Proc'],
                        "strCompChanged": ProcorDiskValue
                        //"iDataDiskQtyChange":DatabaseandAnalyticsDiskQtyChange

                      }
                      break;
                  }
                  this.props.OnFetchNodeQty(Inputs);
                }
              }
            })
          }
        }
      })
    }
    this.setState({})
  }
  maxDriveCountValidation(title) {
    let noOfExistingNVMeDrives = 0
    let noOfExistingDrives = 0
    let qtyOfExistingDataDisks = 0
    let noOfExistingNonNVMeDrives = 0;
    let arrayObjectCommonMethod = (ServiceName, service) => {
      if (service['@Type'] === this.props.title) {
        if (service['@Selected'] === Constants.tRUE_) {
          osdisktypValue = service.Hardware['@OSDisk'];
          serverValue = service.Hardware['@Server'];
          if (ServiceName.serviceName === this.props.title) {
            for (var key in ServiceName.totalList) {
              if (key === serverValue) {
                MaxDriveQty = ServiceName.totalList[key].iMaxDrives;
                if (serverValue === Constants.HPE_APOLLO_4200_GEN10 && osdisktypValue.indexOf(Constants.M_2) !== -1) {
                  MaxDriveQty = MaxDriveQty + 2;
                }
                if (service.Hardware["@DataDisk"].toUpperCase().indexOf(Constants.NVME_) !== -1 || (serverValue === Constants.HPE_APOLLO_4200_GEN10 && (service.Hardware["@DataDisk"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[1]) !== -1 || service.Hardware["@DataDisk"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[0]) > -1))) {
                  let nonNVMeDrives = 0;
                  MaxDriveQty = ServiceName.totalList[key].iMaxNVMeDrives;
                  if (service.DataDisks.length > 0 && service["@mixedStorage"] === Constants.TRUE_) {
                    service.DataDisks.map(x => {
                      if (x.Item["@disk"].toUpperCase().indexOf(Constants.NVME_) !== -1) {
                        noOfExistingNVMeDrives += parseInt(x.Item["@qty"], 10);
                      } else if (serverValue === Constants.HPE_APOLLO_4200_GEN10 && (x.Item["@disk"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[1]) !== -1 || x.Item["@disk"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[0]) > -1)) {
                        nonNVMeDrives += parseInt(x.Item["@qty"], 10);
                      } else {
                        noOfExistingNonNVMeDrives += parseInt(x.Item["@qty"], 10);
                      }
                    })
                  }
                  if (service.Hardware["@OSDisk"].toUpperCase().indexOf(Constants.NVME_) !== -1) {
                    noOfExistingNVMeDrives += parseInt(service.Hardware["@OSDiskQty"], 10);
                  } else {
                    noOfExistingNonNVMeDrives += parseInt(service.Hardware["@OSDiskQty"], 10);
                  }
                  if (editExisting) {
                    qtyOfExistingDataDisks = noOfExistingNVMeDrives + nonNVMeDrives;
                  } else {
                    qtyOfExistingDataDisks = noOfExistingNVMeDrives + nonNVMeDrives + parseInt(service.Hardware["@DiskQty"], 10);
                  }
                  if (qtyOfExistingDataDisks <= MaxDriveQty) {
                    MaxDriveQty = ServiceName.totalList[key].iMaxDrives;
                    if (serverValue === Constants.HPE_APOLLO_4200_GEN10) {
                      if (noOfExistingNVMeDrives > 0 || nonNVMeDrives > 0) {
                        MaxDriveQty = 24;
                        qtyOfExistingDataDisks = noOfExistingNonNVMeDrives;
                      }
                      if (osdisktypValue.indexOf(Constants.M_2) > -1) {
                        MaxDriveQty = MaxDriveQty + 2;
                      }
                    } else {
                      if (editExisting) {
                        qtyOfExistingDataDisks = noOfExistingNVMeDrives + nonNVMeDrives + noOfExistingNonNVMeDrives;
                      } else {
                        qtyOfExistingDataDisks = noOfExistingNVMeDrives + nonNVMeDrives + noOfExistingNonNVMeDrives + parseInt(service.Hardware["@DiskQty"], 10);
                      }
                    }
                  }
                } else {
                  if (service.DataDisks.length > 0 && service["@mixedStorage"] === Constants.TRUE_) {
                    service.DataDisks.map(x => {
                      if (serverValue !== Constants.HPE_APOLLO_4200_GEN10) {
                        noOfExistingDrives += parseInt(x.Item["@qty"], 10);
                      } else {
                        if (x.Item["@disk"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[1]) === -1 && x.Item["@disk"].toUpperCase().indexOf(Constants.SFF_DESCRIPTIONS[0]) === -1) {
                          noOfExistingDrives += parseInt(x.Item["@qty"], 10);
                        }
                        else {
                          MaxDriveQty = 24;
                          if (osdisktypValue.indexOf(Constants.M_2) !== -1) {
                            MaxDriveQty += 2;
                          }
                        }
                      }
                    })
                  }
                  if (editExisting) {
                    qtyOfExistingDataDisks = noOfExistingDrives + parseInt(service.Hardware["@OSDiskQty"], 10);
                  } else {
                    qtyOfExistingDataDisks = noOfExistingDrives + parseInt(noOfDiskValue, 10) + parseInt(service.Hardware["@OSDiskQty"], 10);
                  }
                }
              }
            }
          }
        }
      }
    }
    this.props.defaultSizerWorkload.serversList.map((ServiceName) => {
      this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
        if (val['@Type'] === this.props.type) {
          if (Array.isArray(val.Service)) {
            val.Service.filter((service) => {
              arrayObjectCommonMethod(ServiceName, service);
            })
          }
          else {
            arrayObjectCommonMethod(ServiceName, val.Service);
          }
        }
      })
    })

    if (MaxDriveQty < qtyOfExistingDataDisks) {
      maxDrivesSupported = MaxDriveQty
      if (this.props.title === Constants.DATA_LAKE || this.props.title === "Hive" || this.props.title === "Spark Streaming" || this.props.title === "Yarn" || this.props.title === "Tensorflow" || this.props.title === "MiNifi") {
        maxlayer = true;
        maxlayerSecondServices = false;
        maxlayerthirdServices = false;
        maxlayerFourthServices = false;
      } else if (this.props.title === "Scality" || this.props.title === "Cassandra" || this.props.title === "Kafka" || this.props.title === "Spark" || this.props.title === "PyTorch") {
        maxlayer = false;
        maxlayerSecondServices = true;
        maxlayerthirdServices = false;
        maxlayerFourthServices = false;
      } else if (this.props.title === "Impala" || this.props.title === "Flink") {
        maxlayer = false;
        maxlayerSecondServices = false;
        maxlayerthirdServices = true;
        maxlayerFourthServices = false;
      } else if (this.props.title === "HBase" || this.props.title === "Storm") {
        maxlayer = false;
        maxlayerSecondServices = false;
        maxlayerthirdServices = false;
        maxlayerFourthServices = true;
      }
    } else {

    }
  }

  onMessagesPerSecChange(e, type, title, nwtwkcl) {
    // MessagesPerSec=e.target.value;
    var number = /^[0-9]+$/
    if (e.target.value == "") {
      MessagesPerSec = "0";
      e.target.value = MessagesPerSec;
    }
    if (e.target.value.length <= 5) {
      let value = parseInt(e.target.value, 10);
      if (isNaN(value)) {
        MessagesPerSec = "";
      }
      else if ((number.test(value)) && (value <= 99999) && (value >= 1) || isNaN(value)) {
        MessagesPerSec = value.toString();

      }
      else {

      }
    }
    if (nwtwkcl === "Blur") {
      StroageNodeQtyCall = true
      defaultNodevalueChange = true
    }
    //StroageNodeQtyCall=true
    this.onWorkloadUpdate(type, title, "MessagesPerSec");
  }
  // onMessagesPerSecBlur(e,type,title){
  //     if(e.target.value==""){
  //         MessagesPerSec="0";
  //       }
  // this.onWorkloadUpdate(type,title,"MessagesPerSec");   
  // }
  NodeQtycahnge(e, type, title) {
    let visible = false;
    if (e.value === "Sizer Recommendation") {
      visible = true;
      updateGrowthItem(title,defaultNodevalue,this.props.workload);
    }
    nodeValue = e.value;
    //    this.props. workload.UserInputs.Environments.Functions.Function.filter((val)=>{
    //       if(val['@Type']=== this.props.type)
    //       {
    //         if(Array.isArray(val.Service))
    //         {
    //             val.Service.filter((service)=>{
    //               if(service['@Type']===this.props.title)
    //               {
    //               if( service['@Selected']==="true"){
    //                 service.Hardware['@NodesQty']= nodeValue;
    //               }
    //             }
    //             })
    //         } else{
    //           if(val.Service['@Type']===this.props.title)
    //               {
    //                 if( val.Service['@Selected']==="true"){
    //                 val.Service.Hardware['@NodesQty'] = nodeValue;
    //                 }
    //               }
    //         }
    //       }
    // })
    this.onWorkloadUpdate(type, title, "nodeValue");
    this.setState({ NodeQtyvisible: visible })
  }
  ContainerdisplayChange(e, type, title) {
    Analyticsvalue = e.value;
    StroageNodeQtyCall = true;
    ProcorDiskValue = null
    defaultNodevalueChange = true
    this.onWorkloadUpdate(type, title, "Analyticsvalue");
  }
  onContainersQtyChange(e, type, title, ntwrkcl) {
    //ContainersQty=e.target.value;
    var number = /^[0-9]+$/
    // if (e.target.value === "") {
    //   e.target.value = "1"
    // }
    if (e.target.value.length <= 3) {
      let value = parseInt(e.target.value, 10);
      if (isNaN(value)) {
        ContainersQty = "";
      }
      else if ((number.test(value)) && (value <= 999) && (value >= 1) || isNaN(value)) {
        ContainersQty = value.toString();

      }
      else {

      }
    }
    if (ntwrkcl === "Blur") {
      if (e.target.value === "") {
        ContainersQty = "1"
      }
      StroageNodeQtyCall = true;
      defaultNodevalueChange = true
    }

    this.onWorkloadUpdate(type, title, "ContainersQty");
  }
  // onContainersQtyChangeBlur(e,type,title)
  // {
  //    if(e.target.value==="")
  //    {
  //      ContainersQty="1"
  //    }
  //    StroageNodeQtyCall=true;
  //       defaultNodevalueChange=true
  //   this.onWorkloadUpdate(type,title,"ContainersQty");

  // }
  onCoresPerContainerChange(e, type, title, ntwrkcl) {
    //CoresPerContainer=e.target.value;
    var number = /^[0-9]+$/
    // if (e.target.value === "") {
    //   CoresPerContainer = "1";
    //   e.target.value = CoresPerContainer;
    // }
    if (e.target.value.length < 3) {
      let value = parseInt(e.target.value, 10);
      if (isNaN(value)) {
        CoresPerContainer = "";
      }
      else if ((number.test(value)) && (value <= 99) && (value >= 1) || isNaN(value)) {
        CoresPerContainer = value.toString();

      }
      else {

      }
    }
    if (ntwrkcl === "Blur") {
      if (e.target.value === "") {
        CoresPerContainer = "1";
        e.target.value = CoresPerContainer;
      }
      StroageNodeQtyCall = true;
      defaultNodevalueChange = true
    }
    this.onWorkloadUpdate(type, title, "CoresPerContainer");
  }
  //  onCoresPerContainerChangeBlur(e,type,title){
  //     if(e.target.value==="")
  //    {
  //      CoresPerContainer="1";
  //    }
  //     StroageNodeQtyCall=true;
  //   defaultNodevalueChange=true
  //   this.onWorkloadUpdate(type,title,"CoresPerContainer");
  //  }
  onMemoryPerContainerChange(e, type, title, ntwrkcl) {
    //  MemoryPerContainer=e.target.value;
    var number = /^[0-9]+$/
    // if (e.target.value === "") {
    //   MemoryPerContainer = "1";
    //   e.target.value = MemoryPerContainer;
    // }
    if (e.target.value.length < 3) {
      let value = parseInt(e.target.value, 10);
      if (isNaN(value)) {
        MemoryPerContainer = "";
      }
      else if ((number.test(value)) && (value <= 99) && (value >= 1) || isNaN(value)) {
        MemoryPerContainer = value.toString();

      }
      else {

      }
    }
    if (ntwrkcl === "Blur") {
      if (e.target.value === "") {
        MemoryPerContainer = "1";
        e.target.value = MemoryPerContainer;
      }
      StroageNodeQtyCall = true;
      defaultNodevalueChange = true
    }
    this.onWorkloadUpdate(type, title, "MemoryPerContainer");
  }
  //  onMemoryPerContainerChangeBlur(e,type,title){
  //    if(e.target.value==="")
  //    {
  //      MemoryPerContainer="1";
  //    }
  //    StroageNodeQtyCall=true;
  //   defaultNodevalueChange=true
  //   this.onWorkloadUpdate(type,title,"MemoryPerContainer");
  //  }
  onNodelocalStorageValueChange(e, type, title) {
    //NodelocalStorageValue=e.target.value;
    var number = /^[0-9]+$/
    if (e.target.value.length < 4) {
      let value = parseInt(e.target.value, 10);
      if (isNaN(value)) {
        NodelocalStorageValue = "";
      }
      else if ((number.test(value)) && (value <= 999) && (value >= 1) || isNaN(value)) {
        NodelocalStorageValue = value.toString();

      }
      else {

      }
    }

    this.onWorkloadUpdate(type, title, "NodelocalStorageValue");
  }
  onNodelocalStorageValueChangeBlur(e, type, title) {
    //  if(e.target.value==="")
    //  {
    //    NodelocalStorageValue="1"
    //  }
    var number = /^[0-9]+$/
    if (e.target.value.length < 4) {
      let value = parseInt(e.target.value, 10);
      if (isNaN(value)) {
        NodelocalStorageValue = '1';
      }
      else if ((number.test(value)) && (value <= 999) && (value >= 1) || isNaN(value)) {
        NodelocalStorageValue = value.toString();

      }
      else {

      }
    }
    StroageNodeQtyCall = true
    ProcorDiskValue = "Node Storage Changed";
    this.onWorkloadUpdate(type, title, "NodelocalStorageValue");
  }
  onAnsdiskcapacityvalue(e, type, title, ntwrkcl) {
    // Ansdiskcapacityvalue=e.target.value;
    var number = /^[0-9]+$/
    if (e.target.value === "") {
      Ansdiskcapacityvalue = "0"
      e.target.value = Ansdiskcapacityvalue;
    }
    if (e.target.value.length < 4) {
      let value = parseInt(e.target.value, 10);
      if (isNaN(value)) {
        Ansdiskcapacityvalue = "";
      }
      else if ((number.test(value)) && (value <= 999) && (value >= 0) || isNaN(value)) {
        Ansdiskcapacityvalue = value.toString();

      }
      else {

      }
    }
    if (ntwrkcl === "Blur") {
      StroageNodeQtyCall = true;
      defaultNodevalueChange = true
    }
    this.onWorkloadUpdate(type, title, "Ansdiskcapacityvalue");
  }
  //  onAnsdiskcapacityvalueBlur(e,type,title)
  //  {
  //     if(e.target.value==="")
  //    {
  //      Ansdiskcapacityvalue="0"
  //    }
  //   this.onWorkloadUpdate(type,title,"Ansdiskcapacityvalue");
  //  }
  onStorageNodesQtyChange(e, type, title, ntwrkcl) {
    // StorageNodesQty=e.target.value;
    ProcorDiskValue = null;
    var number = /^[0-9]+$/
    if (e.target.value === "") {
      StorageNodesQty = "1"
      e.target.value = StorageNodesQty;
    }
    if (e.target.value.length < 4) {
      let value = parseInt(e.target.value, 10);
      if (isNaN(value)) {
        StorageNodesQty = "";
      }
      else if ((number.test(value)) && (value <= 999) && (value >= 1) || isNaN(value)) {
        StorageNodesQty = value.toString();

      }
      else {

      }
    }
    if (ntwrkcl === "Blur") {
      StroageNodeQtyCall = true;
      defaultNodevalueChange = true
    }
    this.onWorkloadUpdate(type, title, "StorageNodesQty");
  }
  //  onStorageNodesQtyChangeBlur(e,type,title){
  //    if(e.target.value==="")
  //    {
  //      StorageNodesQty="1"
  //    }
  //   this.onWorkloadUpdate(type,title,"StorageNodesQty");
  //  }
  onStorageOptionsChange(e, type, title) {
    Storagevalue = e.value;
    if (Storagevalue === "Balanced Workload") {
      Storagevalue1 = '1'
      Storagevalue2 = '2'
    }
    else if (Storagevalue === "IO intensive") {
      Storagevalue1 = '1'
      Storagevalue2 = '1'
    }
    else if (Storagevalue === "Compute Intensive") {
      Storagevalue1 = '1'
      Storagevalue2 = '3'
    }
    StroageNodeQtyCall = true
    defaultNodevalueChange = true
    ProcorDiskValue = null;
    this.onWorkloadUpdate(type, title, "Storagevalue");

  }
  onDiskCapacityChange(e, type, title) {
    var number = /^[0-9]+$/
    if (e.target.value.length < 7) {
      let value = parseInt(e.target.value, 10);
      if (isNaN(value)) {
        diskcapacityvalue = "";
      }
      else if ((number.test(value)) && (value <= 999999) && (value >= 1) || isNaN(value)) {
        diskcapacityvalue = value.toString();

      }
      else {

      }
    }
    //diskcapacityvalue=e.target.value;
    //StroageNodeQtyCall=true;
    defaultNodevalueChange = true
    this.onWorkloadUpdate(type, title, "diskcapacityvalue");
  }
  onDiskCapacityBlur(e, type, title) {
    if (e.target.value == "") {
      diskcapacityvalue = "1024";
    }
    StroageNodeQtyCall = true;
    defaultNodevalueChange = true
    this.onWorkloadUpdate(type, title, "diskcapacityvalue");
  }
  onOverheadChange(e, type, title) {
    onChangeTriggered = true;
    var number = /^[0-9]+$/
    let value = parseInt(e.target.value, 10);
    if (isNaN(value)) {
      overhead = "";
    }
    else if ((number.test(value)) && (value <= 100) && (value >= 0) || isNaN(value)) {
      overhead = value.toString();

    }
    else {

    }
    // overhead=e.target.value;
    //StroageNodeQtyCall=true;
    defaultNodevalueChange = true
    this.onWorkloadUpdate(type, title, "overhead");
  }
  onBlurValidation = () => {
    if (onChangeTriggered) {
      StroageNodeQtyCall = true;
      onChangeTriggered = false;
    }
  }
  onOverheadBlur(e, type, title) {
    if (e.target.value == "") {
      overhead = 0;
    }
    this.onBlurValidation();
    defaultNodevalueChange = true
    this.onWorkloadUpdate(type, title, "overhead");
  }
  onStorageWorkloadChange(e, type, title) {
    var number = /^[0-9]+$/
    let value = parseInt(e.target.value, 10);
    if (isNaN(value)) {
      strgwrkload = "";

    }
    else if ((number.test(value)) && (value <= 100) && (value >= 0) || isNaN(value)) {
      strgwrkload = value.toString();

    }
    else {

    }
    //strgwrkload=e.target.value;

    this.onWorkloadUpdate(type, title, "strgwrkload");
  }
  onStorageWorkloadBlur(e, type, title) {
    if (e.target.value == "") {
      strgwrkload = 0;
    }
    this.onWorkloadUpdate(type, title, "strgwrkload");
  }
  onCompressionChange(e, type, title) {
    onChangeTriggered = true;
    var alapha = /\d+(\.\d{1,2})?/
    if ((alapha.test(e.target.value) && (e.target.value) <= parseFloat(Constants.DATALAKE_COMPRESSION_MAXVLAUE, 10) && (e.target.value) >= parseFloat(Constants.DATALAKE_COMPRESSION_MINVLAUE, 10)) || (e.target.value == "")) {
      var decimal = e.target.value;
      if (decimal.length <= 2) {
        compression = e.target.value.toString();

      }
      if (decimal.indexOf(".") > 0) {
        let result = decimal.split(".");
        let output1 = result[0];
        let output2 = result[1];
        if (output2.length <= 2) {
          compression = e.target.value.toString();
        }
      }
    }
    // compression=e.target.value;
    // StroageNodeQtyCall=true;
    defaultNodevalueChange = true
    this.onWorkloadUpdate(type, title, "compression");
  }
  onCompressionBlur(e, type, title) {
    if (e.target.value == "") {
      compression = 1;
    }
    if (e.target.value.length === 2) {
      let arr = [];
      arr = e.target.value.split('.')
      compression = arr[0]

    }
    this.onBlurValidation();    
    defaultNodevalueChange = true
    this.onWorkloadUpdate(type, title, "compression");
  }
  onReplicationCahnge(e, type, title) {
    // replicationvalue=e.target.value;
    onChangeTriggered = true;
    var alapha = /\d+(\.\d{1,2})?/
    if ((alapha.test(e.target.value) && (e.target.value) <= parseFloat(Constants.DATALAKE_REPLICATION_MAXVALUE, 10) && (e.target.value) >= parseFloat(Constants.DATALAKE_REPLICATION_MINVALUE, 10)) || (e.target.value == "")) {
      var decimal = e.target.value;
      if (decimal.length <= 2) {
        replicationvalue = e.target.value.toString();

      }
      if (decimal.indexOf(".") > 0) {
        let result = decimal.split(".");
        let output1 = result[0];
        let output2 = result[1];
        if (output2.length <= 2) {
          replicationvalue = e.target.value.toString();
        }
      }
    }
    defaultNodevalueChange = true
    this.onWorkloadUpdate(type, title, "replicationvalue");
  }
  onReplicationBlur(e, type, title) {
    if (e.target.value == "") {
      replicationvalue = 1;
    }
    if (e.target.value.length === 2) {
      let arr = [];
      arr = e.target.value.split('.')
      replicationvalue = arr[0]

    }
    this.onBlurValidation();
    defaultNodevalueChange = true
    this.onWorkloadUpdate(type, title, "replicationvalue");
  }
  onEnsuredataCahnge(e, type, title) {
    //ensurecodngdata=e.target.value;
    var number = /^[0-9]+$/
    if (e.target.value.length < 3) {
      let value = parseInt(e.target.value, 10);
      if (isNaN(value)) {
        ensurecodngdata = "";
      }
      else if ((number.test(value)) && (value <= 10) && (value >= 1) || isNaN(value)) {
        ensurecodngdata = value.toString();
        if (parseInt(ensurecodngparity, 10) >= parseInt(ensurecodngdata, 10) && parseInt(ensurecodngdata, 10) >= 3) {
          ensurecodngparity = (parseInt(ensurecodngdata, 10) - 1)
        }
      }
      else {

      }
    }
    //StroageNodeQtyCall=true;
    //defaultNodevalueChange=true
    this.onWorkloadUpdate(type, title, "ensurecodngdata");
  }
  onEnsuredataBlur(e, type, title) {
    if (e.target.value === " " || e.target.value < 3) {
      ensurecodngdata = "3";
      if (parseInt(ensurecodngparity, 10) > (parseInt(ensurecodngdata, 10) - 1)) {
        ensurecodngparity = (parseInt(ensurecodngdata, 10) - 1)
      }
    }

    StroageNodeQtyCall = true;
    defaultNodevalueChange = true
    this.onWorkloadUpdate(type, title, "ensurecodngdata");
  }
  onEnsureParityCahnge(e, type, title) {
    // ensurecodngparity=e.target.value;
    var number = /^[0-9]+$/
    let val = parseInt(ensurecodngdata, 10);
    if (e.target.value.length <= 2) {
      let value = parseInt(e.target.value, 10);
      if (isNaN(value)) {
        ensurecodngparity = "";
      }
      else if ((number.test(value)) && (value < val) && (value >= 1) || isNaN(value)) {
        ensurecodngparity = value.toString();

      }
      else {
        ensurecodngparity = (parseInt(ensurecodngdata, 10) - 1).toString()
      }
    }
    // StroageNodeQtyCall=true;
    // defaultNodevalueChange=true
    this.onWorkloadUpdate(type, title, "ensurecodngparity");
  }
  onEnsureParityBlur(e, type, title) {
    if (e.target.value === "") {
      ensurecodngparity = (parseInt(ensurecodngdata, 10) - 1).toString()
    }
    StroageNodeQtyCall = true;
    defaultNodevalueChange = true
    this.onWorkloadUpdate(type, title, "ensurecodngparity");
  }
  onImagesPerSecChange(e, type, title, nwtwkcl) {
    //ImagesPerSec=e.target.value;
    var number = /^[0-9]+$/
    if (e.target.value === '') {
      ImagesPerSec = '0'
      e.target.value = ImagesPerSec;
    }
    //let val=parseInt(ensurecodngdata, 10);
    if (e.target.value.length <= 6) {
      let value = parseInt(e.target.value, 10);
      if (isNaN(value)) {
        ImagesPerSec = "";
      }
      else if ((number.test(value)) && (value <= 999999) && (value >= 0) || isNaN(value)) {
        ImagesPerSec = value.toString();

      }
      else {
        ImagesPerSec = ensurecodngdata
      }
    }
    if (nwtwkcl === "Blur") {
      StroageNodeQtyCall = true
      defaultNodevalueChange = true
    }
    this.onWorkloadUpdate(type, title, "ImagesPerSec");
  }
  // onImagesPerSecChangeBlur(e,type,title){
  //   if(e.target.value===''){
  //     ImagesPerSec='1'
  //   }
  //   this.onWorkloadUpdate(type,title,"ImagesPerSec");
  // }
  // onGPUQtyChange(e){
  //   GPUQty=e.target.value;
  //   this.onWorkloadUpdate();
  // }
  onEventsPerSecChange(e, type, title, nwtcal) {
    var number = /^[0-9]+$/
    if (nwtcal === "Blur") {
      if (e.target.value === '') {
        EventsPerSec = '1'
      }
    }
    else {
      if (e.target.value.length <= 4) {
        let value = parseInt(e.target.value, 10);
        if (isNaN(value)) {
          EventsPerSec = "";
        }
        else if ((number.test(value)) && (value <= 9999) && (value >= 1) || isNaN(value)) {
          EventsPerSec = value.toString();

        }
      }
    }
    this.onWorkloadUpdate(type, title, "EventsPerSec");
  }
  //  onEventsPerSecChangeBlur(e,type,title){
  //    if(e.target.value===''){
  //     EventsPerSec='1'
  //   }
  //   this.onWorkloadUpdate(type,title,"EventsPerSec");

  // }



  // DefaultServers(title) {
  //   switch (title) {
  //     case "HDFS":
  //     case "Scality":
  //     case "Weka":
  //     case "Hive":
  //     case "Cassandra":
  //     case "HDFS":
  //     case "HDFS":
  //     case "HDFS":
  //     case "HDFS":
  //     case "HDFS":
  //     case "HDFS":
  //     case "HDFS":

  //   }
  // }
  onSKUInformationChange(e, type, title, ) {
    SKUInformationValue = e.value;
    if (SKUInformationValue !== "Predefined Configuration") {
      StroageNodeQtyCall = true
      defaultNodevalueChange = true
    } else {
      StroageNodeQtyCall = false
      //  defaultNodevalueChange = true
    }
    this.onWorkloadUpdate(type, title, "SKUInformationValue");
    //this.setState({SKUInformationValue:e.value})
  }
  onDriveClassChange(e, type, title) {
    DriveClassValue = e.value;
    StroageNodeQtyCall = true
    defaultNodevalueChange = true
    DriveClassChanged = true
    DATADriveCapacityoptions = []
    this.props.EPAInputs.Sizers.Sizer.Functions.Function.Input.map((val) => {
      switch (val["@Type"]) {
        case "Drives Capacity":
          val.Item.map((capacity) => {
            // if (capacity["_DriveClass"] === DriveClassValue)
            //   DATADriveCapacityoptions.push(capacity["__text"])

            //Dheeraj              
            if (capacity["@DriveClass"] === DriveClassValue)
              DATADriveCapacityoptions.push(capacity["#text"])
          })
          break;
      }
    })
    this.onWorkloadUpdate(type, title, "DriveClassValue");
    // this.setState({DriveClassValue:e.value})
  }
  onDeploymentChange(e, type, title) {
    Addservers = e.value;
    this.onWorkloadUpdate(type, title, "Addservers");
  }
  onOSEnvironmentChange(e, type, title) {
    OSEnvironment = e.value;
    this.onWorkloadUpdate(type, title, "OSEnvironment");
  }
  onSupportYearCountChange(e, type, title) {
    SupportYearCount = e.value;
    this.onWorkloadUpdate(type, title, "SupportYearCount");
  }
  onEducationCustomerChange(e, type, title) {
    EducationCustomer = e.value;
    this.onWorkloadUpdate(type, title, "EducationCustomer");
  }
  onNetworkTypeChange(e, type, title) {
    NetworkType = e.value;
    this.onWorkloadUpdate(type, title, "NetworkType");
  }
  onServerTypeChange(e, type, title) {
    ServerType = e.value;
    if (ServerType === "ProLiant DL360 Gen10") {
      DATADrivePerServeroptions = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];
      DATADrivePerServer = DATADrivePerServeroptions[9]

    } else {
      if (ServerType === "ProLiant XL170r Gen10") {
        DATADrivePerServeroptions = ["1", "2", "3", "4"]
        DATADrivePerServer = DATADrivePerServeroptions[3]
      }
    }
    StroageNodeQtyCall = true
    defaultNodevalueChange = true
    this.onWorkloadUpdate(type, title, "ServerType");
    this.onWorkloadUpdate(type, title, "DATADrivePerServer");
  }


  onPeakreadiopsChange(e, type, title, nwtwkcl) {
    //Peakreadiops=e.value;
    var number = /^[0-9]+$/
    //let val=parseInt(ensurecodngdata, 10);
    if (e.target.value.length <= 4) {
      let value = parseInt(e.target.value, 10);
      if (isNaN(value)) {
        Peakreadiops = "";
      }
      else if ((number.test(value)) && (value <= 9999) && (value >= 1) || isNaN(value)) {
        Peakreadiops = value.toString();

      }
      else {
        // EventsPerSec=ensurecodngdata
        // EventsPerSec=" "

      }
    }
    if (nwtwkcl === "Blur") {
      if (e.target.value === '') {
        Peakreadiops = '1'
      }
      StroageNodeQtyCall = true
      defaultNodevalueChange = true
    }
    this.onWorkloadUpdate(type, title, "Peakreadiops");
  }
  onPeakwriteiopsChange(e, type, title, nwtwkcl) {
    //Peakwriteiops=e.value;
    var number = /^[0-9]+$/

    //let val=parseInt(ensurecodngdata, 10);
    if (e.target.value.length <= 4) {
      let value = parseInt(e.target.value, 10);
      if (isNaN(value)) {
        Peakwriteiops = "";
      }
      else if ((number.test(value)) && (value <= 9999) && (value >= 1) || isNaN(value)) {
        Peakwriteiops = value.toString();

      }
      else {
        // EventsPerSec=ensurecodngdata
        // EventsPerSec=" "

      }
    }
    if (nwtwkcl === "Blur") {

      if (e.target.value === '') {
        Peakwriteiops = '1'
      }
      StroageNodeQtyCall = true
      defaultNodevalueChange = true
    }
    this.onWorkloadUpdate(type, title, "Peakwriteiops");
  }
  onTotalusablestorageChange(e, type, title, nwtwkcl) {
    //Totalusablestorage=e.value;
    var number = /^[0-9]+$/

    //let val=parseInt(ensurecodngdata, 10);
    if (e.target.value.length <= 4) {
      let value = parseInt(e.target.value, 10);
      if (isNaN(value)) {
        Totalusablestorage = "";
      }
      else if ((number.test(value)) && (value <= 9999) && (value >= 1) || isNaN(value)) {
        Totalusablestorage = value.toString();

      }
      else {
        // EventsPerSec=ensurecodngdata
        // EventsPerSec=" "

      }
    }
    if (nwtwkcl === "Blur") {
      if (e.target.value === '') {
        Totalusablestorage = '1'
      }
      StroageNodeQtyCall = true
      defaultNodevalueChange = true
    }
    //this.onWorkloadUpdate(type,title,"Peakwriteiops");
    this.onWorkloadUpdate(type, title, "Totalusablestorage");
  }
  onPeakreadbandwdthChange(e, type, title, nwtwkcl) {
    // Peakreadbandwdth=e.value;
    var number = /^[0-9]+$/

    //let val=parseInt(ensurecodngdata, 10);
    if (e.target.value.length <= 4) {
      let value = parseInt(e.target.value, 10);
      if (isNaN(value)) {
        Peakreadbandwdth = "";
      }
      else if ((number.test(value)) && (value <= 9999) && (value >= 1) || isNaN(value)) {
        Peakreadbandwdth = value.toString();

      }
      else {
        // EventsPerSec=ensurecodngdata
        // EventsPerSec=" "

      }
    }
    if (nwtwkcl === "Blur") {
      if (e.target.value === '') {
        Peakreadbandwdth = '1'
      }
      StroageNodeQtyCall = true
      defaultNodevalueChange = true
    }
    this.onWorkloadUpdate(type, title, "Peakreadbandwdth");
  }

  onPeakwritebandwdthChange(e, type, title, nwtwkcl) {
    //Peakwritebandwdth=e.value;
    var number = /^[0-9]+$/

    //let val=parseInt(ensurecodngdata, 10);
    if (e.target.value.length <= 4) {
      let value = parseInt(e.target.value, 10);
      if (isNaN(value)) {
        Peakwritebandwdth = "";
      }
      else if ((number.test(value)) && (value <= 9999) && (value >= 1) || isNaN(value)) {
        Peakwritebandwdth = value.toString();

      }
      else {
        // EventsPerSec=ensurecodngdata
        // EventsPerSec=" "

      }
    }
    if (nwtwkcl === "Blur") {
      if (e.target.value === '') {
        Peakwritebandwdth = '1'
      }
      StroageNodeQtyCall = true
      defaultNodevalueChange = true
    }
    this.onWorkloadUpdate(type, title, "Peakwritebandwdth");
  }
  oncapacityrequiredChange(e, type, title, nwtwkcl) {
    var number = /^[0-9]+$/

    //let val=parseInt(ensurecodngdata, 10);
    if (e.target.value.length <= 4) {
      let value = parseInt(e.target.value, 10);
      if (isNaN(value)) {
        capacityrequired = "";
      }
      else if ((number.test(value)) && (value <= 9999) && (value >= 1) || isNaN(value)) {
        capacityrequired = value.toString();

      }
      else {

      }
    }
    if (nwtwkcl === "Blur") {
      if (e.target.value === '') {
        capacityrequired = '1'
      }
      StroageNodeQtyCall = true
      defaultNodevalueChange = true
    }
    this.onWorkloadUpdate(type, title, "capacityrequired");
  }
  onNetworkSwitchvalueChange(e, type, title) {
    NetworkSwitchvalue = e.value;
    this.onWorkloadUpdate(type, title, "NetworkSwitchvalue");
  }
  onQuantityvalueChange(e, type, title) {
    Quantityvalue = e.value;
    this.onWorkloadUpdate(type, title, "Quantityvalue");
  }
  OnDIMMCapacityoptionsChange(e, type, title) {
    DIMMCapacity = e.value;
    this.onWorkloadUpdate(type, title, "DIMMCapacity");
  }
  OnDATADriveCapacityoptionsChange(e, type, title) {
    DATADriveCapacity = e.value;
    this.onWorkloadUpdate(type, title, "DATADriveCapacity");
  }
  OnDATADrivePerServeroptionsChange(e, type, title) {
    DATADrivePerServer = e.value;
    this.onWorkloadUpdate(type, title, "DATADrivePerServer");
  }
  OnSpareServersoptionsChange(e, type, title) {
    SpareServers = e.value;
    this.onWorkloadUpdate(type, title, "SpareServers");
  }
  OnNumServersChange(e, type, title, nwtwkcl) {
    var number = /^[0-9]+$/

    if (nwtwkcl === "Change") {
      if (e.target.value.length <= 2) {
        let value = parseInt(e.target.value, 10);
        if (isNaN(value)) {
          NumServers = "";
        }
        else if ((number.test(value)) && (value <= 99) && (value >= 1) || isNaN(value)) {
          NumServers = value.toString();

        }
      }
    }
    else {
      if (e.target.value === '') {
        NumServers = '1'

      }
    }
    this.onWorkloadUpdate(type, title, "NumServers");
  }
  //  componentWillReceiveProps(nextProps, nextState){
  //    if(nextProps.defaultSizerWorkload.serversList.length !==this.props.defaultSizerWorkload.serversList.length){
  //      let inputs={
  //                function:this.props.type,
  //                service:this.props.title,
  //               }
  //            let pushservice=true;

  //            nextProps.defaultSizerWorkload.serversList.map((ServiceName)=>{
  //                if(ServiceName.serviceName===this.props.title)
  //                {
  //                    pushservice=false
  //                }             
  //            })
  //              if(pushservice){
  //                this.props.OnFetchServerList(inputs);
  //                }  

  //    }

  //  }
  layercloseHive() {
    ShowHiveLayer = false;
    FirstServer = false;
    this.setState({})
  }

  render() {
    //  inputs.function=this.props.type;
    //   inputs.service=this.props.title;
    let Deleteservers = false
    Servers = [];
    Drives = [];
    MemoryList = [];
    OSDiskList = [];
    ProcList = [];
    let NodesQtyOptions = [];
    ProcFamilyList = [];
    let AIConfigTypeOptions = [];
    GPUsOptions = []
    console.log(this.props);
    let layer = ""
    let layerSecondService = ""
    let layerThirdService = ""
    let layerFourthService = ""
    //  let ServerChangeNote1=""
    //  let ServerChangeNote2=""
    //  let ServerChangeNote3=""
    //  let ServerChangeNote4=""
    // let MaxDriveQty=" "
    let AnlyOptions = [];
    // switch(this.props.title)
    // {
    //    case "HDFS":
    //     noteTextOnChangeOfConfiguration = this.noteTextOnChangeOfConfiguration(this.props.title);
    //     noteTextOnChangeOfConfigurationScality=''
    //       break;
    //     case "Scality":
    //     noteTextOnChangeOfConfiguration=" "
    //        noteTextOnChangeOfConfigurationScality = this.noteTextOnChangeOfConfiguration(this.props.title);
    //       break;

    // }
    //noteTextOnChangeOfConfiguration = 
    this.noteTextOnChangeOfConfiguration(this.props.title);
    if (this.props.workload !== undefined && this.props.workload !== null && this.props.EPAInputs.Sizers!==undefined) {
      DATADriveCapacityoptions = [];
      this.props.EPAInputs.Sizers.Sizer.Functions.Function.Input.map((val) => {
        switch (val["@Type"]) {
          case "OS Environment":
            OSEnvironmentoptions = val.Item;
            break;
          case "Support  Year":
            SupportYearCountoptions = val.Item;
            break;
          case "Network Type":
            //NetworkTypeoptions=val.Item;
            NetworkTypeoptions = ["100GbE"];
            break;
          case "Drive Per Server":
            if (ServerType === "ProLiant DL360 Gen10") {
              DATADrivePerServeroptions = val.Item;
              if (DATADrivePerServeroptions.indexOf(DATADrivePerServer) === -1) {
                DATADrivePerServer = DATADrivePerServeroptions[0]
              }
            } else {
              if (ServerType === "ProLiant XL170r Gen10") {
                DATADrivePerServeroptions = ["1", "2", "3", "4"]
                if (DATADrivePerServeroptions.indexOf(DATADrivePerServer) === -1) {
                  DATADrivePerServer = DATADrivePerServeroptions[0]
                }
              }

            }

            break;
          case "Spare Servers":
            SpareServersoptions = val.Item;
            break;
          case "DIMM Capacity":
            DIMMCapacityoptions = val.Item;
            break;
          case "Drives Capacity":
            val.Item.map((capacity) => {
              //Dheeraj
              // if (capacity["_DriveClass"] === DriveClassValue)
              //   DATADriveCapacityoptions.push(capacity["__text"])
              if (capacity["@DriveClass"] === DriveClassValue)
                DATADriveCapacityoptions.push(capacity["#text"])
            })
            break;
        }
      })

      //Updating Values from workload to variables to render
      this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
        if (val['@Type'] === this.props.type) {
          if (Array.isArray(val.Service)) {
            val.Service.filter((service) => {
              if (service['@Type'] === this.props.title) {
                //service['@Selected']=this.props.isSelected;
                if (service['@Selected'] === "true") {
                  isMixedStorageConfiguration = service["@mixedStorage"]
                  //Hardware Selection
                  if (service.Hardware['@Server'] === "HP Apollo 4200 Gen10 Server") {
                    service.Hardware['@Server'] = "HPE Apollo 4200 Gen10 Server"
                  }
                  serverValue = service.Hardware['@Server'];
                  processorValue = service.Hardware['@Proc'];
                  if (service.Hardware['@ProcFamily'] === undefined) {
                    service.Hardware['@ProcFamily'] = "Cascade Lake"
                  }
                  processorTypeValue = service.Hardware['@ProcFamily']
                  pocQtyValue = service.Hardware['@ProcQty'];
                  datadisktypValue = service.Hardware['@DataDisk'];
                  // if(OSDiskList.indexOf(service.Hardware['@OSDisk'])===-1 )
                  // {
                  //   service.Hardware['@OSDisk']=OSDiskList[0];
                  // }
                  // osdisktypValue = service.Hardware['@OSDisk'];
                  nodesQtyValue = service.Hardware['@NodesCount'];
                  memoryValue = service.Hardware['@Memory'];
                  //noOfDiskValue = service.Hardware['@DiskQty'];
                  nodeValue = service.Hardware['@NodesQty'];
                  if (defaultNodevalueChange || service['@Type'] === Constants.DATA_LAKE && this.props.workload.UserInputs.Environments.updateDataLakeRecommendations === Constants.tRUE_) {
                    // defaultNodevalueChange=false
                    defaultNodevalue = service.Hardware['@NodesCount'];
                    if (service['@Type'] === Constants.DATA_LAKE) {
                      this.props.workload.UserInputs.Environments.updateDataLakeRecommendations = Constants.fALSE_;
                    }
                  }
                  //else{
                  //   defaultNodevalueChange=true
                  // }
                  //Storage Selection
                  if (this.props.title === Constants.DATA_LAKE || this.props.title === "MapR and MapR-EC") {
                    diskcapacityvalue = service.Inputs['@Capacity'];
                    if (parseFloat(service.Inputs['@Compression'], 10) > parseFloat(Constants.DATALAKE_COMPRESSION_MAXVLAUE, 10)){
                      service.Inputs['@Compression'] = Constants.DATALAKE_COMPRESSION_MAXVLAUE;
                      compression = service.Inputs['@Compression'];
                      let value = {
                        target : {
                          value : Constants.DATALAKE_COMPRESSION_MAXVLAUE
                        }
                      }
                      this.onCompressionBlur(value, this.props.type, this.props.title)
                    }
                    compression = service.Inputs['@Compression'];
                    ensurecodngdata = service.Inputs['@ErasureData'];
                    ensurecodngparity = service.Inputs['@ErasureParity'];
                    overhead = service.Inputs['@OverHead'];
                    strgwrkload = service.Inputs['@StorageWL'];
                    capacitytypevalue = service.Inputs['@Type'];
                    if (parseFloat(service.Inputs['@Replication'], 10) > parseFloat(Constants.DATALAKE_REPLICATION_MAXVALUE, 10)) {
                      service.Inputs['@Replication'] = Constants.DATALAKE_REPLICATION_MAXVALUE;
                      replicationvalue = Constants.DATALAKE_REPLICATION_MAXVALUE;
                      let value = {
                        target : {
                          value : Constants.DATALAKE_REPLICATION_MAXVALUE
                        }
                      }
                      onChangeTriggered = true;
                      this.onReplicationBlur(value, this.props.type, this.props.title);
                    }
                    replicationvalue = service.Inputs['@Replication'];
                    this.state.capacitytypevalueoptions = ['Raw', 'Usable capacity ']
                  }
                  else if (this.props.title === "Scality") {
                    ARCvalue = service.Inputs['@ARC'];
                    Scalitydiskcapacityvalue = service.Inputs['@Capacity'];
                    GreenLakevalue = service.Inputs['@GreenLake'];
                    Sitesvalue = service.Inputs['@NoOfSites'];
                    StoragePerc = service.Inputs['@StoragePerc'];
                    NetworkSwitchvalue = service.Inputs['@NwSwitch'];
                    Quantityvalue = service.Inputs['@NwSwitchQty'];
                    Secondsitevalue = service.Inputs['@Replication'];
                    Secondsiteoptions = ["Yes", "No"];
                    Sitesvalueoptions = ["1 (single site, most capacity)", "1 (single site, most durability)", "2 (two site stretched)", "3 (three site stretched)"];
                    Quantityoptions = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
                    GreenLakeoptions = ["Yes", "No"]

                  }
                  else if (this.props.type === 'Streaming') {
                    MessagesPerSec = service.Inputs['@MessagesPerSec'];
                  }
                  else if (this.props.type === "AI") {
                    GPUvalue = service.Inputs['@GPU'];
                    GPUQty = service.Inputs['@GPUQty'];
                    ImagesPerSec = service.Inputs['@ImagesPerSec'];
                    AIConfigtypevalue = service.Inputs['@ConfigType'];
                  }
                  else if (this.props.type === "IoT") {
                    EventsPerSec = service.Inputs['@EventsPerSec'];
                    defaultNodevalue = '1'

                  }
                  else if (this.props.type === "Analytics") {
                    Analyticsvalue = service.Inputs['@ConfigType'];
                    Ansdiskcapacityvalue = service.Inputs['@UsableCapacity'];
                    ContainersQty = service.Inputs['@ContainersQty'];
                    CoresPerContainer = service.Inputs['@CoresPerContainer'];
                    MemoryPerContainer = service.Inputs['@MemoryPerContainer'];
                    NodelocalStorageValue = service.Inputs['@NodeStorage'];
                    StorageNodesQty = service.Inputs['@StorageNodesQty'];
                    Storagevalue = service.Inputs['@SCRatio'];
                    Storagevalue1 = service.Inputs['@Storage'];
                    Storagevalue2 = service.Inputs['@Compute'];
                    StorageOptions = ["Balanced Workload", "IO intensive", "Compute Intensive", "Custom"]
                    if (this.props.title === "Spark") {
                      AnlyOptions = ["Executors", 'Storage Ratio']
                    }
                    else {
                      AnlyOptions = ["Containers", 'Storage Ratio']
                    }

                  } else if (this.props.type === "Database") {
                    QueryData = service.Inputs['@Capacity'];
                    ResponseTime = service.Inputs['@NodeStorage'];
                    if(service["@Type"]=== "HBase") {
                      if(service.Inputs['@OpsPerSec'] === undefined) {
                        service.Inputs['@OpsPerSec'] = "1"
                      } 
                    }
                    ConcurrentQueries = service.Inputs['@OpsPerSec'];
                    // DatabaseUsablecapacity = service.Inputs['@Capacity'];

                  }
                  else if (this.props.title === "Weka") {

                    Addservers = service.Inputs['@AddServers'];
                    Totalusablestorage = service.Inputs['@Capacity'];
                    DriveClassValue = service.Inputs['@DriveClass'];
                    EducationCustomer = service.Inputs['@IsEduCustomer'];

                    NetworkType = service.Inputs['@NetworkType'];
                    OSEnvironment = service.Inputs['@OS'];
                    Peakreadbandwdth = service.Inputs['@PeakReadBW'];
                    Peakreadiops = service.Inputs['@PeakReadIOPS'];

                    Peakwritebandwdth = service.Inputs['@PeakWriteBW'];
                    Peakwriteiops = service.Inputs['@PeakWriteIOPS'];
                    SKUInformationValue = service.Inputs['@SKUInfo'];
                    ServerType = service.Hardware['@Server'];
                    if (ServerType === Constants.PROLIANT_DL325_GEN10_PLUS) {
                      service.Hardware["@ProcQty"] = Constants.QTY_ONE;
                    } else {
                      service.Hardware["@ProcQty"] = Constants.QTY_TWO;
                    }
                    SupportYearCount = service.Inputs['@SupportYears'];
                    capacityrequired = service.Inputs['@TierCapacity'];
                    DIMMCapacity = service.Inputs['@DIMMCapacity'];

                    DATADriveCapacity = service.Inputs['@DATADriveCapacity'];
                    DATADrivePerServer = service.Inputs['@DATADrivePerServer'];
                    SpareServers = service.Inputs['@SpareServers'];
                    NumServers = service.Hardware['@NodesCount'];
                    DriveClassList = ['Mixed Use', 'Read Intensive']

                  }


                  //for deleting servers
                  Deleteservers = false
                  NodesQtyOptions = ["User Defined", "Sizer Recommendation"];
                  ProcFamilyList = []
                  AIConfigTypeOptions = ["Training", "Inference"]
                  this.populateGPUOptions();
                  if (GPUsOptions.indexOf(GPUvalue) === -1) {
                    GPUvalue = GPUsOptions[0]
                    service.Inputs['@GPU'] = GPUvalue;
                  }

                  EducationCustomeroptions = ["Yes", "No"];
                  Addserversoptions = ["Yes", "No"];
                  SKUInformationList = ['Customer Requirements', 'Predefined Configuration'];
                  NetworkSwitchoptions = this.props.sessions.inputs.Sizers.Sizer.OtherEnvirontmentDetails.NwSwitches.Scality.Item




                  //Sizer Recommendation
                  SizerRecmdtnServer = service.Recommendation['@Name']
                  SizerRecmdtnProcsr = service.Recommendation['@Proc']
                  SizerRecmdtnDisktype = service.Recommendation['@DataDisk']
                  SizerRecmdtnMemory = service.Recommendation['@Memory']
                }
                else {
                  //Hardware Selection
                  serverValue = ""
                  processorValue = ""
                  processorTypeValue = ""
                  pocQtyValue = ""
                  datadisktypValue = ""
                  osdisktypValue = ""
                  nodesQtyValue = ""
                  memoryValue = ""
                  noOfDiskValue = ""
                  noOfOSDiskValue = ""
                  nodeValue = ""
                  Servers = []
                  NodesQtyOptions = []
                  ProcFamilyList = []
                  AIConfigTypeOptions = []
                  GPUsOptions = []
                  AnlyOptions = []
                  //Storage Selection
                  diskcapacityvalue = ""
                  compression = ""
                  ensurecodngdata = ""
                  ensurecodngparity = ""
                  overhead = ""
                  replicationvalue = ''
                  strgwrkload = ""
                  capacitytypevalue = ""
                  this.state.capacitytypevalueoptions = []
                  ARCvalue = ""
                  Scalitydiskcapacityvalue = ''
                  GreenLakevalue = ''
                  StoragePerc = ''
                  Sitesvalue = ''
                  MessagesPerSec = ''
                  ImagesPerSec = ''
                  GPUvalue = ''
                  AIConfigtypevalue = ''
                  GPUQty = ''
                  EventsPerSec = ''
                  Sitesvalueoptions = []
                  GreenLakeoptions = []

                  Analyticsvalue = ''
                  Ansdiskcapacityvalue = ''
                  ContainersQty = ""
                  CoresPerContainer = ""
                  MemoryPerContainer = ""
                  NodelocalStorageValue = ""
                  StorageNodesQty = ''
                  StorageOptions = ""
                  Storagevalue = ''



                  QueryData = ''
                  ResponseTime = ''
                  ConcurrentQueries = ''
                  //DatabaseUsablecapacity = ""
                  EducationCustomeroptions = []
                  Addserversoptions = [];
                  SKUInformationList = [];

                  Addservers = ""
                  capacityrequired = ""
                  DriveClassValue = ""
                  EducationCustomer = ""
                  NetworkType = ""
                  OSEnvironment = ""
                  Peakreadbandwdth = ""
                  Peakreadiops = ""
                  Peakwritebandwdth = ""
                  Peakwriteiops = ""
                  SKUInformationValue = ""
                  ServerType = ""
                  SupportYearCount = ""
                  Totalusablestorage = ""
                  NetworkSwitchoptions = []
                  NetworkSwitchvalue = ""
                  Quantityvalue = ""
                  Secondsitevalue = ""
                  Secondsiteoptions = []
                  Quantityoptions = []
                  DIMMCapacity = ""
                  DATADriveCapacity = ""
                  DATADrivePerServer = ""
                  SpareServers = ""
                  NumServers = ""
                  OSEnvironmentoptions = []
                  SupportYearCountoptions = []
                  NetworkTypeoptions = []
                  DriveClassList = []

                  //for deleting servers
                  Deleteservers = true
                  //Sizer Recommendation
                  SizerRecmdtnServer = ""
                  SizerRecmdtnProcsr = ""
                  SizerRecmdtnDisktype = ""
                  SizerRecmdtnMemory = ""
                }
              }
            })
          } else {
            if (val.Service['@Type'] === this.props.title) {
              // val.Service['@Selected']=this.props.isSelected;
              if (val.Service['@Selected'] === "true") {
                isMixedStorageConfiguration = val.Service["@mixedStorage"]
                if (this.props.type === "IoT") {
                  if (val.Service.Hardware['@ServerName'] === undefined) {
                    val.Service.Hardware['@ServerName'] = "HPE ProLiant m510-16c Server Cartridge EL1000 10G 2xSFP"
                  }
                  serverValue = val.Service.Hardware['@ServerName'];
                } else {
                  serverValue = val.Service.Hardware['@Server'];
                }
                processorValue = val.Service.Hardware['@Proc'];
                if (val.Service.Hardware['@ProcFamily'] === undefined) {
                  val.Service.Hardware['@ProcFamily'] = "Cascade Lake"
                }
                processorTypeValue = val.Service.Hardware['@ProcFamily']
                pocQtyValue = val.Service.Hardware['@ProcQty'];
                datadisktypValue = val.Service.Hardware['@DataDisk'];
                //  if(OSDiskList.indexOf(val.Service.Hardware['@OSDisk'])===-1 )
                //   {
                //     val.Service.Hardware['@OSDisk']=OSDiskList[0];
                //   }
                // osdisktypValue = val.Service.Hardware['@OSDisk'];
                nodesQtyValue = val.Service.Hardware['@NodesCount'];
                memoryValue = val.Service.Hardware['@Memory'];
                nodeValue = val.Service.Hardware['@NodesQty'];
                //noOfDiskValue = val.Service.Hardware['@DiskQty'];

                //Storage Selection
                diskcapacityvalue = val.Service.Inputs['@Capacity'];
                compression = val.Service.Inputs['@Compression'];
                ensurecodngdata = val.Service.Inputs['@ErasureData'];
                ensurecodngparity = val.Service.Inputs['@ErasureParity'];
                overhead = val.Service.Inputs['@OverHead'];
                replicationvalue = val.Service.Inputs['@Replication'];
                strgwrkload = val.Service.Inputs['@StorageWL'];
                capacitytypevalue = val.Service.Inputs['@Type'];
                EventsPerSec = val.Service.Inputs['@EventsPerSec'];
                this.state.capacitytypevalueoptions = ['Raw', 'Usable capacity ']

                Deleteservers = false
                NodesQtyOptions = ["User Defined", "Sizer Recommendation"];
                ProcFamilyList = []
                AIConfigTypeOptions = ["Training", "Inference"]
                defaultNodevalue = '1'
                //Sizer Recommendation
                SizerRecmdtnServer = val.Service.Recommendation['@Name']
                SizerRecmdtnProcsr = val.Service.Recommendation['@Proc']
                SizerRecmdtnDisktype = val.Service.Recommendation['@DataDisk']
                SizerRecmdtnMemory = val.Service.Recommendation['@Memory']
                //As of now
              }
              else {

                //Hardware Selection
                serverValue = ""
                processorValue = ""
                processorTypeValue = ""
                pocQtyValue = ""
                datadisktypValue = ""
                osdisktypValue = ""
                nodesQtyValue = ""
                memoryValue = ""
                noOfDiskValue = ""
                noOfOSDiskValue = ""
                Servers = []
                //Storage Selection
                diskcapacityvalue = ""
                compression = ""
                ensurecodngdata = ""
                ensurecodngparity = ""
                overhead = ""
                replicationvalue = ''
                strgwrkload = ""
                capacitytypevalue = ""
                this.state.capacitytypevalueoptions = []
                ARCvalue = ""
                Scalitydiskcapacityvalue = ''
                GreenLakevalue = ''
                StoragePerc = ''
                Sitesvalue = ''
                EventsPerSec = ''
                NodesQtyOptions = [];
                ProcFamilyList = []
                AIConfigTypeOptions = []

                Deleteservers = true
                //Sizer Recommendation
                SizerRecmdtnServer = ""
                SizerRecmdtnProcsr = ""
                SizerRecmdtnDisktype = ""
                SizerRecmdtnMemory = ""
              }
            }
          }

        }
      })
      if (this.props.defaultSizerWorkload.serversList !== "" && this.props.defaultSizerWorkload.serversList !== undefined && this.props.defaultSizerWorkload.serversList !== null) {
        this.props.defaultSizerWorkload.serversList.map((ServiceName) => {
          if (ServiceName.serviceName === this.props.title && ServiceName.Servers !== '') {
            this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
              if (val['@Type'] === this.props.type) {
                if (Array.isArray(val.Service)) {
                  val.Service.filter((service) => {
                    if (service['@Type'] === this.props.title) {
                      if (service['@Selected'] === "true") {
                        for (let key in ServiceName.totalList) {
                          if (key === serverValue) {
                            if (IDatadiskqtynotchange && parseInt(noOfDiskValue, 10) < ServiceName.totalList[key].iDataDiskQty) {
                              noOfDiskValue = ServiceName.totalList[key].iDataDiskQty.toString();
                              service.Hardware['@DiskQty'] = noOfDiskValue
                            } else {
                              noOfDiskValue = service.Hardware['@DiskQty'];
                            }
                            if (IOSDatadiskqtynotchange && parseInt(noOfOSDiskValue, 10) < ServiceName.totalList[key].iOSDiskQty) {

                              noOfOSDiskValue = ServiceName.totalList[key].iOSDiskQty.toString();
                              service.Hardware['@OSDiskQty'] = noOfOSDiskValue
                            } else {
                              noOfOSDiskValue = service.Hardware['@OSDiskQty'];
                            }
                            MaxDriveQty = ServiceName.totalList[key].iMaxDrives
                          }
                          if ((this.props.type === "Streaming" || this.props.type === "Analytics" || this.props.type === "Database") && (serverValue === "Synergy 480 Gen10 Server")) {

                            if (this.props.title === "Yarn" && YarnSynergyServerChanged) {
                              YarnSynergyServerChanged = false
                              service.Hardware['@DiskQty'] = "4"
                              noOfDiskValue = "4"
                            }
                            if (this.props.title === "Spark" && SparkAnalyticsSynergyServerChanged) {
                              SparkAnalyticsSynergyServerChanged = false
                              service.Hardware['@DiskQty'] = "4"
                              noOfDiskValue = "4"
                            }

                            if (SparkSynergyServerChanged && this.props.title === "Spark Streaming") {
                              SparkSynergyServerChanged = false
                              service.Hardware['@DiskQty'] = "4"
                              noOfDiskValue = "4"
                            }
                            if (KafkaSynergyServerChanged && this.props.title === "Kafka") {
                              KafkaSynergyServerChanged = false
                              service.Hardware['@DiskQty'] = "4"
                              noOfDiskValue = "4"
                            }
                            if (FlinkSynergyServerChanged && this.props.title === "Flink") {
                              FlinkSynergyServerChanged = false
                              service.Hardware['@DiskQty'] = "4"
                              noOfDiskValue = "4"
                            }
                            if (StormSynergyServerChanged && this.props.title === "Storm") {
                              StormSynergyServerChanged = false
                              service.Hardware['@DiskQty'] = "4"
                              noOfDiskValue = "4"
                            }
                            if (HiveSynergyServerChanged && this.props.title === "Hive") {
                              HiveSynergyServerChanged = false
                              service.Hardware['@DiskQty'] = "4"
                              noOfDiskValue = "4"
                            }
                            if (CassandraSynergyServerChanged && this.props.title === "Cassandra") {
                              CassandraSynergyServerChanged = false
                              service.Hardware['@DiskQty'] = "4"
                              noOfDiskValue = "4"
                            }
                            if (ImpalaSynergyServerChanged && this.props.title === "Impala") {
                              ImpalaSynergyServerChanged = false
                              service.Hardware['@DiskQty'] = "4"
                              noOfDiskValue = "4"
                            }
                            if (HBaseSynergyServerChanged && this.props.title === "HBase") {
                              HBaseSynergyServerChanged = false
                              service.Hardware['@DiskQty'] = "4"
                              noOfDiskValue = "4"
                            }

                          }
                        }
                      }
                    }
                  })
                }
                else {

                  if (val.Service['@Type'] === this.props.title) {
                    if (val.Service['@Selected'] === "true") {
                      for (let key in ServiceName.totalList) {
                        if (key === serverValue) {

                          if (IDatadiskqtynotchange && parseInt(noOfDiskValue, 10) < ServiceName.totalList[key].iDataDiskQty) {

                            noOfDiskValue = ServiceName.totalList[key].iDataDiskQty.toString();
                            val.Service.Hardware['@DiskQty'] = noOfDiskValue
                          } else {
                            noOfDiskValue = val.Service.Hardware['@DiskQty'];
                          }
                          if (IOSDatadiskqtynotchange && parseInt(noOfOSDiskValue, 10) < ServiceName.totalList[key].iOSDiskQty) {

                            noOfOSDiskValue = ServiceName.totalList[key].iOSDiskQty.toString();
                            val.Service.Hardware['@OSDiskQty'] = noOfOSDiskValue
                          } else {
                            noOfOSDiskValue = val.Service.Hardware['@OSDiskQty'];
                          }
                          MaxDriveQty = ServiceName.totalList[key].iMaxDrives
                        }

                      }
                    }
                  }

                }
              }
            })
          }
        })
        //if (maxlayer) {
        if (this.props.title === Constants.DATA_LAKE || this.props.title === "Hive" || this.props.title === "Spark Streaming" || this.props.title === "Yarn" || this.props.title === "Tensorflow" || this.props.title === "MiNifi") {
          if (maxlayer) {
            layerSecondService = ""
            layerThirdService = ""
            layerFourthService = ""
            layer = <Layer style={{ zIndex: '500 !important' }}>
              <Box direction="row" margin="none" separator="bottom" style={{ padding: "none", backgroundColor: "#425563" }} >
                <Box direction="row" margin="none" pad="none" align='start' style={{ width: '96%', padding: "10px", color: "#fff" }}>
                  <Heading tag="h4" strong={true} style={{ marginBottom: '0px' }}>Error</Heading>
                </Box>
                <Box direction="row" style={{ marginTop: "10px", padding: "5px" }} margin="none" pad="none" align='start' alignContent="start" onClick={this.layerclose} >
                  <CloseIcon size='small' colorIndex="light-2" style={{ stroke: 'white' }} />
                </Box>
              </Box>
              <Box style={{ padding: "10px" }}>
          <Paragraph>Disk Quantity requested exceeds the limit of {maxDrivesSupported} for the selected server.</Paragraph>
              </Box>
            </Layer>
          }
        }
        if (this.props.title === "Scality" || this.props.title === "Cassandra" || this.props.title === "Kafka" || this.props.title === "Spark" || this.props.title === "PyTorch") {
          if (maxlayerSecondServices) {
            layer = ""
            layerThirdService = ""
            layerFourthService = ""
            layerSecondService = <Layer style={{ zIndex: '500 !important' }}>
              <Box direction="row" margin="none" separator="bottom" style={{ padding: "none", backgroundColor: "#425563" }} >
                <Box direction="row" margin="none" pad="none" align='start' style={{ width: '96%', padding: "10px", color: "#fff" }}>
                  <Heading tag="h4" strong={true} style={{ marginBottom: '0px' }}>Error</Heading>
                </Box>
                <Box direction="row" style={{ marginTop: "10px", padding: "5px" }} margin="none" pad="none" align='start' alignContent="start" onClick={this.layerclose} >
                  <CloseIcon size='small' colorIndex="light-2" style={{ stroke: 'white' }} />
                </Box>
              </Box>
              <Box style={{ padding: "10px" }}>
                <Paragraph>Disk Quantity requested exceeds the limit for the selected server.</Paragraph>
              </Box>
            </Layer>
          }
        }
        if (this.props.title === "Impala" || this.props.title === "Flink") {
          if (maxlayerthirdServices) {
            layer = ""
            layerSecondService = ""
            layerFourthService = ""
            layerThirdService = <Layer style={{ zIndex: '500 !important' }}>
              <Box direction="row" margin="none" separator="bottom" style={{ padding: "none", backgroundColor: "#425563" }} >
                <Box direction="row" margin="none" pad="none" align='start' style={{ width: '96%', padding: "10px", color: "#fff" }}>
                  <Heading tag="h4" strong={true} style={{ marginBottom: '0px' }}>Error</Heading>
                </Box>
                <Box direction="row" style={{ marginTop: "10px", padding: "5px" }} margin="none" pad="none" align='start' alignContent="start" onClick={this.layerclose} >
                  <CloseIcon size='small' colorIndex="light-2" style={{ stroke: 'white' }} />
                </Box>
              </Box>
              <Box style={{ padding: "10px" }}>
                <Paragraph>Disk Quantity requested exceeds the limit for the selected server.</Paragraph>
              </Box>
            </Layer>
          }
        }
        if (this.props.title === "HBase" || this.props.title === "Storm") {
          if (maxlayerFourthServices) {
            layer = ""
            layerSecondService = ""
            layerThirdService = ""
            layerFourthService = <Layer style={{ zIndex: '500 !important' }}>
              <Box direction="row" margin="none" separator="bottom" style={{ padding: "none", backgroundColor: "#425563" }} >
                <Box direction="row" margin="none" pad="none" align='start' style={{ width: '96%', padding: "10px", color: "#fff" }}>
                  <Heading tag="h4" strong={true} style={{ marginBottom: '0px' }}>Error</Heading>
                </Box>
                <Box direction="row" style={{ marginTop: "10px", padding: "5px" }} margin="none" pad="none" align='start' alignContent="start" onClick={this.layerclose} >
                  <CloseIcon size='small' colorIndex="light-2" style={{ stroke: 'white' }} />
                </Box>
              </Box>
              <Box style={{ padding: "10px" }}>
                <Paragraph>Disk Quantity requested exceeds the limit for the selected server.</Paragraph>
              </Box>
            </Layer>
          }
        }

        //}

      }

    }

    //Replication Changes
    let ReplicationData = "";
    if (this.props.title === "Scality" || this.props.title === Constants.DATA_LAKE || this.props.title === "MapR and MapR-EC") {
      if (this.props.title === Constants.DATA_LAKE) {
        this.props.defaultSizerWorkload.StorageCapacitytype.HDFS = capacitytypevalue;
      } else if (this.props.title === "MapR and MapR-EC") {
        this.props.defaultSizerWorkload.StorageCapacitytype.MAPR = capacitytypevalue;
      }
      if (this.props.erasureHDFS || this.props.erasureMAPR) {
        ReplicationData = <Box direction="row" pad={{ between: 'small' }} style={{width:'33%'}}>
          <ReactTooltip place="right" multiline={true} />
          <FormField className="DiskCapacityDetails" label='DATA' error="(3-10)" style={{width:'150%'}}>
            <Box direction="row">
              <TextInput id='StoraegWorkload' value={ensurecodngdata} onDOMChange={(e) => this.onEnsuredataCahnge(e, this.props.type, this.props.title)} onBlur={(e) => this.onEnsuredataBlur(e, this.props.type, this.props.title)} />
              <CircleInformation data-tip="For Erasure Coding, the number of data fragments must be greater than or equal to 3 and less than or equal to 10." colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} />
            </Box>
          </FormField>
          <FormField className="DiskCapacityDetails" label='PARITY'>
            <Box direction="row">
              <TextInput id='StoraegWorkload' value={ensurecodngparity} onDOMChange={(e) => this.onEnsureParityCahnge(e, this.props.type, this.props.title)} onBlur={(e) => this.onEnsureParityBlur(e, this.props.type, this.props.title)} />
              <CircleInformation data-tip="For Erasure Coding, the number of parity fragments must be greater than 1 and less than (not equal to) the number of data fragments." colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} />
            </Box>
          </FormField>
        </Box>
      } else {
        if (this.props.title === "Scality") {
          ReplicationData = '';
        } else {
          if (capacitytypevalue === "Raw") {
            forRawdisabled = true
          } else {
            forRawdisabled = false
          }
          ReplicationData = <Box style={{ width: '33%' }}>
            <FormField className="DiskCapacityDetails" style={{ height: '100%' }} label='Replication' error={`(${Constants.DATALAKE_REPLICATION_MINVALUE }-${Constants.DATALAKE_REPLICATION_MAXVALUE})`}>
              <Box direction="row">
                <TextInput id='StoraegWorkload' value={replicationvalue} disabled={forRawdisabled} onDOMChange={(e) => this.onReplicationCahnge(e, this.props.type, this.props.title)} onBlur={(e) => this.onReplicationBlur(e, this.props.type, this.props.title)} />
                <ReactTooltip place="right" multiline={true} id={Constants.REPLICATION_}/>
                <CircleInformation data-tip="Number of replicas to store." data-for={Constants.REPLICATION_} colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} />
              </Box>
            </FormField>
          </Box>
        }

      }
    } else {
      ReplicationData = <Box style={{ width: '33%' }}>
        <FormField className="DiskCapacityDetails" style={{ height: '100%' }} label='Replication' error="(1.0-99.99%)">
          <Box direction="row">
            <TextInput id='StoraegWorkload' value={ensurecodngdata} />
            <CircleInformation data-tip={Constants.Replication} colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} />
          </Box>
        </FormField>
      </Box>

    }
    var serviceselectedHive = false
    this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
      if (val['@Type'] === this.props.type) {
        if (Array.isArray(val.Service)) {
          val.Service.filter((service) => {
            if (service['@Type'] === "Hive") {
              if (service['@Selected'] === "true") {
                serviceselectedHive = true
              }
            }
          })
        }
      }
    })
    var HiveLayerrdata = ''
    if (serverValue === "ProLiant XL170r Gen10" && serviceselectedHive) {
      let text = " "
      let note = <Label style={{ fontWeight: '600', fontSize: 'medium' }}>  NOTE :</Label>
      text = <Label style={{ fontWeight: '600', fontSize: 'medium' }}>  1 Node</Label>
      HiveLayerrdata = <Box >
        <Paragraph style={{ fontWeight: '600', marginBottom: '0px' }}> {note} {"Recommended Number of HDFS nodes with 24 SAS/SATA drives :"}{text}</Paragraph>
      </Box>
    }
    if (ShowHiveLayer && this.props.StringMessage !== undefined && this.props.StringMessage !== null && this.props.StringMessage !== '' && serviceselectedHive) {
      let DriveText = []
      DriveText = this.props.StringMessage.split(":")
      let text = " "
      let note = <Label style={{ fontWeight: '600', fontSize: 'medium' }}>  NOTE :</Label>
      text = <Label style={{ fontWeight: '600', fontSize: 'medium' }}> {DriveText[1]}</Label>
      HiveLayerrdata = <Box >
        <Paragraph style={{ fontWeight: '600', marginBottom: '0px' }}> {note}{" Recommended Number of HDFS nodes with 24 SAS/SATA drives :"} {text}</Paragraph>
      </Box>
    }
    //Storage Selection is applicable only for Storge and Analytics
    let StorageSelection = " ";
    if (this.props.type === "Storage" & this.props.title !== "Weka" & this.props.title !== "Scality") {
      if (capacitytypevalue === "Raw") {
        forRawdisabled = true
      } else {
        forRawdisabled = false
      }
      StorageSelection = <Box margin="none" justify='between' >
        <Heading tag='h5' strong={true} margin='none'>Storage capacity</Heading>
        <Box style={{ padding: "10px", overflow: 'auto', width: '95%' }} pad={{ between: 'small' }} >
          <ReactTooltip place="right" multiline={true} />
          <Box direction='row' pad={{ between: 'small', width:'100%' }}>
            <FormField className="DiskCapacityDetails" label='Disk Capacity (TB)' error="(1-999999)" style={{ overflow: "hidden", width:'32.5%' }}>
              <Box direction='row'>
                <TextInput id='StoraegWorkload' placeHolder='None' value={diskcapacityvalue} onDOMChange={(e) => this.onDiskCapacityChange(e, this.props.type, this.props.title)} onBlur={(e) => this.onDiskCapacityBlur(e, this.props.type, this.props.title)} />
                <CircleInformation data-tip={Constants.DiskCapacity} colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} />
              </Box>
            </FormField>
            <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>CapacityType</Paragraph>
              <CircleInformation data-tip={Constants.CapacityType} colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>} style={{ overflow: "hidden", width : '32.5%' }}>
              <Select placeHolder='None' value={capacitytypevalue} options={this.state.capacitytypevalueoptions} onChange={(e) => this.oncapacitytypevalueChange(e, this.props.type, this.props.title)} />
            </FormField>
            {capacitytypevalue !== Constants.RAW_ &&
            <FormField className="DiskCapacityDetails" label='Overhead' error="(0-100%)" style={{ width:'32.5%' }}>
              <Box direction="row">
                <TextInput id='StoraegWorkload' placeHolder='None' disabled={forRawdisabled} value={overhead} onDOMChange={(e) => this.onOverheadChange(e, this.props.type, this.props.title)} onBlur={(e) => this.onOverheadBlur(e, this.props.type, this.props.title)} />
                <ReactTooltip place="left" multiline={true} id={Constants.OVERHEAD_} />
                <CircleInformation data-tip={Constants.Overhead} data-for={Constants.OVERHEAD_} colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} />
              </Box>
            </FormField>}
          </Box>
          {capacitytypevalue !== Constants.RAW_ &&
          <Box direction='row' pad={{ between: 'small' }}>
            <Box direction='row' style={{ width: '32.5%' }} pad={{ between: 'small' }}>
              <FormField className="DiskCapacityDetails" label='Compression' error={`(${Constants.DATALAKE_COMPRESSION_MINVLAUE}-${Constants.DATALAKE_COMPRESSION_MAXVLAUE})`}>
                <Box direction="row">
                  <TextInput id='StoraegWorkload' placeHolder='None' disabled={forRawdisabled} value={compression} onDOMChange={(e) => this.onCompressionChange(e, this.props.type, this.props.title)} onBlur={(e) => this.onCompressionBlur(e, this.props.type, this.props.title)} />
                  <CircleInformation data-tip={Constants.Compression} colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} />
                </Box>
              </FormField>
            </Box>
            {ReplicationData}
          </Box>
          }
          {/*} <Box direction='row'  pad={{ between: 'small' }}>
              {AnalyticsComputeResources}
              </Box> */}
        </Box>
      </Box>
    } else if (this.props.type === "Storage" & this.props.title === "Scality") {
      StorageSelection = <Box margin="none" justify='between' >
        <Heading tag='h5' strong={true} margin='none'>Storage capacity</Heading>
        <Box style={{ padding: "10px", overflow: 'auto', width: '95%' }} pad={{ between: 'small' }} >
          <Box direction='row' pad={{ between: 'small' }}>
            <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Select Green Lake Flex Capacity</Paragraph>
              <CircleInformation data-tip={Constants.Select_Green_Lake_Flex_Capacity} colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>} style={{ overflow: "hidden", width: '62%' }}>
              <Select placeHolder='None' value={GreenLakevalue} options={GreenLakeoptions} onChange={(e) => this.onGreenLakeChange(e, this.props.type, this.props.title)} />
            </FormField>
            <FormField className="DiskCapacityDetails" label='How many sites do you want your primary data stored in?' >
              <Select placeHolder='None' value={Sitesvalue} options={Sitesvalueoptions} onChange={(e) => this.onSitesvalueChange(e, this.props.type, this.props.title)} />
            </FormField>
          </Box>
          <Box direction='row' pad={{ between: 'small' }}>
            <Box direction='row' style={{ width: '100%' }} pad={{ between: 'small' }}>
              <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Replication to a second site</Paragraph>
                <CircleInformation data-tip={Constants.Replication_to_a_second_site} colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>}>
                <Select placeHolder='None' value={Secondsitevalue} options={Secondsiteoptions} onChange={(e) => this.onSecondsitevalueChange(e, this.props.type, this.props.title)} />
              </FormField>
              <FormField className="DiskCapacityDetails" label='Percent of storage containing ARC encoded objects' style={{ overflow: "hidden" }}>
                <TextInput id='StoraegWorkload' placeHolder='None' value={StoragePerc} onDOMChange={(e) => this.onStoragePercChange(e, this.props.type, this.props.title)} onBlur={(e) => this.onStoragePercChange(e, this.props.type, this.props.title, "Blur")} />
              </FormField>
              <FormField className="DiskCapacityDetails" label='Disk Capacity (TB)' style={{ width: '41%' }}>
                <Box direction="row">
                  <TextInput id='StoraegWorkload' placeHolder='None' value={Scalitydiskcapacityvalue} onDOMChange={(e) => this.onScalitydiskcapacityvalue(e, this.props.type, this.props.title)} onBlur={(e) => this.onScalitydiskcapacityvalueBlur(e, this.props.type, this.props.title)} />
                </Box>
              </FormField>
            </Box>
          </Box>
          <Box direction='row' pad={{ between: 'small' }}>
            <FormField className="DiskCapacityDetails" label='calculated ARC(X,Y) level' style={{ overflow: "hidden", width: '57%' }}>
              <Box direction='row' >
                <TextInput id='StoraegWorkload' placeHolder='None' value={ARCvalue} />
                <CircleInformation data-tip={Constants.calculated_ARC_level} colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} />
              </Box>
            </FormField>

            <FormField className="DiskCapacityDetails" label="Network Switch">
              <Select placeHolder='None' value={NetworkSwitchvalue} options={NetworkSwitchoptions} onChange={(e) => this.onNetworkSwitchvalueChange(e, this.props.type, this.props.title)} />
            </FormField>
            <FormField className="DiskCapacityDetails" label="No. of Network Switches">
              <Select placeHolder='None' value={Quantityvalue} options={Quantityoptions} onChange={(e) => this.onQuantityvalueChange(e, this.props.type, this.props.title)} />
            </FormField>

          </Box>

          {ReplicationData}
        </Box>
      </Box>
    }
    else if (this.props.type === "Analytics") {

      // let AnlyOptions = [];
      // if (this.props.title === "Spark") {
      //   AnlyOptions = ["Executors", 'Storage Ratio']
      // }
      // else {
      //   AnlyOptions = ["Containers", 'Storage Ratio']
      // }

      let Info = ' ';
      Storagevalue1disabled = true
      Storagevalue2disabled = true
      if (Storagevalue === "Custom") {
        Storagevalue1disabled = false;
        Storagevalue2disabled = false;
        Info = "These workloads are distributed based on the custom ratio provided."
      }
      else if (Storagevalue === "Balanced Workload") {
        Storagevalue1 = '1'
        Storagevalue2 = '2'
        Info = 'These workloads are distributed equally across the various job types (CPU bound, Disk I/O bound, or Network I/O bound)'
      }
      else if (Storagevalue === "IO intensive") {
        Storagevalue1 = '1'
        Storagevalue2 = '1'
        Info = 'These workload relies more on the I/O bound capacity of the cluster.'
      }
      else if (Storagevalue === "Compute Intensive") {
        Storagevalue1 = '1'
        Storagevalue2 = '3'
        Info = 'These workloads are CPU bound and are characterized by the need of a large number of CPUs and large amounts of memory to store in-process data.'
      }

      let Containerdisplay = ''
      let forFlinkandStrom = ''
      if ((this.props.title === "Spark" || this.props.title === "Yarn")) {
        forFlinkandStrom = <Box direction='row' pad={{ between: 'small' }} style={{ width: '70%' }}>
          <FormField className="DiskCapacityDetails" label="Configuration Based on" style={{ overflow: "hidden" }}>
            <Select id='StoraegWorkload' placeHolder='None' value={Analyticsvalue} options={AnlyOptions} onChange={(e) => this.ContainerdisplayChange(e, this.props.type, this.props.title)} />
          </FormField>
          <FormField className="DiskCapacityDetails" label='Node Local Storage (TB)' error='(1-999)' style={{ overflow: "hidden" }}>
            <Box direction="row">
              <TextInput id='StoraegWorkload' placeHolder='None' value={NodelocalStorageValue} onDOMChange={(e) => this.onNodelocalStorageValueChange(e, this.props.type, this.props.title)} onBlur={(e) => this.onNodelocalStorageValueChangeBlur(e, this.props.type, this.props.title)} />
              <CircleInformation data-tip="Total Disk storage needed on the local nodes. Number of local SSD drives needed for configuration." colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} />
            </Box>
          </FormField>
        </Box>

      }
      let AnInfo = ''
      if (Analyticsvalue === 'Containers') {
        AnInfo = "Number of Total YARN containers for the cluster";
      } else {
        AnInfo = "Number of Spark Executors";
      }

      if ((Analyticsvalue === 'Containers' || Analyticsvalue === 'Executors') && (this.props.title === "Spark" || this.props.title === "Yarn")) {
        Containerdisplay = <Box direction='row' pad={{ between: 'small' }} style={{ width: '90%', padding: '10px' }}>
          <ReactTooltip place="right" multiline={true} />
          <FormField className="DiskCapacityDetails" label={'Number of ' + Analyticsvalue} error='(1-999)' style={{ overflow: "hidden" }}>
            <Box direction='row'>
              <TextInput id='StoraegWorkload' placeHolder='None' value={ContainersQty} onDOMChange={(e) => this.onContainersQtyChange(e, this.props.type, this.props.title)} onBlur={(e) => this.onContainersQtyChange(e, this.props.type, this.props.title, "Blur")} />
              <CircleInformation data-tip={AnInfo} colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} />
            </Box>
          </FormField>
          <FormField className="DiskCapacityDetails" label={'Cores Per  ' + Analyticsvalue} style={{ overflow: "hidden" }}>
            <Box direction='row'>
              <TextInput id='StoraegWorkload' placeHolder='None' value={CoresPerContainer} onDOMChange={(e) => this.onCoresPerContainerChange(e, this.props.type, this.props.title)} onBlur={(e) => this.onCoresPerContainerChange(e, this.props.type, this.props.title, "Blur")} />
              <CircleInformation data-tip="No. of virtual CPU cores per container" colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} />
            </Box>
          </FormField>
          <FormField className="DiskCapacityDetails" label={'Memory Per  ' + Analyticsvalue + ' (GB)'} style={{ overflow: "hidden" }}>
            <Box direction='row'>
              <TextInput id='StoraegWorkload' placeHolder='None' value={MemoryPerContainer} onDOMChange={(e) => this.onMemoryPerContainerChange(e, this.props.type, this.props.title)} onBlur={(e) => this.onMemoryPerContainerChange(e, this.props.type, this.props.title, "Blur")} />
              <CircleInformation data-tip="Amount of virtual memory per Map/Reduce task (in GB)" colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} />
            </Box>
          </FormField>

        </Box>


      }
      else if (Analyticsvalue === 'Storage Ratio' && (this.props.title === "Spark" || this.props.title === "Yarn")) {
        Containerdisplay = <Box direction='row' pad={{ between: 'small' }} style={{ padding: '10px', width: '90%' }}>
          <Box direction='row' pad={{ between: 'small' }} style={{ width: '90%' }}>
            <FormField className="DiskCapacityDetails" label='Number of Storage Nodes' error='(1-999)' style={{ overflow: "hidden" }}>
              <TextInput id='StoraegWorkload' placeHolder='None' value={StorageNodesQty} onDOMChange={(e) => this.onStorageNodesQtyChange(e, this.props.type, this.props.title)} onBlur={(e) => this.onStorageNodesQtyChange(e, this.props.type, this.props.title, "Blur")} />
            </FormField>
            <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Storage to Compute Ratio</Paragraph>
              <ReactTooltip multiline={true} place="right" id={Constants.STORAGE_TO_COMPUTE_RATIO}/>
              <CircleInformation data-tip={Info} data-for={Constants.STORAGE_TO_COMPUTE_RATIO} colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>} style={{ overflow: "hidden" }}>
              <Select id='StoraegWorkload' placeHolder='None' value={Storagevalue} options={StorageOptions} onChange={(e) => this.onStorageOptionsChange(e, this.props.type, this.props.title)} />
            </FormField>
            <Box direction='row' pad={{ between: 'small' }} style={{ width: '50%' }}>
              <TextInput className='Storageanalytics' value={Storagevalue1} disabled={Storagevalue1disabled} onDOMChange={(e) => this.onStoragevalueCahnge(e, "value1", this.props.type, this.props.title)} onBlur={(e) => this.onStoragevalueCahngeBlur(e, "value1", this.props.type, this.props.title, "Blur")} />
              <Paragraph className='StorageanalyticsColon'>:</Paragraph>
              <TextInput className='Storageanalytics' value={Storagevalue2} disabled={Storagevalue2disabled} onDOMChange={(e) => this.onStoragevalueCahnge(e, "value2", this.props.type, this.props.title)} onBlur={(e) => this.onStoragevalueCahngeBlur(e, "value2", this.props.type, this.props.title, "Blur")} />
            </Box>
          </Box>
        </Box>




      }
      StorageSelection = <Box margin="none" justify='between' >
        <ReactTooltip place="right" multiline={true} />
        <Heading tag='h5' strong={true} margin='none'>Storage capacity</Heading>
        <Box direction='row' style={{ padding: "10px", overflow: 'auto', width: '95%' }} pad={{ between: 'small' }} >
          <Box direction='row' pad={{ between: 'small' }} style={{ width: '95%' }}>
            <FormField className="DiskCapacityDetails" label='HDFS Data Size' error="(1-999)" style={{ overflow: "hidden", width: '50%', display: "none" }}>
              <Box direction='row'>
                <TextInput id='StoraegWorkload' placeHolder='None' value={Ansdiskcapacityvalue} onDOMChange={(e) => this.onAnsdiskcapacityvalue(e, this.props.type, this.props.title)} onBlur={(e) => this.onAnsdiskcapacityvalue(e, this.props.type, this.props.title)} />
                <CircleInformation data-tip="Additional storage will be added to HDFS service." colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} />
              </Box>
            </FormField>
            {forFlinkandStrom}
          </Box>
        </Box>
        {Containerdisplay}
      </Box>
    }
    else if (this.props.type === "Database") {
      //let OPSlabel='Operations Per Sec'
      let OPSlabel = 'Queries Per Minute'
      let OPSdiabled = "none"
      let Hivedisabled="none"
      let HiveError="(1-999999)"
      let wdth="33%" 
      if (this.props.title === 'Hive') {
        OPSlabel = 'Queries Per Minute'
        OPSdiabled = "visible"
        OPSminvalue = '1'
        Hivedisabled="visible"
      } else if(this.props.title === 'HBase'){
        OPSlabel = 'Operations per Sec(In Thousands)'
        OPSdiabled = "visible" 
        OPSminvalue = '1'
        HiveError="(1-999999)"
         HiveLayerrdata = ''
         wdth="45%" 
      }
        else {
        HiveLayerrdata = ''
      }
      StorageSelection = <Box margin="none" justify='between' >
        <ReactTooltip place="right" multiline={true} />
        <Box style={{ padding: "10px", overflow: 'auto', width: '95%' }} pad={{ between: 'small' }} >
          <Box direction='row' pad={{ between: 'small' }}>
            <FormField className="DiskCapacityDetails" label={OPSlabel} error={HiveError} style={{ overflow: "hidden", display: OPSdiabled, width: wdth }} >
              <Box direction="row">
                <TextInput id='StoraegWorkload' placeHolder='None' value={ConcurrentQueries} onDOMChange={(e) => this.onConcurrentQueriesChange(e, this.props.type, this.props.title)} onBlur={(e) => this.onConcurrentQueriesChange(e, this.props.type, this.props.title, "Blur")} min={OPSminvalue}/>
                <CircleInformation data-tip="Number of operations to be performed." colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} />
              </Box>
            </FormField>
            <FormField className="DiskCapacityDetails" label='Database Size (TB)' error="(1-999)" style={{ overflow: "hidden", display: Hivedisabled, width: "33%" }}>
              <Box direction="row">
                <TextInput id='StoraegWorkload' placeHolder='None' value={QueryData} onDOMChange={(e) => this.onQueryDataChange(e, this.props.type, this.props.title)} onBlur={(e) => this.onQueryDataChange(e, this.props.type, this.props.title, "Blur")} />
                <CircleInformation data-tip="Additional Storage will be added to HDFS service." colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} />
              </Box>
            </FormField>
            <FormField className="DiskCapacityDetails" label='Node Local Storage (TB)' error="(1-999)" style={{ width: "33%" }}>
              <Box direction="row">
                <TextInput id='StoraegWorkload' placeHolder='None' value={ResponseTime} onDOMChange={(e) => this.onResponseTimeChange(e, this.props.type, this.props.title)} onBlur={(e) => this.onResponseTimeChange(e, this.props.type, this.props.title, "Blur")} />
                <CircleInformation data-tip="Total disk storage needed on the local nodes. Number of local drive storage (SSD) needed for the configuration." colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} />
              </Box>
            </FormField>
          </Box>
          {HiveLayerrdata}
        </Box>
      </Box>

    } else if (this.props.type === "Streaming") {
      StorageSelection = <Box margin="none" justify='between' >
        <ReactTooltip place="right" multiline={true} />
        <Box style={{ padding: "10px", overflow: 'auto', width: '48%' }} pad={{ between: 'small' }} >
          <Box direction='row' pad={{ between: 'small' }}>
            <FormField className="DiskCapacityDetails" label='Thousands of Message (Message size 250 bytes)' error="(0-99999)" style={{ overflow: "hidden" }}>
              <Box direction="row">
                <ReactTooltip place="right" multiline={true} />
                <TextInput id='StoraegWorkload' placeHolder='None' value={MessagesPerSec} onDOMChange={(e) => this.onMessagesPerSecChange(e, this.props.type, this.props.title)} onBlur={(e) => this.onMessagesPerSecChange(e, this.props.type, this.props.title, "Blur")} />
                <CircleInformation data-tip="Number of messages to be processed in thousands." colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} />
              </Box>
            </FormField>
          </Box>
        </Box>
      </Box>
    } else if (this.props.type === "AI") {
      // this.props.defaultSizerWorkload.serversList.map((ServiceName) => {
      //   if (ServiceName.serviceName === this.props.title && ServiceName.Servers !== '') {
      //     for (let key in ServiceName.totalList) {
      //       if (key === serverValue) {
      //         GPUsOptions = ServiceName.totalList[key].GPUList
      //       }
      //     }
      //   }
      // })
      StorageSelection = <Box margin="none" justify='between' >
        <ReactTooltip place="right" multiline={true} />
        <Box style={{ padding: "10px", overflow: 'auto', width: '95%' }} pad={{ between: 'small' }} >
          <Box direction='row' pad={{ between: 'small' }}>
            <FormField className="DiskCapacityDetails" label='Processing Images per Sec' error='(0-999999)' style={{ overflow: "hidden", width: '53%' }}>
              <Box direction="row">
                <TextInput id='StoraegWorkload' placeHolder='None' value={ImagesPerSec} onDOMChange={(e) => this.onImagesPerSecChange(e, this.props.type, this.props.title)} onBlur={(e) => this.onImagesPerSecChange(e, this.props.type, this.props.title, "Blur")} />
                <CircleInformation data-tip="Number of images need to be processed." colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} />
              </Box>
            </FormField>
            <FormField className="DiskCapacityDetails" label='Configuration Type' style={{ width: '32%' }} >
              <Select id='StoraegWorkload' placeHolder='None' value={AIConfigtypevalue} options={AIConfigTypeOptions} onChange={(e) => this.onAIConfigtypevalueChange(e, this.props.type, this.props.title)} />
            </FormField>
            <FormField className="DiskCapacityDetails" label='GPUs' style={{ width: '33%' }}  >
              <Select id='StoraegWorkload' placeHolder='None' value={GPUvalue} options={GPUsOptions} onChange={(e) => this.onGPUvalueChange(e, this.props.type, this.props.title)} />
            </FormField>
            <FormField className="DiskCapacityDetails" label='No. of GPUs' style={{ overflow: "hidden", width: '23%' }}>
              <Box direction="row">
                <TextInput id='StoraegWorkload' placeHolder='None' disabled="true" value={GPUQty} />
                <CircleInformation data-tip="Number of GPUs need to be configured" colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} />
              </Box>
            </FormField>
          </Box>
        </Box>
      </Box>
    }
    else if (this.props.type === "IoT") {
      StorageSelection = <Box margin="none" justify='between' >

        <Box style={{ padding: "10px", overflow: 'auto', width: '33%' }} pad={{ between: 'small' }} >
          <Box direction='row' pad={{ between: 'small' }}>
            <FormField className="DiskCapacityDetails" label='Thousands of Events Per Sec' style={{ overflow: "hidden" }}>
              <Box direction="row">
                <TextInput id='StoraegWorkload' placeHolder='None' value={EventsPerSec} onDOMChange={(e) => this.onEventsPerSecChange(e, this.props.type, this.props.title, "Change")} onBlur={(e) => this.onEventsPerSecChange(e, this.props.type, this.props.title, "Blur")} />
                <CircleInformation data-tip="Process thousands of events per sec" colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} />
              </Box>
            </FormField>
          </Box>
        </Box>
      </Box>
    }

    var Wekaoptional = ''
    var Wekaoptionalone = ''
    if (SKUInformationValue === 'Predefined Configuration') {
      Wekaoptionalone = <Box direction='row' pad={{ between: 'small' }} style={{ width: '71%' }}>
        <FormField className="DiskCapacityDetails" label='DIMM Capacity(GB)' style={{ width: '41%' }}>
          <Select placeHolder='None' value={DIMMCapacity} options={DIMMCapacityoptions} onChange={(e) => this.OnDIMMCapacityoptionsChange(e, this.props.type, this.props.title)} />
        </FormField>
        <FormField className="DiskCapacityDetails" label='Data Drive Capacity(TB)' style={{ width: '59%' }}>
          <Select placeHolder='None' value={DATADriveCapacity} options={DATADriveCapacityoptions} onChange={(e) => this.OnDATADriveCapacityoptionsChange(e, this.props.type, this.props.title)} />
        </FormField>
      </Box>
      Wekaoptional = <Box direction='row' pad={{ between: 'small' }} style={{ width: '100%' }}>
        <FormField className="DiskCapacityDetails" label='Data Drive Per Server' style={{ width: '41%' }}>
          <Select placeHolder='None' value={DATADrivePerServer} options={DATADrivePerServeroptions} onChange={(e) => this.OnDATADrivePerServeroptionsChange(e, this.props.type, this.props.title)} />
        </FormField>
        <FormField className="DiskCapacityDetails" label='Spare Servers' style={{ width: '41%' }}>
          <Select placeHolder='None' value={SpareServers} options={SpareServersoptions} onChange={(e) => this.OnSpareServersoptionsChange(e, this.props.type, this.props.title)} />
        </FormField>
        <FormField className="DiskCapacityDetails" label='Number of Servers' style={{ width: '59%' }}>
          <TextInput placeHolder='None' value={NumServers} onDOMChange={(e) => this.OnNumServersChange(e, this.props.type, this.props.title, "Change")} onBlur={(e) => this.OnNumServersChange(e, this.props.type, this.props.title, "Blur")} />
        </FormField>
      </Box>

    } else if (SKUInformationValue === 'Customer Requirements' && DriveClassValue === 'Mixed Use') {
      Wekaoptionalone = <Box direction='row' pad={{ between: 'small' }} style={{ width: '71%' }}>
        <FormField className="DiskCapacityDetails" label='Peak Read IOPS(Millions)' style={{ width: '41%' }}>
          <TextInput placeHolder='None' value={Peakreadiops} onDOMChange={(e) => this.onPeakreadiopsChange(e, this.props.type, this.props.title, "Change")} onBlur={(e) => this.onPeakreadiopsChange(e, this.props.type, this.props.title, "Blur")} />
        </FormField>
        <FormField className="DiskCapacityDetails" label='Peak Read Bandwidth(GB/s)' style={{ width: '59%' }}>
          <TextInput placeHolder='None' value={Peakreadbandwdth} onDOMChange={(e) => this.onPeakreadbandwdthChange(e, this.props.type, this.props.title, "Change")} onBlur={(e) => this.onPeakreadbandwdthChange(e, this.props.type, this.props.title, "Blur")} />
        </FormField>
      </Box>
      Wekaoptional = <Box direction='row' pad={{ between: 'small' }} style={{ width: '100%' }}>
        <FormField className="DiskCapacityDetails" label='Total Usable Storage(Terabytes)' style={{ width: '41%' }}>
          <TextInput placeHolder='None' value={Totalusablestorage} onDOMChange={(e) => this.onTotalusablestorageChange(e, this.props.type, this.props.title, "Change")} onBlur={(e) => this.onTotalusablestorageChange(e, this.props.type, this.props.title, "Blur")} />
        </FormField>
        <FormField className="DiskCapacityDetails" label='Peak write IOPS(Millions)' style={{ width: '41%' }}>
          <TextInput placeHolder='None' value={Peakwriteiops} onDOMChange={(e) => this.onPeakwriteiopsChange(e, this.props.type, this.props.title, "Change")} onBlur={(e) => this.onPeakwriteiopsChange(e, this.props.type, this.props.title, "Blur")} />
        </FormField>
        <FormField className="DiskCapacityDetails" label='Peak Write Bandwidth(GB/s)' style={{ width: '59%' }}>
          <TextInput placeHolder='None' value={Peakwritebandwdth} onDOMChange={(e) => this.onPeakwritebandwdthChange(e, this.props.type, this.props.title, "Change")} onBlur={(e) => this.onPeakwritebandwdthChange(e, this.props.type, this.props.title, "Blur")} />
        </FormField>
      </Box>
    } else if (SKUInformationValue === 'Customer Requirements' && DriveClassValue === 'Read Intensive') {
      Wekaoptionalone = <Box direction='row' pad={{ between: 'small' }} style={{ width: '71%' }}>
        <FormField className="DiskCapacityDetails" label='Peak Read IOPS(Millions)' style={{ width: '41%' }}>
          <TextInput placeHolder='None' value={Peakreadiops} onDOMChange={(e) => this.onPeakreadiopsChange(e, this.props.type, this.props.title, "Change")} onBlur={(e) => this.onPeakreadiopsChange(e, this.props.type, this.props.title, "Blur")} />
        </FormField>
        <FormField className="DiskCapacityDetails" label='Peak Read Bandwidth(GB/s)' style={{ width: '59%' }}>
          <TextInput placeHolder='None' value={Peakreadbandwdth} onDOMChange={(e) => this.onPeakreadbandwdthChange(e, this.props.type, this.props.title, "Change")} onBlur={(e) => this.onPeakreadbandwdthChange(e, this.props.type, this.props.title, "Blur")} />
        </FormField>
      </Box>
      Wekaoptional = <Box direction='row' pad={{ between: 'small' }} style={{ width: '100%' }}>
        <FormField className="DiskCapacityDetails" label='Total Usable Storage(Terabytes)' style={{ width: '29%' }}>
          <TextInput placeHolder='None' value={Totalusablestorage} onDOMChange={(e) => this.onTotalusablestorageChange(e, this.props.type, this.props.title, "Change")} onBlur={(e) => this.onTotalusablestorageChange(e, this.props.type, this.props.title, "Blur")} />
        </FormField>
      </Box>
    }
    let Sizerrecomd = ''
    /*Changes by Vinay, changed the postion of comparision operations, for CID:10197 */
    if (this.props.defaultSizerWorkload.serversList !== "" && this.props.defaultSizerWorkload.serversList !== undefined && this.props.defaultSizerWorkload.serversList.length !== 0 && this.props.defaultSizerWorkload.serversList !== null) {
      this.props.defaultSizerWorkload.serversList.map((ServiceName) => {
        if (ServiceName.serviceName === this.props.title && ServiceName.Servers !== '') {
          for (let key in ServiceName.totalList) {
            if (key === serverValue) {
              MemoryList = [];
              let supportedDriveslist = []
              if( Array.isArray(this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service)) {
                this.state.dataDriveType = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.filter(x=>x["@Type"] === this.props.title)[0].Hardware["@dataDriveType"] ;
              } else {
                this.state.dataDriveType = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.Hardware["@dataDriveType"];
              }
              if (this.state.dataDriveConsolidatedOptions.length == 0 && this.state.dataDriveType === "") {
                ServiceName.totalList[key].DataDiskList.map(x => {
                    supportedDriveslist.push(x.StrDrive)
                  x.Types.map(y => {
                    if (this.state.dataDriveConsolidatedOptions.indexOf(y) === -1) {
                      this.state.dataDriveConsolidatedOptions.push(y)
                    }
                  })
                })
                  if( Array.isArray(this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service)) {
                    this.state.dataDriveType = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.filter(x=>x["@Type"] === this.props.title)[0].Hardware["@dataDriveType"] 
                    if ( this.state.dataDriveType === "") {
                      this.state.dataDriveType = this.state.dataDriveConsolidatedOptions[0];
                      this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.filter(x=>x["@Type"] === this.props.title)[0].Hardware["@dataDriveType"]  = this.state.dataDriveType
                    }
                  } else {
                    this.state.dataDriveType = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.Hardware["@dataDriveType"] 
                    if ( this.state.dataDriveType === "") {
                      this.state.dataDriveType = this.state.dataDriveConsolidatedOptions[0];
                      this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.Hardware["@dataDriveType"]  = this.state.dataDriveType
                    }
                  }
                
              }
              if (supportedDriveslist.length > 0 && supportedDriveslist.indexOf(datadisktypValue) === -1) {
                datadisktypValue = supportedDriveslist[0]
                if( Array.isArray(this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service)) {
                  this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.filter(x=>x["@Type"] === this.props.title)[0].Hardware['@DataDisk'] = datadisktypValue
                } else {
                  this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === this.props.type)[0].Service.Hardware['@DataDisk'] = datadisktypValue
                }
              }
              //Drives = this.populateDataDriveoptions(ServiceName.totalList[key].DataDiskList)

              this.populateDataDriveoptions()                
              var tempDrives=[];
              Drives.map(drive =>{
                if(drive.indexOf("#MS") > -1 && drive.indexOf(datadisktypValue) > -1 && recommDrive){
                  let index = drive.indexOf('#');
                  datadisktypValue = drive.slice(0,index).trim();
                  recommDrive= false;
                }
                var driveIndex = drive.indexOf("#");
                if(drive.indexOf("#") > -1){
                  tempDrives.push(drive.slice(0,driveIndex).trim());
                }
              });
              Drives = tempDrives;
              if (Drives.indexOf(datadisktypValue) === -1 && this.props.title !== "Weka") {
                datadisktypValue = Drives[0]
                this.textOnConfigurationChange(this.props.title, "DataDisk", datadisktypValue);
              }
              if (this.props.type !== "Func") {//before wrote for IOT
                for (let proctype in ServiceName.totalList[key].ProcessorList) {
                  if (ProcFamilyList.indexOf(proctype) === -1) {
                    ProcFamilyList.push(proctype);
                  }
                  if (proctype === processorTypeValue) {
                    for (let proc in ServiceName.totalList[key].ProcessorList[proctype]) {
                      if(recommProc && (proc.indexOf("#MS") > -1 || proc.indexOf("#null") > -1)){
                        let index = proc.indexOf('#');
                        processorValue ? '' : processorValue = proc.slice(0,index).trim();
                        recommProc = false;
                      }
                      
                      var orignalValue = proc ;
                      if(proc.indexOf(processorValue) > -1){
                        orignalValue = proc;
                      }
                      let index = proc.indexOf('#');
                      proc = proc.slice(0,index).trim();
                      
                      if (ProcList.indexOf(proc) === -1) {
                        ProcList.push(proc);
                      }
                    MemoryList = ServiceName.totalList[key].ProcessorList[proctype][orignalValue];
                    let memIndex;
                    let tempMemArr = [];
                    if(MemoryList){
                    MemoryList.map(mem =>{
                      if(!memoryValue && mem.indexOf("#MS") > -1){
                        let index = mem.indexOf('#');
                        memoryValue = mem.slice(0,index).trim();
                      }
                      memIndex = mem.indexOf("#");
                      if(mem.indexOf("#") > -1){
                        tempMemArr.push(mem.slice(0,memIndex).trim());
                      }
                    });
                    MemoryList = tempMemArr ;
                  }

                      // if (proc === processorValue) {
                      //   MemoryList = ServiceName.totalList[key].ProcessorList[proctype][proc]
                      //   if(MemoryList.indexOf(memoryValue) === -1){
                      //     memoryValue=MemoryList[0]
                      //   }
                      // }
                    }
                    if (ProcList.indexOf(processorValue) === -1) {
                      this.textOnConfigurationChange(this.props.title, "Processor", processorValue);
                      processorValue = ProcList[0]
                    }
                    //if (proc === processorValue) {
                    
                    if (MemoryList.indexOf(memoryValue) === -1) {
                      this.textOnConfigurationChange(this.props.title, "Memory", memoryValue);
                      memoryValue = MemoryList[0]
                    }
                    //}
                  }
                }
              }
              else {
                for (let proc in ServiceName.totalList[key].ProcessorList[processorTypeValue]) {
                  if (ProcList.indexOf(proc) === -1) {
                    ProcList.push(proc);
                  }
                  if (proc === processorValue) {
                    MemoryList = ServiceName.totalList[key].ProcessorList[processorTypeValue][proc]
                  }
                }
              }

              if (ServiceName.totalList[key].OSDiskList.length !== 0) {
                OSDiskList = ServiceName.totalList[key].OSDiskList

                this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
                  if (val['@Type'] === this.props.type) {
                    if (Array.isArray(val.Service)) {
                      val.Service.filter((service) => {
                        if (service['@Type'] === this.props.title) {
                          if (service['@Selected'] === "true") {
                            osdisktypValue = service.Hardware['@OSDisk'];
                          }
                        }
                      })
                    }
                  }
                })
                var tempOsDisk=[];
                OSDiskList = ServiceName.totalList[key].OSDiskList
                var osIndex;
                //osdisktypValue ='';
                OSDiskList.map( osDisk =>{
                  if(osDisk.indexOf("#MS") > -1 && recommOSDisk){
                    let index = osDisk.indexOf('#');
                    osdisktypValue = osDisk.slice(0,index).trim();
                    recommOSDisk = false;
                  }
                  osIndex = osDisk.indexOf("#");
                  tempOsDisk.push(osDisk.slice(0,osIndex).trim());
                });
                OSDiskList = tempOsDisk;
                if (OSDiskList.indexOf(osdisktypValue) === -1) {
                  this.textOnConfigurationChange(this.props.title, "OSDisk", osdisktypValue);
                  osdisktypValue = OSDiskList[0]
                }
              }
              if (serverValue === "Synergy 480 Gen10 Server" && processorValue.indexOf("M") !== 4 && processorValue.indexOf("L") !== 4 && MemoryList.indexOf("3072 GB") !== -1) {
                MemoryList.pop();
              }
            }
            this.pushToServersList(key);
          }
        }
      })
      if (Deleteservers) {
        Servers = [];
        Sizerrecomd = ""
      }
      else {
        Sizerrecomd = <Box>
          <Paragraph className='DesignrequirementsPara' style={{ margin: "0px", padding: "10px", fontWeight: '600', paddingBottom: '2px' }}>Sizer Recommendation:</Paragraph>
          <Paragraph className='DesignrequirementsPara' style={{ margin: "0px", paddingLeft: "20px", fontWeight: '600', paddingTop: '0px' }}>{SizerRecmdtnServer} / {SizerRecmdtnProcsr} / {SizerRecmdtnMemory} / {SizerRecmdtnDisktype} / {defaultNodevalue}-Nodes</Paragraph>
        </Box>
      }
     
      this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
        if (val['@Type'] === this.props.type) {
          if (Array.isArray(val.Service)) {
            val.Service.filter((service) => {
              if (service['@Type'] === this.props.title) {
                //service['@Selected']=this.props.isSelected;
                if (service['@Selected'] === "true") {
                  service.Hardware['@Proc'] = processorValue;
                  service.Hardware['@Memory'] = memoryValue;
                  service.Hardware['@DataDisk'] = datadisktypValue;
                  service.Hardware['@OSDisk'] = osdisktypValue;
                }
                
            
              }
            })
          } else {
            if (val.Service['@Type'] === this.props.title) {
              if (val.Service['@Selected'] === "true") {
                val.Service.Hardware['@Proc'] = processorValue;
                val.Service.Hardware['@Memory'] = memoryValue;
                val.Service.Hardware['@DataDisk'] = datadisktypValue;
                val.Service.Hardware['@OSDisk'] = osdisktypValue;
              }
            }
          }
        }
      })
    } else {
      var dup = []
      dup = this.props.DuplicateOSlist
      OSDiskList = dup
    }
    if (OSDiskList.length == 0) {
      OSDiskList = this.props.DuplicateOSlist
    }

    if (OSDiskList !== undefined && OSDiskList.length !== 0) {
      this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
        if (val['@Type'] === this.props.type) {
          if (Array.isArray(val.Service)) {
            val.Service.filter((service) => {
              if (service['@Type'] === this.props.title) {

                if (service['@Selected'] === "true") {

                  //OSDisks Selection
                  if (OSDiskList.indexOf(service.Hardware['@OSDisk']) === -1) {
                    this.textOnConfigurationChange(this.props.title, "OSDisk", service.Hardware['@OSDisk'])
                    service.Hardware['@OSDisk'] = OSDiskList[0];
                  }
                  osdisktypValue = service.Hardware['@OSDisk'];
                }
                else {
                  osdisktypValue = ""
                  OSDiskList = []
                }
              }
            })
          }
          else {
            if (val.Service['@Type'] === this.props.title) {
              // val.Service['@Selected']=this.props.isSelected;
              if (val.Service['@Selected'] === "true") {
                if (OSDiskList.indexOf(val.Service.Hardware['@OSDisk']) === -1) {
                  val.Service.Hardware['@OSDisk'] = OSDiskList[0];
                }
                osdisktypValue = val.Service.Hardware['@OSDisk'];
              }
              else {
                osdisktypValue = ""
                OSDiskList = []
              }
            }
          }
        }
      })
    }

    var Loadingdata = ''
    if (this.props.isLoading) {
      let Data = "Please wait while fetching os disks."
      // if(firstTime=true)
      // {
      //    firstTime=false
      //      Data=" Please wait while Initializing."
      // }else{
      //    Data=" Please wait while Calculating the Node Count."
      // }

      Loadingdata = <Layer style={{ zIndex: '500 !important' }}>
        <Box direction='row' style={{ padding: '40px', backgroundColor: "#425563" }} size='medium' pad={{ 'between': 'small' }}>
          <Spinning size='small' style={{ color: "#fff" }} />
          <Heading tag='h5' margin='none' style={{ color: "#fff" }}>{Data}</Heading>
        </Box>
      </Layer>
    }

    if (this.props.isLoadingServers) {
      Loadingdata = <Layer style={{ zIndex: '500 !important' }}>
        <Box direction='row' style={{ padding: '40px', backgroundColor: "#425563" }} size='medium' pad={{ 'between': 'small' }}>
          <Spinning size='small' style={{ color: "#fff" }} />
          <Heading tag='h5' margin='none' style={{ color: "#fff" }}>{"Please wait while fetching Default values."}</Heading>
        </Box>
      </Layer>
    }
    var Content = "";
    if (nodeValue === "User Defined") {
      this.state.NodeQtyvisible = false;
    } else {
      this.state.NodeQtyvisible = true;
    }
    // if((DataDiskChanged || ProcessorChanged) && !this.props.isLoadingServers &&  !this.props.isLoading){
    //    if (this.props.title === "HDFS" || this.props.title === "Hive" || this.props.title === "Spark Streaming" || this.props.title === "Yarn" || this.props.title === "Tensorflow" || this.props.title === "MiNifi") {
    //      ServerChangeNote2=""
    //      ServerChangeNote3=""
    //      ServerChangeNote4=""
    //       ServerChangeNote1=<Layer style={{ zIndex: '500 !important' }}>
    //           <Box direction="row" margin="none" separator="bottom" style={{ padding: "none", backgroundColor: "#425563" }} >
    //             <Box direction="row" margin="none" pad="none" align='start' style={{ width: '96%', padding: "10px", color: "#fff" }}>
    //               <Heading tag="h4" strong={true} style={{ marginBottom: '0px' }}>Alert</Heading>
    //             </Box>
    //             <Box direction="row" style={{ marginTop: "10px", padding: "5px" }} margin="none" pad="none" align='start' alignContent="start" onClick={this.onServerChangeLayerClose.bind(this)} >
    //               <CloseIcon size='small' colorIndex="light-2" style={{ stroke: 'white' }} />
    //             </Box>
    //           </Box>
    //           <Box style={{ padding: "10px" }}>
    //             <Paragraph>Note:</Paragraph>
    //           </Box>
    //         </Layer>
    //       }else if (this.props.title === "Scality" || this.props.title === "Cassandra" || this.props.title === "Kafka" || this.props.title === "Spark" || this.props.title === "PyTorch") {
    //         ServerChangeNote1=""
    //      ServerChangeNote3=""
    //      ServerChangeNote4=""
    //            ServerChangeNote2=<Layer style={{ zIndex: '500 !important' }}>
    //           <Box direction="row" margin="none" separator="bottom" style={{ padding: "none", backgroundColor: "#425563" }} >
    //             <Box direction="row" margin="none" pad="none" align='start' style={{ width: '96%', padding: "10px", color: "#fff" }}>
    //               <Heading tag="h4" strong={true} style={{ marginBottom: '0px' }}>Alert</Heading>
    //             </Box>
    //             <Box direction="row" style={{ marginTop: "10px", padding: "5px" }} margin="none" pad="none" align='start' alignContent="start" onClick={this.onServerChangeLayerClose.bind(this)} >
    //               <CloseIcon size='small' colorIndex="light-2" style={{ stroke: 'white' }} />
    //             </Box>
    //           </Box>
    //           <Box style={{ padding: "10px" }}>
    //             <Paragraph>Note:</Paragraph>
    //           </Box>
    //         </Layer>
    //       }
    //       else if (this.props.title === "Impala" || this.props.title === "Flink"){
    //          ServerChangeNote1=""
    //      ServerChangeNote2=""
    //      ServerChangeNote4=""
    //            ServerChangeNote3=<Layer style={{ zIndex: '500 !important' }}>
    //           <Box direction="row" margin="none" separator="bottom" style={{ padding: "none", backgroundColor: "#425563" }} >
    //             <Box direction="row" margin="none" pad="none" align='start' style={{ width: '96%', padding: "10px", color: "#fff" }}>
    //               <Heading tag="h4" strong={true} style={{ marginBottom: '0px' }}>Alert</Heading>
    //             </Box>
    //             <Box direction="row" style={{ marginTop: "10px", padding: "5px" }} margin="none" pad="none" align='start' alignContent="start" onClick={this.onServerChangeLayerClose.bind(this)} >
    //               <CloseIcon size='small' colorIndex="light-2" style={{ stroke: 'white' }} />
    //             </Box>
    //           </Box>
    //           <Box style={{ padding: "10px" }}>
    //             <Paragraph>Note:</Paragraph>
    //           </Box>
    //         </Layer>
    //       }else if (this.props.title === "HBase" || this.props.title === "Storm"){
    //         ServerChangeNote1=""
    //      ServerChangeNote2=""
    //      ServerChangeNote3=""
    //            ServerChangeNote4=<Layer style={{ zIndex: '500 !important' }}>
    //           <Box direction="row" margin="none" separator="bottom" style={{ padding: "none", backgroundColor: "#425563" }} >
    //             <Box direction="row" margin="none" pad="none" align='start' style={{ width: '96%', padding: "10px", color: "#fff" }}>
    //               <Heading tag="h4" strong={true} style={{ marginBottom: '0px' }}>Alert</Heading>
    //             </Box>
    //             <Box direction="row" style={{ marginTop: "10px", padding: "5px" }} margin="none" pad="none" align='start' alignContent="start" onClick={this.onServerChangeLayerClose.bind(this)} >
    //               <CloseIcon size='small' colorIndex="light-2" style={{ stroke: 'white' }} />
    //             </Box>
    //           </Box>
    //           <Box style={{ padding: "10px" }}>
    //             <Paragraph>Note:</Paragraph>
    //           </Box>
    //         </Layer>
    //       }
    //         }

    if (this.props.title !== "Weka") {
      var exceptIOT = ''
      var Iotwidth = "45%"
      if(processorTypeValue !== NA_) {
        Iotwidth = "30%"
        exceptIOT = <FormField className="DiskCapacityDetails" label='Processor Family' error={this.state.DiskCapacityerror} style={{ width: '20%', minWidth: '147px' }}>
          <Select placeHolder='None' options={ProcFamilyList} value={processorTypeValue} onChange={(e) => this.onProcessorFamilyChange(e, this.props.type, this.props.title)} />
        </FormField>
      }
     
      Content =
        <Box pad='none' margin='none'>
          <ReactTooltip place="right" multiline={true} />
          {StorageSelection}
          {layer}
          {layerSecondService}
          {layerThirdService}
          {layerFourthService}
          <Box margin="none" justify='between' >
            <Box style={{ overflow: 'auto' }} >
              <Heading tag='h5' strong={true} margin='none'>Hardware Selection</Heading>
              <Box style={{ padding: "10px", overflow: 'auto', width: '95%' }} pad={{ between: 'small' }} >
                <Box direction='row' pad={{ between: 'small' }}>
                  <FormField className="DiskCapacityDetails" label='Server' error={this.state.DiskCapacityerror} style={{ width: Iotwidth, minWidth: '200px' }} >
                    <Select placeHolder='None' options={Servers} value={serverValue} onChange={(e) => this.onServerChange(e, this.props.type, this.props.title)} />
                  </FormField>
                  {exceptIOT}
                  <FormField className="DiskCapacityDetails" label='Processor' error={this.state.DiskCapacityerror} style={{ width: '25%', minWidth: '127px' }}>
                    <Select placeHolder='None' options={ProcList} value={processorValue} onChange={(e) => this.onProcessorChange(e, this.props.type, this.props.title)} />
                  </FormField>
                  <FormField className="DiskCapacityDetails" label='Proc Qty' style={{ width: '12%', minWidth: '110px' }}>
                    <Select placeHolder='None' options={procQuantity} value={pocQtyValue} onChange={(e) => this.onProcQtyChange(e, this.props.type, this.props.title)} />
                  </FormField>
                  <FormField className="DiskCapacityDetails" label='Memory' style={{ width: '13%', minWidth: '141px' }}>
                    <Select placeHolder='None' options={MemoryList} value={memoryValue} onChange={(e) => this.onMemoryChange(e, this.props.type, this.props.title)} />
                  </FormField>
                </Box>
                
              <DataDrive Drives={Drives} dataDiskValue={datadisktypValue} type={this.props.type} title={this.props.title} onDataDiskChange={this.onDataDiskChange} noOfDisksValue={noOfDiskValue} onNoOfDisksChange={this.onNoOfDisksChange} dataDriveType={this.state.dataDriveType} onDatadriveTypeChange={this.onDatadriveTypeChange} renderTable={this.renderTable} onAddingDataDisk={this.onAddingDataDisk} dataDriveConsolidatedOptions={this.state.dataDriveConsolidatedOptions} isMixedStorage={isMixedStorageConfiguration} enableADDButton={this.state.enableADDButton} workloadType={Constants.BIG_DATA} />
              <Box direction='row' pad={{ between: 'small' }}>
              <FormField className="DiskCapacityDetails" label='OS Disk' error={this.state.DiskCapacityerror} >
                    <Select placeHolder='None' options={OSDiskList} value={osdisktypValue} onChange={(e) => this.onOSDiskChange(e, this.props.type, this.props.title)} />
                  </FormField>
                  <FormField className="DiskCapacityDetails" label='No. of OS Disks'>
                    <TextInput placeHolder='None' value={noOfOSDiskValue} onDOMChange={(e) => this.onNoOfOSDisksChange(e, this.props.type, this.props.title, "Change")} onBlur={(e) => this.onNoOfOSDisksChange(e, this.props.type, this.props.title, "Blur")} />
                  </FormField>
                </Box>
              </Box>
            </Box>
          </Box>
          <Box>
            <Box direction="row" pad={{ between: 'small' }} style={{ width: '70%', paddingLeft: "9px" }} >
              <FormField className="DiskCapacityDetails" label='Nodes Quantity' style={{ width: '44%' }} >
                <Select className="NodeSelect" placeHolder='None' options={NodesQtyOptions} value={nodeValue} onChange={(e) => this.NodeQtycahnge(e, this.props.type, this.props.title)} />
              </FormField>
              <Box direction="row" alignContent='center' align='center'>
                <TextInput id='UserDefined' hidden={this.state.NodeQtyvisible} value={nodesQtyValue} onBlur={(e) => this.onNodevalueBlur(e, this.props.type, this.props.title)} style={{ width: '44%' }} onDOMChange={(e) => this.onNodevalueChange(e, this.props.type, this.props.title)} />
                <Paragraph className='DesignrequirementsPara' hidden={this.state.NodeQtyvisible} style={{ marginLeft: "10px", fontWeight: '600' }}>{"Minimun Nodes required:" + defaultNodevalue}</Paragraph>
              </Box>
            </Box>
            { /*{noteTextOnChangeOfConfiguration}*/}
            {this.props.title === Constants.DATA_LAKE ? noteTextOnChangeOfConfiguration : ""}
            {this.props.title === "Scality" ? noteTextOnChangeOfConfigurationScality : ""}
            {this.props.title === "PyTorch" ? noteTextOnChangeOfConfigurationPyTorch : ""}
            {this.props.title === "Weka" ? noteTextOnChangeOfConfigurationWeka : ""}
            {this.props.title === "Hive" ? noteTextOnChangeOfConfigurationHive : ""}
            {this.props.title === "Cassandra" ? noteTextOnChangeOfConfigurationCassandra : ""}
            {this.props.title === "Impala" ? noteTextOnChangeOfConfigurationImpala : ""}
            {this.props.title === "HBase" ? noteTextOnChangeOfConfigurationHBase : ""}
            {this.props.title === "Spark Streaming" ? noteTextOnChangeOfConfigurationSparkStreaming : ""}
            {this.props.title === "Kafka" ? noteTextOnChangeOfConfigurationKafka : ""}
            {this.props.title === "Flink" ? noteTextOnChangeOfConfigurationFlink : ""}
            {this.props.title === "Storm" ? noteTextOnChangeOfConfigurationStorm : ""}
            {this.props.title === "Yarn" ? noteTextOnChangeOfConfigurationYarn : ""}
            {this.props.title === "Spark" ? noteTextOnChangeOfConfigurationSpark : ""}
            {this.props.title === "Tensorflow" ? noteTextOnChangeOfConfigurationTensorflow : ""}
            {this.props.title === "MiNifi" ? noteTextOnChangeOfConfigurationMiNifi : ""}

            { /*{noteTextOnChangeOfConfigurationScality}*/}
            {Sizerrecomd}
          </Box>
        </Box>
    } else {
      let weakinfo = ""
      //ServerType=Servers
      if (this.state.SKUInformationValue === "Predefined Configuration") {
        weakinfo = "Sizing using selected hardware configuration and server count."
      } else {
        weakinfo = "Recommend using total usable storage (TB), read/write IOPs (millions) and read/write bandwidth (GB/s)."
      }
      Content =
        <Box pad='none' margin='none'>
          <ReactTooltip place="right" multiline={true} />
          <Box margin="none" justify='between'>
            <Box style={{ overflow: 'auto' }} >
              {layer}
              {layerSecondService}
              <Box style={{ padding: "10px", overflow: 'auto', width: '100%' }} pad={{ between: 'small' }} >
                <Box direction='row' style={{ width: '100%' }} pad={{ between: 'small' }}>
                  <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Do you expect to add servers to this deployment?</Paragraph>
                    <CircleInformation data-tip={Constants.Add_servers_to_this_deployment} colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>} error={this.state.DiskCapacityerror}>
                    <Select placeHolder='None' options={Addserversoptions} value={Addservers} onChange={(e) => this.onDeploymentChange(e, this.props.type, this.props.title)} />
                  </FormField>
                  <FormField className="DiskCapacityDetails" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Select how you will specify BOM and SKU information</Paragraph>
                    <CircleInformation data-tip={Constants.BOM_and_SKU_information} colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>} error={this.state.DiskCapacityerror} >
                    <Select placeHolder='None' options={SKUInformationList} value={SKUInformationValue} onChange={(e) => this.onSKUInformationChange(e, this.props.type, this.props.title)} />
                  </FormField>
                </Box>
                <Box direction='row' style={{ width: '100%' }} pad={{ between: 'small' }}>
                  <FormField className="DiskCapacityDetails" label='OS Environment' style={{ width: '35%' }} >
                    <Select placeHolder='None' value={OSEnvironment} options={OSEnvironmentoptions} onChange={(e) => this.onOSEnvironmentChange(e, this.props.type, this.props.title)} />
                  </FormField>
                  <FormField className="DiskCapacityDetails" label='Support Year Count' style={{ width: '35%' }}  >
                    <Select placeHolder='None' value={SupportYearCount} options={SupportYearCountoptions} onChange={(e) => this.onSupportYearCountChange(e, this.props.type, this.props.title)} />
                  </FormField>
                  <FormField className="DiskCapacityDetails" label='Is this an Education or Government Customer' style={{ width: '50%' }} >
                    <Select placeHolder='None' value={EducationCustomer} options={EducationCustomeroptions} onChange={(e) => this.onEducationCustomerChange(e, this.props.type, this.props.title)} />
                  </FormField>
                </Box>
                <Box direction="row" style={{ width: '100%' }} pad={{ between: 'small' }}>
                  <FormField className="DiskCapacityDetails" label='Network Type' style={{ width: '35%' }}>
                    <Select placeHolder='None' value={NetworkType} options={NetworkTypeoptions} onChange={(e) => this.onNetworkTypeChange(e, this.props.type, this.props.title)} />
                  </FormField>
                  <FormField className="DiskCapacityDetails" label='Tiering capacity required' style={{ width: '35%' }}>
                    <Box direction='row'>
                      <TextInput placeHolder='None' style={{ paddingLeft: '25px' }} value={capacityrequired} onDOMChange={(e) => this.oncapacityrequiredChange(e, this.props.type, this.props.title, "Change")} onBlur={(e) => this.oncapacityrequiredChange(e, this.props.type, this.props.title, "onBlur")} />
                      <CircleInformation data-tip="Additional Weka tiering capacity license needed in addition to usable capacity." colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} />
                    </Box>
                  </FormField>
                  <FormField className="DiskCapacityDetails" label='Server Type' style={{ width: '50%' }}>
                    <Select placeHolder='None' value={ServerType} options={Servers} onChange={(e) => this.onServerTypeChange(e, this.props.type, this.props.title)} />
                  </FormField>
                </Box>
                <Box direction="row" pad={{ between: 'small' }}  >
                  <FormField className="DiskCapacityDetails" label='Drive Class ' style={{ width: '29%' }}>
                    <Select placeHolder='None' options={DriveClassList} value={DriveClassValue} onChange={(e) => this.onDriveClassChange(e, this.props.type, this.props.title, )} />
                  </FormField>
                  {Wekaoptionalone}
                </Box>
                <Box direction="row" pad={{ between: 'small' }} >
                  {Wekaoptional}
                </Box>
              </Box>
            </Box>
          </Box>
          <Box>

            <Box>
            </Box>
            {Sizerrecomd}
          </Box>
        </Box>
    }
    let Synergyflag = false
    this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
      if (val['@Type'] !== "Master Node" && val['@Type'] !== "Gateway Node") {
        if (Array.isArray(val.Service)) {
          val.Service.filter((service) => {
            // if (service['@Type'] === this.props.title) {
            if (service['@Selected'] === "true" && service.Hardware['@Server'].indexOf("Synergy") !== -1) {
              Synergyflag = true
            }
            //  }
          })
        }
        else {

        }
      }
    })
    if (!Synergyflag && SynergyServerChanged) {
      SynergyServerChanged = false
      this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
        if (val['@Type'] === "Master Node") {
          val.Service.Hardware['@DataDisk'] = "HPE 900GB 12G SAS 15K 2.5in SC DS HDD";
          val.Service.Hardware['@DiskQty'] = "8";
          val.Service.Hardware['@Memory'] = "128 GB";
          val.Service.Hardware['@NodesCount'] = "3";
          val.Service.Hardware['@NodesQty'] = "Sizer Recommendation";
          val.Service.Hardware['@OSDisk'] = "HPE 480GB SATA MU 2.5in SC 2.5in DS SSD";
          val.Service.Hardware['@OSDiskQty'] = "2";
          val.Service.Hardware['@Proc'] = "4210 / 2.2 GHz / 10 Cores / 55 SpecInt";
          val.Service.Hardware['@ProcFamily'] = "Cascade Lake";
          val.Service.Hardware['@ProcQty'] = "2";
          val.Service.Hardware['@Server'] = "ProLiant DL360 Gen10";
        }
        else if (val['@Type'] === "Gateway Node") {
          val.Service.Hardware['@DataDisk'] = "HPE 900GB 12G SAS 15K 2.5in SC DS HDD";
          val.Service.Hardware['@DiskQty'] = "1";
          val.Service.Hardware['@Memory'] = "128 GB";
          val.Service.Hardware['@NodesCount'] = "1 Per Rack";
          val.Service.Hardware['@NodesQty'] = "Sizer Recommendation";
          val.Service.Hardware['@OSDisk'] = "HPE 480GB SATA MU 2.5in SC 2.5in DS SSD";
          val.Service.Hardware['@OSDiskQty'] = "2";
          val.Service.Hardware['@Proc'] = "4210 / 2.2 GHz / 10 Cores / 55 SpecInt";
          val.Service.Hardware['@ProcFamily'] = "Cascade Lake";
          val.Service.Hardware['@ProcQty'] = "2";
          val.Service.Hardware['@Server'] = "ProLiant DL360 Gen10";
        }
        else {

        }
      })
    }
    return (

      <Box pad='none' margin='none' style={{ position: 'relative', width: '97%' }} >
        <ReactTooltip place="right" multiline={true} />
        {serverChangeConfirmationlayer}
        {Content}
        {Loadingdata}
      </Box>

    )
  }
}
const mapStateToProps = (state) => {
  return {

    // isLoading:state.sizerWorkload.isLoading,
    // Functions:state.sizerWorkload.serversList.workload.WorkLoad.UserInputs.Environments.Functions,
    workload: state.sizerWorkload.workload,
    isLoading: state.sizerWorkload.isLoading,
    isLoadingServers: state.sizerWorkload.isLoadingServers,
    //:state.sizerWorkload.workload.Workload.UserInputs.Environments.Functions,
    defaultSizerWorkload: state.sizerWorkload,
    sessions: state.sessions.sessionDefaults,
    activeSession: state.sessions.activeSession,
    EPAInputs: state.sessions.sessionDefaults.inputs,
    DuplicateOSlist: state.sizerWorkload.duplicateOSlist,
    StringMessage: state.sizerWorkload.workload.UserInputs.Environments.strmessage,
    // StringMessage:state.sessions.activeSession.strmessage,
    //SelectedService:state.sizerWorkload.title,
    //SelectedService:state.sessions.activeSession.title,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    OnFetchNodeQty: (value) => {
      dispatch(fetchNodeQty(value));
    },
    OnGetARCValue: (value) => {
      dispatch(getARCValue(value));
    },
    OnGetOSDiskList: (value) => {
      dispatch(getosdisklist(value));
    },
    updateError: (errorMsg) => {
      dispatch(errorValidataion(errorMsg));
    },
    OnFetchServerList: (value) => {
      dispatch(fetchServerList(value));
    },
    OnToggleSizeButton: (value) => { dispatch(toggleSizeButton(value)) },
    RecallAnalyticsandDatabaseNodeQty: (value) => { dispatch(recallAnalyticsandDatabasenodeQty(value)) }

  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Serverconfig);



// WEBPACK FOOTER //
// ./src/SizerUI/SizerScreens/Serverconfig.js